import*as React__default from'react';import React__default__default,{createRef,forwardRef}from'react';import {IconButton as IconButton$3,Avatar as Avatar$1,Card as Card$1,Typography,Icon,CardContent as CardContent$1,CardActions as CardActions$1,Divider as Divider$1,FormControl as FormControl$1,InputLabel as InputLabel$1,Select as Select$1,Switch as Switch$1,StylesProvider as StylesProvider$1,Tab as Tab$1,TabScrollButton as TabScrollButton$1,Tabs as Tabs$1,Stepper,StepContent as StepContent$1}from'@material-ui/core';import {setYear,setMonth,setDate,getDate,getMonth,getYear,formatISO,subMonths,format,addMonths,getWeeksInMonth,setDay,addWeeks,isSameMonth,isEqual,addYears,getWeekOfMonth,getDay,subWeeks,subYears,endOfWeek,startOfWeek,addDays,subDays}from'date-fns';import {TabContext as TabContext$1,TabList as TabList$1,TabPanel as TabPanel$1}from'@material-ui/lab';var __assign$2$3 = function() {
    __assign$2$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2$3.apply(this, arguments);
};

function __rest$2$3(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function styleInject$4$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$5$3 = ".denhaag-button{align-items:center;background-color:var(--denhaag-button-primary-action-background-color);border:0;border-radius:var(--denhaag-button-border-radius);color:var(--denhaag-button-primary-action-color);cursor:var(--denhaag-button-cursor,default);display:inline-flex;font-family:var(--denhaag-button-font-family);font-size:var(--denhaag-typography-scale-base-font-size);line-height:1.75;padding-block-end:var(--denhaag-button-medium-size-padding-block,var(--denhaag-button-padding-block));padding-block-start:var(--denhaag-button-medium-size-padding-block,var(--denhaag-button-padding-block));padding-inline-end:var(--denhaag-button-medium-size-padding-inline,var(--denhaag-button-padding-inline));padding-inline-start:var(--denhaag-button-medium-size-padding-inline,var(--denhaag-button-padding-inline));position:relative;text-decoration:none}a.denhaag-button{--denhaag-button-cursor:pointer}.denhaag-button--focus-visible:after,.denhaag-button--focus:after,.denhaag-button:focus-visible:after,.denhaag-button:focus:after{border:var(--denhaag-focus-border);border-radius:var(--denhaag-border-radius);bottom:-2px;content:\"\";display:block;left:-2px;position:absolute;right:-2px;top:-2px}.denhaag-button--focus-visible,.denhaag-button:focus-visible{outline:none}.denhaag-button--secondary-action.denhaag-button--focus:after,.denhaag-button--secondary-action:focus:after{bottom:-3px;left:-3px;right:-3px;top:-3px}.denhaag-button.denhaag-button--hover,.denhaag-button:hover{background-color:var(--denhaag-button-primary-action-hover-background-color);color:var(--denhaag-button-primary-action-hover-color)}.denhaag-button.denhaag-button--disabled,.denhaag-button.denhaag-button:disabled{background-color:var(--denhaag-button-primary-action-disabled-background-color);color:var(--denhaag-button-primary-action-disabled-color)}.denhaag-button--secondary-action{background-color:var(--denhaag-button-secondary-action-background-color);border-color:var(--denhaag-button-secondary-action-border-color);border-style:solid;border-width:var(--denhaag-button-border-width);color:var(--denhaag-button-secondary-action-color);padding-block-end:calc(var(--denhaag-button-medium-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-block-start:calc(var(--denhaag-button-medium-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-inline-end:calc(var(--denhaag-button-medium-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width));padding-inline-start:calc(var(--denhaag-button-medium-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width))}.denhaag-button--secondary-action.denhaag-button--hover,.denhaag-button--secondary-action:hover{background-color:var(--denhaag-button-secondary-action-hover-background-color);border-color:var(--denhaag-button-secondary-action-hover-border-color);color:var(--denhaag-button-secondary-action-hover-color)}.denhaag-button--secondary-action.denhaag-button--disabled,.denhaag-button--secondary-action.denhaag-button:disabled{background-color:var(--denhaag-button-secondary-action-disabled-background-color);border-color:var(--denhaag-button-secondary-action-disabled-border-color);color:var(--denhaag-button-secondary-action-disabled-color)}.denhaag-button--large{font-size:var(--denhaag-typography-scale-lg-font-size);padding-block-end:var(--denhaag-button-large-size-padding-block,var(--denhaag-button-padding-block));padding-block-start:var(--denhaag-button-large-size-padding-block,var(--denhaag-button-padding-block));padding-inline-end:var(--denhaag-button-large-size-padding-inline,var(--denhaag-button-padding-inline));padding-inline-start:var(--denhaag-button-large-size-padding-inline,var(--denhaag-button-padding-inline))}.denhaag-button--large.denhaag-button--secondary-action{padding-block-end:calc(var(--denhaag-button-large-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-block-start:calc(var(--denhaag-button-large-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-inline-end:calc(var(--denhaag-button-large-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width));padding-inline-start:calc(var(--denhaag-button-large-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width))}.denhaag-button__icon>:first-child{font-size:var(--denhaag-typography-scale-lg-font-size)}.denhaag-button--large .denhaag-button__icon>:first-child{font-size:var(--denhaag-typography-scale-xl-font-size)}.denhaag-button--start-icon .denhaag-button__icon{display:inherit;margin-inline-end:8px;margin-inline-start:-4px}.denhaag-button--end-icon .denhaag-button__icon{display:inherit;margin-inline-end:-4px;margin-inline-start:8px}.denhaag-button__sr-only{clip:rect(0,0,0,0);border:0;height:1px;margin-block-end:-1px;margin-block-start:-1px;margin-inline-end:-1px;margin-inline-start:-1px;overflow:hidden;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;position:absolute;width:1px}";
styleInject$4$1(css_248z$5$3);function toVal$4$1(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$4$1(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$4$1 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$4$1(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Primary UI component for user interaction
 */
var Button$1 = function (_a) {
    var icon = _a.icon, className = _a.className, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.iconAlign, iconAlign = _c === void 0 ? 'start' : _c, props = __rest$2$3(_a, ["icon", "className", "type", "iconAlign"]);
    var buttonClassNames = clsx$4$1('denhaag-button', {
        'denhaag-button--secondary-action': props.variant === 'secondary-action',
        'denhaag-button--large': props.size === 'large',
        'denhaag-button--start-icon': iconAlign === 'start' && icon !== undefined,
        'denhaag-button--end-icon': iconAlign === 'end',
    }, className);
    var iconWrapped = icon !== undefined ? React__default__default.createElement("span", { className: 'denhaag-button__icon' }, icon) : '';
    return (React__default__default.createElement("button", __assign$2$3({}, props, { type: type, className: buttonClassNames }),
        iconAlign === 'start' ? iconWrapped : '',
        React__default__default.createElement("span", { className: 'denhaag-button__label' }, props.children),
        iconAlign === 'end' ? iconWrapped : ''));
};function styleInject$3$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$1$2 = ".utrecht-heading-1{--utrecht-heading-1-color:var(--denhaag-heading-color);--utrecht-heading-1-line-height:var(--denhaag-heading-line-height);font-family:var(--utrecht-heading-1-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-1-font-size);font-weight:var(--utrecht-heading-1-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-1-margin-block-end);margin-block-start:var(--utrecht-heading-1-margin-block-start)}.utrecht-heading-1--distanced{--utrecht-heading-1-margin-block-start:var(--utrecht-heading-1-distanced-margin-block-start);--utrecht-heading-1-margin-block-end:var(--utrecht-heading-1-distanced-margin-block-end)}.utrecht-heading-1+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-1-font-size)/4)}[class^=denhaag-]+.utrecht-heading-1{--utrecht-heading-1-margin-block-start:calc(var(--utrecht-heading-1-font-size)*1.125)}.utrecht-heading-2{--utrecht-heading-2-line-height:var(--denhaag-heading-line-height);--utrecht-heading-2-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-2-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-2-font-size);font-weight:var(--utrecht-heading-2-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-2-margin-block-end);margin-block-start:var(--utrecht-heading-2-margin-block-start)}.utrecht-heading-2--distanced{--utrecht-heading-2-margin-block-start:var(--utrecht-heading-2-distanced-margin-block-start);--utrecht-heading-2-margin-block-end:var(--utrecht-heading-2-distanced-margin-block-end)}.utrecht-heading-2+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-2-font-size)/4)}[class^=denhaag-]+.utrecht-heading-2{--utrecht-heading-2-margin-block-start:calc(var(--utrecht-heading-2-font-size)*1.125)}.utrecht-heading-3{--utrecht-heading-3-line-height:var(--denhaag-heading-line-height);--utrecht-heading-3-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-3-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-3-font-size);font-weight:var(--utrecht-heading-3-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-3-margin-block-end);margin-block-start:var(--utrecht-heading-3-margin-block-start)}.utrecht-heading-3--distanced{--utrecht-heading-3-margin-block-start:var(--utrecht-heading-3-distanced-margin-block-start);--utrecht-heading-3-margin-block-end:var(--utrecht-heading-3-distanced-margin-block-end)}.utrecht-heading-3+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-3-font-size)/4)}[class^=denhaag-]+.utrecht-heading-3{--utrecht-heading-3-margin-block-start:calc(var(--utrecht-heading-3-font-size)*1.125)}.utrecht-heading-4{--utrecht-heading-4-line-height:var(--denhaag-heading-line-height);--utrecht-heading-4-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-4-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-4-font-size);font-weight:var(--utrecht-heading-4-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-4-margin-block-end);margin-block-start:var(--utrecht-heading-4-margin-block-start)}.utrecht-heading-4--distanced{--utrecht-heading-4-margin-block-start:var(--utrecht-heading-4-distanced-margin-block-start);--utrecht-heading-4-margin-block-end:var(--utrecht-heading-4-distanced-margin-block-end)}.utrecht-heading-4+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-4-font-size)/4)}[class^=denhaag-]+.utrecht-heading-4{--utrecht-heading-4-margin-block-start:calc(var(--utrecht-heading-4-font-size)*1.125)}.utrecht-heading-5{--utrecht-heading-5-line-height:var(--denhaag-heading-line-height);--utrecht-heading-5-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-5-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-5-font-size);font-weight:var(--utrecht-heading-5-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-5-margin-block-end);margin-block-start:var(--utrecht-heading-5-margin-block-start)}.utrecht-heading-5--distanced{--utrecht-heading-5-margin-block-start:var(--utrecht-heading-5-distanced-margin-block-start);--utrecht-heading-5-margin-block-end:var(--utrecht-heading-5-distanced-margin-block-end)}.utrecht-heading-5+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-5-font-size)/4)}[class^=denhaag-]+.utrecht-heading-5{--utrecht-heading-5-margin-block-start:calc(var(--utrecht-heading-5-font-size)*1.125)}";
styleInject$3$1(css_248z$1$1$2);function toVal$3$1(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$3$1(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$3$1 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$3$1(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var Heading4$1 = function (props) {
    var rootClassNames = clsx$3$1('utrecht-heading-4', 'utrecht-heading-4--distanced', props.className);
    return React__default__default.createElement("h4", { className: rootClassNames }, props.children);
};var css_248z$4$3 = ".utrecht-paragraph{color:var(--utrecht-paragraph-color,var(--utrecht-document-color,inherit));font-family:var(--utrecht-paragraph-font-family,var(--utrecht-document-font-family,inherit));font-size:var(--utrecht-paragraph-font-size,var(--utrecht-document-font-size,inherit));font-weight:var(--utrecht-paragraph-font-weight,inherit);line-height:var(--utrecht-paragraph-line-height,var(--utrecht-document-line-height,normal));margin-block-end:var(--utrecht-paragraph-margin-block-end);margin-block-start:var(--utrecht-paragraph-margin-block-start)}.utrecht-paragraph--lead{font-size:var(--utrecht-paragraph-lead-font-size,inherit);font-weight:var(--utrecht-paragraph-lead-font-weight,inherit);line-height:var(--utrecht-paragraph-lead-line-height,inherit)}.utrecht-paragraph--distanced{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-distanced-margin-block-start);--utrecht-paragraph-margin-block-end:var(--utrecht-paragraph-distanced-margin-block-end)}.denhaag-paragraph--detail{font-family:var(--denhaag-posttypelabel-font-family,inherit);font-size:var(--denhaag-posttypelabel-font-size,.75rem);letter-spacing:var(--denhaag-posttypelabel-letter-spacing,1px);line-height:var(--denhaag-posttypelabel-line-height,1.5);text-transform:var(--denhaag-posttypelabel-text-transform,uppercase)}.utrecht-paragraph+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-paragraph-margin-block-start,inherit)}.utrecht-paragraph--lead+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-lead-paragraph-margin-block-start,inherit)}.denhaag-list+.utrecht-paragraph,.denhaag-list__wrapper+.utrecht-paragraph,.denhaag-ordered-list+.utrecht-paragraph,.denhaag-unordered-list+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-list-margin-block-start,inherit)}.denhaag-list+.utrecht-paragraph--lead,.denhaag-list__wrapper+.utrecht-paragraph--lead,.denhaag-ordered-list+.utrecht-paragraph--lead,.denhaag-unordered-list+.utrecht-paragraph--lead{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-lead-list-margin-block-start,inherit)}";
styleInject$3$1(css_248z$4$3);var Paragraph$2 = function (props) {
    var rootClassNames = clsx$3$1('utrecht-paragraph', 'utrecht-paragraph--distanced', props.className);
    return React__default__default.createElement("p", { className: rootClassNames },
        " ",
        props.children);
};var __assign$1$7 = function() {
    __assign$1$7 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$7.apply(this, arguments);
};

function __rest$1$8(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$2$2(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$2$2(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$2$2 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$2$2(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$9 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$1$8(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$2$2({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$1$7({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$2$3(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$3$4 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$2$3(css_248z$3$4);var _path$z;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function SvgClose(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$B({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React__default.createElement("path", {
    d: "M5.293 5.293a1 1 0 011.414 0L12 10.586l5.293-5.293a1 1 0 111.414 1.414L13.414 12l5.293 5.293a1 1 0 01-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 01-1.414-1.414L10.586 12 5.293 6.707a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

var MemoSvgClose = /*#__PURE__*/React__default.memo(SvgClose);var _g$1;

function _extends$m$1() { _extends$m$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m$1.apply(this, arguments); }

function SvgAlertTriangle$1(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$m$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React__default.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0v0zM12 17h.01M12 9v4"
  }))));
}

var MemoSvgAlertTriangle$1 = /*#__PURE__*/React__default.memo(SvgAlertTriangle$1);var _path$l$1, _path2$6$1;

function _extends$l$1() { _extends$l$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l$1.apply(this, arguments); }

function SvgCheckCircle$1(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$l$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l$1 || (_path$l$1 = /*#__PURE__*/React__default.createElement("path", {
    d: "M22 11.08V12a10 10 0 11-5.93-9.14",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$6$1 || (_path2$6$1 = /*#__PURE__*/React__default.createElement("path", {
    d: "M22 4L12 14.01l-3-3",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var MemoSvgCheckCircle$1 = /*#__PURE__*/React__default.memo(SvgCheckCircle$1);var _path$j, _path2$4;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function SvgCircleInformation(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$j({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React__default.createElement("path", {
    d: "M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z",
    fill: "currentColor"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React__default.createElement("path", {
    d: "M12 10a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zM13.5 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "currentColor"
  })));
}

var MemoSvgCircleInformation = /*#__PURE__*/React__default.memo(SvgCircleInformation);var buildIcon$9 = function (svg, props) { return (React__default__default.createElement(SvgIcon$9, __assign$1$7({ component: svg }, props))); };
// Functional
var CloseIcon = function (props) { return buildIcon$9(MemoSvgClose, props); };
// Informational
var AlertTriangleIcon$1 = function (props) { return buildIcon$9(MemoSvgAlertTriangle$1, props); };
var CheckCircleIcon$1 = function (props) { return buildIcon$9(MemoSvgCheckCircle$1, props); };
var CircleInformationIcon = function (props) { return buildIcon$9(MemoSvgCircleInformation, props); };var __assign$o = function() {
    __assign$o = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$o.apply(this, arguments);
};

function __rest$h(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function styleInject$1$b(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$e = ".denhaag-icon-button--hover,.denhaag-icon-button:hover{background-color:transparent}";
styleInject$1$b(css_248z$1$e);var css_248z$2$7 = ".denhaag-icon-button{appearance:none;background-color:transparent;border:0;border-radius:0;color:var(--denhaag-icon-button-color);cursor:pointer;display:inline-flex;outline:0;padding-block-end:var(--denhaag-icon-button-padding-block-end);padding-block-start:var(--denhaag-icon-button-padding-block-start);padding-inline-end:var(--denhaag-icon-button-padding-inline-end);padding-inline-start:var(--denhaag-icon-button-padding-inline-start)}.denhaag-icon-button--hover,.denhaag-icon-button:hover{color:var(--denhaag-icon-button-hover-color)}.denhaag-icon-button--focus,.denhaag-icon-button:focus{color:var(--denhaag-icon-button-focus-color);outline-color:var(--denhaag-icon-button-focus-outline-color);outline-offset:var(--denhaag-icon-button-focus-outline-offset);outline-style:var(--denhaag-icon-button-focus-outline-style);outline-width:var(--denhaag-icon-button-focus-outline-width)}";
styleInject$1$b(css_248z$2$7);function toVal$1$b(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$b(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$b () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$b(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Displays a Button with an Icon as content.
 * @param props The properties of an IconButton component.
 * @constructor Constructs an instance of IconButton.
 */
var IconButton$2 = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = __rest$h(_a, ["disabled"]);
    var rootClassNames = clsx$1$b('denhaag-icon-button', props.className);
    return (React__default__default.createElement(IconButton$3, __assign$o({}, props, { className: rootClassNames, disabled: disabled, disableRipple: true, disableFocusRipple: true }), props.children));
};function styleInject$n(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$s = ".denhaag-alert{--utrecht-paragraph-margin-block-end:0;border-radius:var(--denhaag-alert-border-radius);border-width:0;display:flex;flex-direction:row;justify-content:space-between;padding-block-end:var(--denhaag-alert-padding-block-end);padding-block-start:var(--denhaag-alert-padding-block-start);padding-inline-end:var(--denhaag-alert-padding-inline-end);padding-inline-start:var(--denhaag-alert-padding-inline-start)}.denhaag-alert--error{--denhaag-paragraph-color:var(--denhaag-alert-error-paragraph-color);--utrecht-heading-4-color:var(--denhaag-alert-error-title-color);--denhaag-button-primary-action-background-color:var(--denhaag-alert-error-action-button-background-color);--denhaag-button-primary-action-color:var(--denhaag-alert-error-action-button-color);--denhaag-button-primary-action-hover-background-color:var(\n    --denhaag-alert-error-action-button-hover-background-color\n  );--denhaag-icon-button-color:var(--denhaag-alert-error-close-icon-color);--denhaag-icon-button-hover-color:var(--denhaag-alert-error-close-icon-color);--denhaag-icon-button-focus-color:var(--denhaag-alert-error-close-icon-color);background-color:var(--denhaag-alert-error-background-color)}.denhaag-alert__main-content{display:flex;flex-direction:row;justify-content:space-between}.denhaag-alert .denhaag-alert__icon{margin-block-start:4px}.denhaag-alert__close{padding-block-start:4px}.denhaag-alert .denhaag-button{margin-block-start:var(--denhaag-alert-action-padding-block-start)}.denhaag-alert--error .denhaag-alert__icon{color:var(--denhaag-alert-error-icon-color)}.denhaag-alert--info{--denhaag-paragraph-color:var(--denhaag-alert-info-paragraph-color);--utrecht-heading-4-color:var(--denhaag-alert-info-title-color);--denhaag-button-primary-action-background-color:var(--denhaag-alert-info-action-button-background-color);--denhaag-button-primary-action-color:var(--denhaag-alert-info-action-button-color);--denhaag-button-primary-action-hover-background-color:var(\n    --denhaag-alert-info-action-button-hover-background-color\n  );--denhaag-icon-button-color:var(--denhaag-alert-info-close-icon-color);--denhaag-icon-button-hover-color:var(--denhaag-alert-info-close-icon-color);--denhaag-icon-button-focus-color:var(--denhaag-alert-info-close-icon-color);background-color:var(--denhaag-alert-info-background-color)}.denhaag-alert--info .denhaag-alert__icon{color:var(--denhaag-alert-info-icon-color)}.denhaag-alert--success{--denhaag-paragraph-color:var(--denhaag-alert-success-paragraph-color);--utrecht-heading-4-color:var(--denhaag-alert-success-title-color);--denhaag-button-primary-action-background-color:var(--denhaag-alert-success-action-button-background-color);--denhaag-button-primary-action-color:var(--denhaag-alert-success-action-button-color);--denhaag-button-primary-action-hover-background-color:var(\n    --denhaag-alert-success-action-button-hover-background-color\n  );--denhaag-icon-button-color:var(--denhaag-alert-success-close-icon-color);--denhaag-icon-button-hover-color:var(--denhaag-alert-success-close-icon-color);--denhaag-icon-button-focus-color:var(--denhaag-alert-success-close-icon-color);background-color:var(--denhaag-alert-success-background-color)}.denhaag-alert--success .denhaag-alert__icon{color:var(--denhaag-alert-success-icon-color)}.denhaag-alert--warning{--denhaag-paragraph-color:var(--denhaag-alert-warning-paragraph-color);--utrecht-heading-4-color:var(--denhaag-alert-warning-title-color);--denhaag-button-primary-action-background-color:var(--denhaag-alert-warning-action-button-background-color);--denhaag-button-primary-action-color:var(--denhaag-alert-warning-action-button-color);--denhaag-button-primary-action-hover-background-color:var(\n    --denhaag-alert-warning-action-button-hover-background-color\n  );--denhaag-icon-button-color:var(--denhaag-alert-warning-close-icon-color);--denhaag-icon-button-hover-color:var(--denhaag-alert-warning-close-icon-color);--denhaag-icon-button-focus-color:var(--denhaag-alert-warning-close-icon-color);background-color:var(--denhaag-alert-warning-background-color)}.denhaag-alert--warning .denhaag-alert__icon{color:var(--denhaag-alert-warning-icon-color)}.denhaag-alert__content{margin-inline-end:var(--denhaag-alert-content-margin-inline-end);margin-inline-start:var(--denhaag-alert-content-margin-inline-start)}";
styleInject$n(css_248z$s);function toVal$m(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$m(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$m () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$m(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Primary UI component for user interaction
 */
var Alert = function (_a) {
    var id = _a.id, title = _a.title, text = _a.text, variant = _a.variant, action = _a.action, close = _a.close, supportIcon = _a.supportIcon, className = _a.className;
    var rootClassNames = clsx$m('denhaag-alert', "denhaag-alert--".concat(variant), className);
    var icon;
    if (supportIcon !== undefined) {
        icon = supportIcon;
    }
    else {
        switch (variant) {
            case 'error':
                icon = React__default__default.createElement(AlertTriangleIcon$1, null);
                break;
            case 'info':
                icon = React__default__default.createElement(CircleInformationIcon, null);
                break;
            case 'success':
                icon = React__default__default.createElement(CheckCircleIcon$1, null);
                break;
            case 'warning':
                icon = React__default__default.createElement(AlertTriangleIcon$1, null);
                break;
        }
    }
    return (React__default__default.createElement("div", { id: id, className: rootClassNames },
        React__default__default.createElement("div", { className: "denhaag-alert__main-content" },
            React__default__default.createElement("div", { className: "denhaag-alert__icon" }, icon),
            React__default__default.createElement("div", { className: "denhaag-alert__content" },
                React__default__default.createElement(Heading4$1, null, title),
                React__default__default.createElement(Paragraph$2, null, text),
                action && (React__default__default.createElement(Button$1, { type: "button", onClick: function () { return action.onClick(); } }, action.buttonText)))),
        close && (React__default__default.createElement("div", { className: "denhaag-alert__close" },
            React__default__default.createElement(IconButton$2, { "aria-label": "Close", onClick: close, tabIndex: 0 },
                React__default__default.createElement(CloseIcon, null))))));
};var __assign$n = function() {
    __assign$n = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$n.apply(this, arguments);
};/**
 * Displaying a small image, such as a profile picture, as avatar.
 * @param props The properties of an Avatar component.
 * @constructor Constructs an instance of Avatar.
 */
var Avatar = function (props) {
    return React__default__default.createElement(Avatar$1, __assign$n({}, props), props.children);
};function styleInject$1$a(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$d = ".denhaag-dot-indicator{display:inline-flex;flex-shrink:0;position:relative;vertical-align:middle}.denhaag-dot-indicator__dot{background-color:var(--denhaag-dot-indicator-background-color);border:var(--denhaag-dot-indicator-border);border-radius:50%;height:var(--denhaag-dot-indicator-size);position:absolute;transform:scale(1) translate(50%,-50%);width:var(--denhaag-dot-indicator-size)}.denhaag-dot-indicator--overlap-rectangle .denhaag-dot-indicator__dot{right:0;top:0;transform:scale(1) translate(50%,-50%)}.denhaag-dot-indicator--overlap-circle .denhaag-dot-indicator__dot{right:14%;top:14%;transform:scale(1) translate(50%,-50%)}";
styleInject$1$a(css_248z$1$d);function toVal$1$a(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$a(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$a () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$a(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * A dot indicator is a visual update message that announces something new for the user to see.
 * Dot indicators are typically used with counter badges
 * @param props The properties of a Dot Indicator component.
 */
var DotIndicator = function (props) {
    var rootClassNames = clsx$1$a('denhaag-dot-indicator', {
        'denhaag-dot-indicator--overlap-rectangle': props.overlap === 'rectangle',
        'denhaag-dot-indicator--overlap-circle': props.overlap === 'circle',
    }, props.className);
    return (React__default__default.createElement("span", { className: rootClassNames, id: props.id },
        props.children,
        React__default__default.createElement("span", { className: 'denhaag-dot-indicator__dot' })));
};function styleInject$m(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$r = ".utrecht-badge{background-color:var(--utrecht-badge-background-color,#000);border-radius:var(--utrecht-badge-border-radius,.5ch);color:var(--utrecht-badge-color,#fff);font-size:var(--utrecht-badge-font-size,inherit);font-style:var(--utrecht-badge-font-style,normal);font-weight:var(--utrecht-badge-font-weight,bold);line-height:var(--utrecht-badge-line-height);padding-block-end:var(--utrecht-badge-padding-block,.5ex);padding-block-start:var(--utrecht-badge-padding-block,.5ex);padding-inline-end:var(--utrecht-badge-padding-inline,.5ch);padding-inline-start:var(--utrecht-badge-padding-inline,.5ch)}.denhaag-badge-counter__counter,.utrecht-badge,.utrecht-badge-counter{display:inline-block;font-family:var(--utrecht-document-font-family,sans-serif);text-decoration:none}.denhaag-badge-counter__counter,.utrecht-badge-counter{background-color:var(--utrecht-badge-counter-background-color,var(--utrecht-badge-background-color,#000));border-radius:var(--utrecht-badge-counter-border-radius,var(--utrecht-badge-border-radius,.5ch));color:var(--utrecht-badge-counter-color,var(--utrecht-badge-color,#fff));font-style:var(--utrecht-badge-counter-font-style,normal);font-weight:var(--utrecht-badge-counter-font-weight,var(--utrecht-badge-font-weight,bold));padding-block-end:var(--utrecht-badge-counter-padding-block,var(--utrecht-badge-padding-block,.5ex));padding-block-start:var(--utrecht-badge-counter-padding-block,var(--utrecht-badge-padding-block,.5ex));padding-inline-end:var(--utrecht-badge-counter-padding-inline,var(--utrecht-badge-padding-inline,.5ch));padding-inline-start:var(--utrecht-badge-counter-padding-inline,var(--utrecht-badge-padding-inline,.5ch))}.denhaag-badge-counter{--denhaag-dot-indicator-size:8px}.denhaag-badge-counter__counter{font-family:var(--utrecht-badge-counter-font-family);font-size:var(--utrecht-badge-counter-font-size)}";
styleInject$m(css_248z$r);function toVal$l(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$l(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$l () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$l(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * A counter badge notifies a user of a specific amount of updates.
 * @param props The properties of a Badge component.
 * @constructor Constructs an instance of Badge.
 */
var BadgeCounter = function (props) {
    var rootClassNames = clsx$l('denhaag-badge-counter', props.className);
    return (React__default__default.createElement("div", { id: props.id, className: rootClassNames },
        React__default__default.createElement(DotIndicator, { overlap: 'rectangle' },
            React__default__default.createElement("div", { className: 'denhaag-badge-counter__counter' }, props.children))));
};var __assign$m = function() {
    __assign$m = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$m.apply(this, arguments);
};

function __rest$g(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function styleInject$l(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$q = ".denhaag-button{align-items:center;background-color:var(--denhaag-button-primary-action-background-color);border:0;border-radius:var(--denhaag-button-border-radius);color:var(--denhaag-button-primary-action-color);cursor:var(--denhaag-button-cursor,default);display:inline-flex;font-family:var(--denhaag-button-font-family);font-size:var(--denhaag-typography-scale-base-font-size);line-height:1.75;padding-block-end:var(--denhaag-button-medium-size-padding-block,var(--denhaag-button-padding-block));padding-block-start:var(--denhaag-button-medium-size-padding-block,var(--denhaag-button-padding-block));padding-inline-end:var(--denhaag-button-medium-size-padding-inline,var(--denhaag-button-padding-inline));padding-inline-start:var(--denhaag-button-medium-size-padding-inline,var(--denhaag-button-padding-inline));position:relative;text-decoration:none}a.denhaag-button{--denhaag-button-cursor:pointer}.denhaag-button--focus-visible:after,.denhaag-button--focus:after,.denhaag-button:focus-visible:after,.denhaag-button:focus:after{border:var(--denhaag-focus-border);border-radius:var(--denhaag-border-radius);bottom:-2px;content:\"\";display:block;left:-2px;position:absolute;right:-2px;top:-2px}.denhaag-button--focus-visible,.denhaag-button:focus-visible{outline:none}.denhaag-button--secondary-action.denhaag-button--focus:after,.denhaag-button--secondary-action:focus:after{bottom:-3px;left:-3px;right:-3px;top:-3px}.denhaag-button.denhaag-button--hover,.denhaag-button:hover{background-color:var(--denhaag-button-primary-action-hover-background-color);color:var(--denhaag-button-primary-action-hover-color)}.denhaag-button.denhaag-button--disabled,.denhaag-button.denhaag-button:disabled{background-color:var(--denhaag-button-primary-action-disabled-background-color);color:var(--denhaag-button-primary-action-disabled-color)}.denhaag-button--secondary-action{background-color:var(--denhaag-button-secondary-action-background-color);border-color:var(--denhaag-button-secondary-action-border-color);border-style:solid;border-width:var(--denhaag-button-border-width);color:var(--denhaag-button-secondary-action-color);padding-block-end:calc(var(--denhaag-button-medium-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-block-start:calc(var(--denhaag-button-medium-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-inline-end:calc(var(--denhaag-button-medium-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width));padding-inline-start:calc(var(--denhaag-button-medium-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width))}.denhaag-button--secondary-action.denhaag-button--hover,.denhaag-button--secondary-action:hover{background-color:var(--denhaag-button-secondary-action-hover-background-color);border-color:var(--denhaag-button-secondary-action-hover-border-color);color:var(--denhaag-button-secondary-action-hover-color)}.denhaag-button--secondary-action.denhaag-button--disabled,.denhaag-button--secondary-action.denhaag-button:disabled{background-color:var(--denhaag-button-secondary-action-disabled-background-color);border-color:var(--denhaag-button-secondary-action-disabled-border-color);color:var(--denhaag-button-secondary-action-disabled-color)}.denhaag-button--large{font-size:var(--denhaag-typography-scale-lg-font-size);padding-block-end:var(--denhaag-button-large-size-padding-block,var(--denhaag-button-padding-block));padding-block-start:var(--denhaag-button-large-size-padding-block,var(--denhaag-button-padding-block));padding-inline-end:var(--denhaag-button-large-size-padding-inline,var(--denhaag-button-padding-inline));padding-inline-start:var(--denhaag-button-large-size-padding-inline,var(--denhaag-button-padding-inline))}.denhaag-button--large.denhaag-button--secondary-action{padding-block-end:calc(var(--denhaag-button-large-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-block-start:calc(var(--denhaag-button-large-size-padding-block, var(--denhaag-button-padding-block)) - var(--denhaag-button-border-width));padding-inline-end:calc(var(--denhaag-button-large-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width));padding-inline-start:calc(var(--denhaag-button-large-size-padding-inline, var(--denhaag-button-padding-inline)) - var(--denhaag-button-border-width))}.denhaag-button__icon>:first-child{font-size:var(--denhaag-typography-scale-lg-font-size)}.denhaag-button--large .denhaag-button__icon>:first-child{font-size:var(--denhaag-typography-scale-xl-font-size)}.denhaag-button--start-icon .denhaag-button__icon{display:inherit;margin-inline-end:8px;margin-inline-start:-4px}.denhaag-button--end-icon .denhaag-button__icon{display:inherit;margin-inline-end:-4px;margin-inline-start:8px}.denhaag-button__sr-only{clip:rect(0,0,0,0);border:0;height:1px;margin-block-end:-1px;margin-block-start:-1px;margin-inline-end:-1px;margin-inline-start:-1px;overflow:hidden;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;position:absolute;width:1px}";
styleInject$l(css_248z$q);function toVal$k(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$k(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$k () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$k(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Primary UI component for user interaction
 */
var Button = function (_a) {
    var icon = _a.icon, className = _a.className, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.iconAlign, iconAlign = _c === void 0 ? 'start' : _c, props = __rest$g(_a, ["icon", "className", "type", "iconAlign"]);
    var buttonClassNames = clsx$k('denhaag-button', {
        'denhaag-button--secondary-action': props.variant === 'secondary-action',
        'denhaag-button--large': props.size === 'large',
        'denhaag-button--start-icon': iconAlign === 'start' && icon !== undefined,
        'denhaag-button--end-icon': iconAlign === 'end',
    }, className);
    var iconWrapped = icon !== undefined ? React__default__default.createElement("span", { className: 'denhaag-button__icon' }, icon) : '';
    return (React__default__default.createElement("button", __assign$m({}, props, { type: type, className: buttonClassNames }),
        iconAlign === 'start' ? iconWrapped : '',
        React__default__default.createElement("span", { className: 'denhaag-button__label' }, props.children),
        iconAlign === 'end' ? iconWrapped : ''));
};function __rest$1$7(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var __assign$l = function() {
    __assign$l = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$l.apply(this, arguments);
};

function __rest$f(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$1$9(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$9(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$9 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$9(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$8 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$f(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$1$9({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$l({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$1$9(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$5$2 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$1$9(css_248z$5$2);var _path$H;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

function SvgArrowRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$J({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/React__default.createElement("path", {
    d: "M12.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L16.586 13H5a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

var MemoSvgArrowRight = /*#__PURE__*/React__default.memo(SvgArrowRight);var buildIcon$8 = function (svg, props) { return (React__default__default.createElement(SvgIcon$8, __assign$l({ component: svg }, props))); };
var ArrowRightIcon = function (props) { return buildIcon$8(MemoSvgArrowRight, props); };function styleInject$k(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$4$2 = ".denhaag-card{overflow:unset;transition:none}.denhaag-card,.denhaag-card--focus,.denhaag-card--hover,.denhaag-card:focus,.denhaag-card:hover{box-shadow:none}";
styleInject$k(css_248z$4$2);var css_248z$3$3 = ".denhaag-card{border-radius:var(--denhaag-card-border-radius);width:var(--denhaag-card-width)}.denhaag-card--focus,.denhaag-card:focus-within{outline:none}.denhaag-card--hover,.denhaag-card:hover,.denhaag-card:hover:focus{cursor:pointer}.denhaag-card__wrapper{border-color:var(--denhaag-card-border-color);border-radius:var(--denhaag-card-border-radius);border-style:solid;border-width:var(--denhaag-card-border-width);box-sizing:border-box;display:flex;flex-direction:column;height:var(--denhaag-card-height);padding-block-end:var(--denhaag-card-wrapper-padding-block);padding-block-start:var(--denhaag-card-wrapper-padding-block);padding-inline-end:var(--denhaag-card-wrapper-padding-inline);padding-inline-start:var(--denhaag-card-wrapper-padding-inline)}.denhaag-card--focus .denhaag-card__text-wrapper,.denhaag-card:focus-within .denhaag-card__text-wrapper{outline:var(--denhaag-focus-border);position:relative}.denhaag-card__arrow{left:var(--denhaag-card-arrow-left);margin-inline-start:auto;position:var(--denhaag-card-arrow-position);right:var(--denhaag-card-arrow-right)}.denhaag-card__title{-webkit-line-clamp:2;-webkit-box-orient:vertical;color:var(--denhaag-title-font-color);display:-webkit-box;font-size:var(--denhaag-card-title-font-size);line-height:var(--denhaag-card-title-line-height);overflow:hidden;padding-block-end:var(--denhaag-card-title-padding-block);padding-block-start:var(--denhaag-card-title-padding-block);padding-inline-end:var(--denhaag-card-title-padding-block);padding-inline-start:var(--denhaag-card-title-padding-inline);text-decoration:none}.denhaag-card__title a:link,.denhaag-card__title a:visited{color:inherit;text-decoration:none}.denhaag-card__title a:link:focus{outline:none}.denhaag-card__subtitle{color:var(--denhaag-card-subtitle-font-color);font-size:var(--denhaag-card-subtitle-font-size);font-weight:var(--denhaag-card-subtitle-font-weight);line-height:var(--denhaag-card-subtitle-line-height);padding-block-end:var(--denhaag-card-subtitle-padding-block);padding-block-start:var(--denhaag-card-subtitle-padding-block);padding-inline-end:var(--denhaag-card-subtitle-padding-block);padding-inline-start:var(--denhaag-card-subtitle-padding-block)}.denhaag-card--case{background:var(--denhaag-card-case-secondary-background-color);padding-block-start:var(--denhaag-card-case-padding-block-start);position:relative}.denhaag-card--case:before{background:var(--denhaag-card-case-paper-color);border-radius:0 var(--denhaag-card-border-radius) 0 0;content:\"\";display:block;height:20px;position:absolute;right:8px;top:8px;width:50%}.denhaag-card--case .denhaag-card__wrapper{background:transparent;border:2px;border-radius:var(--denhaag-card-border-radius);box-sizing:border-box;display:flex;flex-direction:column;height:var(--denhaag-card-case-height);padding-block-end:var(--denhaag-card-case-padding-block-end);padding-block-start:var(--denhaag-card-case-padding-block-start);perspective:1800px;position:relative}.denhaag-card--case .denhaag-card__background{background:var(--denhaag-card-case-primary-background-color);border-radius:var(--denhaag-card-border-radius);border-top-left-radius:0;bottom:0;left:0;position:absolute;right:0;top:0;transform-origin:50% 100%;z-index:-1}.denhaag-card--case .denhaag-card__background:before{border-top-left-radius:var(--denhaag-card-border-radius);height:25px;left:0;width:60%}.denhaag-card--case .denhaag-card__background:after,.denhaag-card--case .denhaag-card__background:before{background:var(--denhaag-card-case-primary-background-color);content:\"\";display:block;position:absolute;top:-20px}.denhaag-card--case .denhaag-card__background:after{height:22px;left:55%;transform:skewX(30deg);width:10%}.denhaag-card--case .denhaag-card__arrow{color:var(--denhaag-card-case-color);left:var(--denhaag-card-arrow-left);position:var(--denhaag-card-arrow-position);right:var(--denhaag-card-arrow-right)}.denhaag-card--case.denhaag-card--focus .denhaag-card__arrow,.denhaag-card--case.denhaag-card--hover .denhaag-card__arrow,.denhaag-card--case:focus-within .denhaag-card__arrow,.denhaag-card--case:hover .denhaag-card__arrow{color:var(--denhaag-card-case-active-color)}.denhaag-card--focus .denhaag-card__arrow,.denhaag-card:focus-within .denhaag-card__arrow{outline:var(--denhaag-focus-border)}.denhaag-card--case .denhaag-card__title{color:var(--denhaag-card-case-color);font-weight:700;padding-block-end:var(--denhaag-card-title-padding-block);padding-block-start:var(--denhaag-card-title-padding-block);padding-inline-end:var(--denhaag-card-title-padding-inline);padding-inline-start:var(--denhaag-card-title-padding-inline);position:relative}.denhaag-card--case.denhaag-card--focus .denhaag-card__title,.denhaag-card--case.denhaag-card--hover .denhaag-card__title,.denhaag-card--case:focus-within .denhaag-card__title,.denhaag-card--case:hover .denhaag-card__title{color:var(--denhaag-card-case-active-color)}.denhaag-card--case .denhaag-card__subtitle{color:var(--denhaag-card-case-color);font-weight:500;padding-block-end:var(--denhaag-card-subtitle-padding);padding-block-start:var(--denhaag-card-subtitle-padding);padding-inline-end:var(--denhaag-card-subtitle-padding);padding-inline-start:var(--denhaag-card-subtitle-padding);position:relative}.denhaag-card--case.denhaag-card--focus .denhaag-card__subtitle,.denhaag-card--case.denhaag-card--hover .denhaag-card__subtitle,.denhaag-card--case:focus-within .denhaag-card__subtitle,.denhaag-card--case:hover .denhaag-card__subtitle{color:var(--denhaag-card-case-active-color)}.denhaag-card--case.denhaag-card--focus:before,.denhaag-card--case.denhaag-card--hover:before,.denhaag-card--case:focus-within:before,.denhaag-card--case:hover:before{top:12px;transform:rotate(-2.45deg);transform-origin:right}.denhaag-card--case.denhaag-card--focus .denhaag-card__background,.denhaag-card--case.denhaag-card--hover .denhaag-card__background,.denhaag-card--case:focus-within .denhaag-card__background,.denhaag-card--case:hover .denhaag-card__background{transform:rotateX(-20deg)}.denhaag-card--case.denhaag-card--archived{--denhaag-card-case-primary-background-color:var(--denhaag-card-case-archived-primary-background-color);--denhaag-card-case-secondary-background-color:var(--denhaag-card-case-archived-secondary-background-color);--denhaag-card-case-color:var(--denhaag-card-case-archived-color)}";
styleInject$k(css_248z$3$3);const cardClasses = {
  root: 'denhaag-card',
};

const cardArrowClasses = {
  root: 'denhaag-card__arrow',
};

const cardTitleClasses = {
  root: 'denhaag-card__title',
};

const cardSubtitleClasses = {
  root: 'denhaag-card__subtitle',
};

const cardCaseClasses = {
  root: 'denhaag-card--case',
};

const cardArchivedClasses = {
  root: 'denhaag-card--archived',
};var css_248z$2$6 = ".denhaag-card__content{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;padding-inline-end:0;padding-inline-start:0}.denhaag-card__content,.denhaag-card__content:last-child{padding-block-end:0;padding-block-start:0}";
styleInject$k(css_248z$2$6);const CardContentClasses = {
  root: 'denhaag-card__content',
};/**
 * Primary UI component for user interaction
 */
var CardContent = function (props) {
    return React__default__default.createElement(CardContent$1, { classes: CardContentClasses }, props.children);
};var css_248z$1$c = ".denhaag-card__actions{justify-content:space-between;padding-block-end:var(--denhaag-card-actions-padding-block-end) 0;padding-block-start:var(--denhaag-card-actions-padding-block-start) 8px;padding-inline-end:var(--denhaag-card-actions-padding-inline-end) 0;padding-inline-start:var(--denhaag-card-actions-padding-inline-start) 0}";
styleInject$k(css_248z$1$c);var css_248z$p = ".denhaag-card__actions{padding-inline-end:0;padding-inline-start:0}";
styleInject$k(css_248z$p);const cardActionClasses = {
  root: 'denhaag-card__actions',
};/**
 * Primary UI component for user interaction
 */
var CardActions = function (props) {
    return (React__default__default.createElement(CardActions$1, { classes: cardActionClasses, disableSpacing: props.disableSpacing }, props.children));
};function toVal$j(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$j(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$j () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$j(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Primary UI component for user interaction
 */
var Card = function (_a) {
    var _b = _a.archived, archived = _b === void 0 ? false : _b, props = __rest$1$7(_a, ["archived"]);
    var rootClassNames = clsx$j(cardClasses.root, props.variant === 'case' && cardCaseClasses.root, archived === true && cardArchivedClasses.root, props.className);
    var arrowClasses = cardArrowClasses;
    var titleClasses = cardTitleClasses;
    var subtitleClasses = cardSubtitleClasses;
    var linkRef = createRef();
    var title = (React__default__default.createElement("a", { href: props.href, ref: linkRef }, props.title));
    var onClick = function (event) {
        if (typeof props.onClick === 'function') {
            props.onClick(event);
            event.stopPropagation();
        }
        else if (linkRef.current !== null) {
            linkRef.current.click();
        }
    };
    return (React__default__default.createElement(Card$1, { className: rootClassNames, onClick: onClick },
        React__default__default.createElement("div", { className: "denhaag-card__wrapper" },
            React__default__default.createElement("div", { className: "denhaag-card__background" }),
            React__default__default.createElement(CardContent, null,
                React__default__default.createElement("div", { className: "denhaag-card__text-wrapper" },
                    React__default__default.createElement(Typography, { classes: titleClasses, component: "p" }, title),
                    React__default__default.createElement(Typography, { classes: subtitleClasses, component: "p" }, props.subTitle)),
                React__default__default.createElement(CardActions, { disableSpacing: true },
                    props.date && (React__default__default.createElement(Typography, { component: "div", classes: subtitleClasses },
                        React__default__default.createElement("time", { dateTime: props.date.toISOString() }, props.date.toLocaleDateString()))),
                    React__default__default.createElement(Icon, { classes: arrowClasses, "aria-label": "ArrowRightIcon" },
                        React__default__default.createElement(ArrowRightIcon, null)))))));
};var __assign$1$6 = function() {
    __assign$1$6 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$6.apply(this, arguments);
};

function __rest$1$6(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$1$8(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$8(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$8 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$8(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var __assign$k = function() {
    __assign$k = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$k.apply(this, arguments);
};

function __rest$e(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$i(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$i(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$i () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$i(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$7 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$e(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$i({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$k({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$1$8(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$b = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$1$8(css_248z$1$b);var _path$y$1;

function _extends$A$1() { _extends$A$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A$1.apply(this, arguments); }

function SvgChecked$1(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$A$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path$y$1 || (_path$y$1 = /*#__PURE__*/React__default.createElement("path", {
    d: "M20.664 5.253a1 1 0 01.083 1.411l-10.666 12a1 1 0 01-1.495 0l-5.333-6a1 1 0 011.494-1.328l4.586 5.159 9.92-11.16a1 1 0 011.411-.082z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })));
}

var MemoSvgChecked$1 = /*#__PURE__*/React__default.memo(SvgChecked$1);var buildIcon$7 = function (svg, props) { return (React__default__default.createElement(SvgIcon$7, __assign$k({ component: svg }, props))); };
var CheckedIcon$1 = function (props) { return buildIcon$7(MemoSvgChecked$1, props); };function styleInject$j(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$o = ".denhaag-checkbox{align-items:center;display:inline-flex;justify-content:center;position:relative}.denhaag-checkbox__input{left:0;margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;opacity:0;position:absolute;top:0;z-index:1}.denhaag-checkbox__icon,.denhaag-checkbox__input{aspect-ratio:1;cursor:pointer;width:var(--utrecht-custom-checkbox-size)}.denhaag-checkbox__icon{align-items:center;background-color:var(--utrecht-custom-checkbox-background-color,var(--utrecht-form-input-background-color));border-color:var(--utrecht-custom-checkbox-border-color,var(--utrecht-form-input-border-color));border-radius:var(--utrecht-custom-checkbox-border-radius,var(--utrecht-form-input-border-radius));border-style:solid;border-width:var(--utrecht-custom-checkbox-border-width,var(--utrecht-form-input-border-width));box-sizing:border-box;display:inline-flex;justify-content:center}.denhaag-checkbox__icon .denhaag-icon{display:none}.denhaag-checkbox__input:disabled{cursor:default}.denhaag-checkbox__input:checked+.denhaag-checkbox__icon{background-color:var(--utrecht-custom-checkbox-checked-background-color);border-color:var(--utrecht-custom-checkbox-checked-border-color);border-width:var(--utrecht-custom-checkbox-checked-border-width)}.denhaag-checkbox__input:checked+.denhaag-checkbox__icon .denhaag-icon{color:var(--utrecht-custom-checkbox-checked-color);display:block;font-size:var(--utrecht-custom-checkbox-icon-size)}.denhaag-checkbox.denhaag-checkbox--error .denhaag-checkbox__icon{border-color:var(--utrecht-custom-checkbox-invalid-border-color,var(--utrecht-form-input-invalid-border-color));border-width:var(--utrecht-custom-checkbox-invalid-border-width,var(--utrecht-form-input-invalid-border-width))}.denhaag-checkbox.denhaag-checkbox--error .denhaag-checkbox__icon .denhaag-icon{color:var(--utrecht-custom-checkbox-invalid-color)}.denhaag-checkbox.denhaag-checkbox--focus .denhaag-checkbox__icon,.denhaag-checkbox:focus-within .denhaag-checkbox__icon{outline:var(--denhaag-focus-border)}.denhaag-checkbox.denhaag-checkbox--hover .denhaag-checkbox__icon,.denhaag-checkbox:hover .denhaag-checkbox__icon,.denhaag-form-control-label:hover .denhaag-checkbox__icon{border-color:var(--denhaag-checkbox-hover-border-color);border-width:var(--denhaag-checkbox-hover-border-width)}.denhaag-checkbox .denhaag-checkbox__input:disabled+.denhaag-checkbox__icon{background-color:var(--utrecht-custom-checkbox-disabled-background-color);border-color:var(--utrecht-custom-checkbox-disabled-border-color);border-width:var(--utrecht-custom-checkbox-disabled-border-width);cursor:default}.denhaag-checkbox.denhaag-checkbox--error.denhaag-checkbox.denhaag-checkbox--hover .denhaag-checkbox__icon,.denhaag-checkbox.denhaag-checkbox--error:hover .denhaag-checkbox__icon,.denhaag-form-control-label:hover .denhaag-checkbox.denhaag-checkbox--error .denhaag-checkbox__icon{border-color:var(--denhaag-checkbox-hover-invalid-border-color)}.denhaag-checkbox.denhaag-checkbox--hover .denhaag-checkbox__input:checked+.denhaag-checkbox__icon,.denhaag-checkbox:hover .denhaag-checkbox__input:checked+.denhaag-checkbox__icon,.denhaag-form-control-label:hover .denhaag-checkbox__input:checked+.denhaag-checkbox__icon{background-color:var(--denhaag-checkbox-hover-checked-background-color);border-color:var(--denhaag-checkbox-hover-checked-border-color)}.denhaag-checkbox .denhaag-checkbox__input:checked:disabled+.denhaag-checkbox__icon{background-color:var(--denhaag-checkbox-checked-disabled-background-color);border-color:var(--denhaag-checkbox-checked-disabled-border-color)}.denhaag-checkbox.denhaag-checkbox--error .denhaag-checkbox__input:checked+.denhaag-checkbox__icon{background-color:var(--denhaag-checkbox-checked-invalid-background-color)}.denhaag-checkbox.denhaag-checkbox--error.denhaag-checkbox--hover .denhaag-checkbox__input:checked+.denhaag-checkbox__icon,.denhaag-checkbox.denhaag-checkbox--error:hover .denhaag-checkbox__input:checked+.denhaag-checkbox__icon,.denhaag-form-control-label:hover .denhaag-checkbox.denhaag-checkbox--error .denhaag-checkbox__input:checked+.denhaag-checkbox__icon{background-color:var(--denhaag-checkbox-hover-invalid-background-color);border-color:var(--denhaag-checkbox-hover-invalid-border-color)}";
styleInject$j(css_248z$o);/**
 * Checkboxes allow the user to select one or more items from a set.
 */
var Checkbox = function (_a) {
    var className = _a.className, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.checkedIcon, checkedIcon = _d === void 0 ? React__default__default.createElement(CheckedIcon$1, null) : _d, onChange = _a.onChange, props = __rest$1$6(_a, ["className", "error", "checked", "checkedIcon", "onChange"]);
    var _e = React__default__default.useState(checked), isChecked = _e[0], setChecked = _e[1];
    var classes = clsx$1$8('denhaag-checkbox', { 'denhaag-checkbox--error': error }, className);
    return (React__default__default.createElement("span", { className: classes },
        React__default__default.createElement("input", __assign$1$6({ type: "checkbox", className: "denhaag-checkbox__input", checked: isChecked, onChange: function (event) {
                setChecked(!isChecked);
                if (onChange) {
                    onChange(event);
                }
            } }, props)),
        React__default__default.createElement("span", { className: "denhaag-checkbox__icon" }, checkedIcon)));
};var __assign$1$5 = function() {
    __assign$1$5 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$5.apply(this, arguments);
};

function __rest$1$5(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$1$7(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$7(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$7 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$7(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }

  return result;
}var dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;var formatRelativeLocale = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}var eraValues = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var dayValues = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};

function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'e';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide'
  })
};
var localize$1 = localize;var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */

var locale = {
  code: 'nl',
  formatDistance: formatDistance,
  formatLong: formatLong$1,
  formatRelative: formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var nl = locale;var __assign$j = function() {
    __assign$j = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$j.apply(this, arguments);
};

function __rest$d(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$h(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$h(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$h () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$h(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$6 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$d(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$h({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$j({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$1$7(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$a = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$1$7(css_248z$1$a);var _path$F$1;

function _extends$H$1() { _extends$H$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H$1.apply(this, arguments); }

function SvgChevronRight$1(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$H$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F$1 || (_path$F$1 = /*#__PURE__*/React__default.createElement("path", {
    d: "M9.293 18.707a1 1 0 010-1.414L14.586 12 9.293 6.707a1 1 0 011.414-1.414l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0z",
    fill: "currentColor"
  })));
}

var MemoSvgChevronRight$1 = /*#__PURE__*/React__default.memo(SvgChevronRight$1);var _path$D;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

function SvgChevronLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$F({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/React__default.createElement("path", {
    d: "M14.3 18.7l-6-6c-.4-.4-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L10.4 12l5.3 5.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0z",
    fill: "currentColor"
  })));
}

var MemoSvgChevronLeft = /*#__PURE__*/React__default.memo(SvgChevronLeft);var _g;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function SvgAlertTriangle(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$m({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React__default.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0v0zM12 17h.01M12 9v4"
  }))));
}

var MemoSvgAlertTriangle = /*#__PURE__*/React__default.memo(SvgAlertTriangle);var _path$f;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function SvgCalendar(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React__default.createElement("path", {
    d: "M9 2a1 1 0 011 1v1h4V3a1 1 0 112 0v1h3a2 2 0 012 2v13a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h3V3a1 1 0 011-1zM8 6H5v3h14V6h-3v1a1 1 0 11-2 0V6h-4v1a1 1 0 01-2 0V6zm11 5H5v8h14v-8z",
    fill: "currentColor"
  })));
}

var MemoSvgCalendar = /*#__PURE__*/React__default.memo(SvgCalendar);var buildIcon$6 = function (svg, props) { return (React__default__default.createElement(SvgIcon$6, __assign$j({ component: svg }, props))); };
var ChevronRightIcon$1 = function (props) { return buildIcon$6(MemoSvgChevronRight$1, props); };
var ChevronLeftIcon = function (props) { return buildIcon$6(MemoSvgChevronLeft, props); };
// Informational
var AlertTriangleIcon = function (props) { return buildIcon$6(MemoSvgAlertTriangle, props); };
var CalendarIcon = function (props) { return buildIcon$6(MemoSvgCalendar, props); };function styleInject$i(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$n = ".denhaag-datepicker{position:relative;width:var(--denhaag-datepicker-width)}.denhaag-datepicker:after{background-color:var(--denhaag-datepicker-input-background-color);color:var(--denhaag-datepicker-input-placeholder-color);content:attr(data-placeholder);font-family:var(--denhaag-datepicker-font-family);font-size:var(--denhaag-datepicker-input-font-size);height:var(--denhaag-datepicker-input-line-height);inset-block-start:calc((var(--denhaag-datepicker-input-height) - var(--denhaag-datepicker-input-line-height))/2);inset-inline-end:calc(var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-input-padding-inline));inset-inline-start:var(--denhaag-datepicker-input-padding-inline);line-height:var(--denhaag-datepicker-input-line-height);pointer-events:none;position:absolute}.denhaag-datepicker.denhaag-datepicker--has-value:after{content:\"\";inset-inline-start:unset;width:16px}.denhaag-datepicker.denhaag-datepicker--error:after{inset-inline-end:calc(var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-error-icon-inset-inline-end) + var(--denhaag-datepicker-error-icon-font-size) + var(--denhaag-datepicker-input-padding-inline))}.denhaag-datepicker.denhaag-datepicker--disabled:after{color:var(--denhaag-datepicker-disabled-input-color)}.denhaag-datepicker__button{background:none;border:0;color:var(--denhaag-datepicker-button-color);cursor:pointer;height:var(--denhaag-datepicker-input-height);inset-block-start:0;inset-inline-end:var(--denhaag-datepicker-button-inset-inline-end);outline:0;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;position:absolute}.denhaag-datepicker__button.denhaag-datepicker__button--hover,.denhaag-datepicker__button:hover{color:var(--denhaag-icon-button-hover-color)}.denhaag-datepicker__button.denhaag-datepicker__button--focus,.denhaag-datepicker__button:focus-visible{color:var(--denhaag-icon-button-focus-color)}.denhaag-datepicker__button .denhaag-icon{font-size:var(--denhaag-datepicker-button-font-size)}.denhaag-datepicker__input{appearance:none;background-color:var(--denhaag-datepicker-input-background-color);border-color:var(--denhaag-datepicker-input-border-color);border-radius:var(--denhaag-datepicker-input-border-radius);border-style:var(--denhaag-datepicker-input-border-style);border-width:var(--denhaag-datepicker-input-border-width);box-sizing:border-box;color:var(--denhaag-datepicker-input-color);font-family:var(--denhaag-datepicker-font-family);font-size:var(--denhaag-datepicker-input-font-size);height:var(--denhaag-datepicker-input-height);line-height:var(--denhaag-datepicker-input-line-height);padding-inline-end:calc(var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-input-padding-inline));padding-inline-start:var(--denhaag-datepicker-input-padding-inline);width:100%}.denhaag-datepicker__input::-webkit-date-and-time-value{text-align:start}.denhaag-datepicker__input::-webkit-calendar-picker-indicator{display:none}.denhaag-datepicker--error .denhaag-datepicker__input{border-color:var(--denhaag-datepicker-error-input-border-color);padding-inline-end:calc(var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-error-icon-inset-inline-end) + var(--denhaag-datepicker-error-icon-font-size) + var(--denhaag-datepicker-input-padding-inline))}.denhaag-datepicker__input.denhaag-datepicker__input--hover,.denhaag-datepicker__input:hover{border-color:var(--denhaag-datepicker-input-hover-border-color);border-width:var(--denhaag-datepicker-input-hover-border-width);padding-inline-end:calc(var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-input-padding-inline) - var(--denhaag-datepicker-input-hover-border-width) + var(--denhaag-datepicker-input-border-width));padding-inline-start:calc(var(--denhaag-datepicker-input-padding-inline) - var(--denhaag-datepicker-input-hover-border-width) + var(--denhaag-datepicker-input-border-width))}.denhaag-datepicker--disabled .denhaag-datepicker__input{border-color:var(--denhaag-datepicker-disabled-input-border-color);color:var(--denhaag-datepicker-disabled-input-color);pointer-events:none}.denhaag-datepicker--error .denhaag-datepicker__input.denhaag-datepicker__input--hover,.denhaag-datepicker--error .denhaag-datepicker__input:hover{padding-inline-end:calc(var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-error-icon-inset-inline-end) + var(--denhaag-datepicker-error-icon-font-size) + var(--denhaag-datepicker-input-padding-inline) - var(--denhaag-datepicker-input-hover-border-width) + var(--denhaag-datepicker-input-border-width))}.denhaag-datepicker__error-icon{display:none}.denhaag-datepicker--error .denhaag-datepicker__error-icon{color:var(--denhaag-datepicker-error-icon-color);display:block;font-size:var(--denhaag-datepicker-error-icon-font-size);inset-block-start:calc((var(--denhaag-datepicker-input-height) - var(--denhaag-datepicker-error-icon-font-size))/2);inset-inline-end:calc(var(--denhaag-datepicker-button-inset-inline-end) + var(--denhaag-datepicker-button-font-size) + var(--denhaag-datepicker-error-icon-inset-inline-end));position:absolute}.denhaag-datepicker--disabled .denhaag-datepicker__button{color:var(--denhaag-datepicker-disabled-button-color);pointer-events:none}.denhaag-datepicker .denhaag-datepicker__button.denhaag-datepicker__button--focus+.denhaag-datepicker__input,.denhaag-datepicker .denhaag-datepicker__button:focus-visible+.denhaag-datepicker__input,.denhaag-datepicker .denhaag-datepicker__input.denhaag-datepicker__input--focus,.denhaag-datepicker .denhaag-datepicker__input:focus-visible{outline:var(--denhaag-focus-border)}.denhaag-datepicker__calendar{background-color:var(--denhaag-datepicker-calendar-background-color);border-color:var(--denhaag-datepicker-calendar-border-color);border-radius:var(--denhaag-datepicker-calendar-border-radius);border-style:var(--denhaag-datepicker-calendar-border-style);border-width:var(--denhaag-datepicker-calendar-border-width);box-sizing:border-box;left:0;padding-block-end:var(--denhaag-datepicker-calendar-padding-block-end);padding-inline-end:var(--denhaag-datepicker-calendar-padding-inline);padding-inline-start:var(--denhaag-datepicker-calendar-padding-inline);position:absolute;top:var(--denhaag-datepicker-input-height);z-index:1}.denhaag-datepicker__calendar.denhaag-datepicker__calendar--hidden{display:none}.denhaag-datepicker__calendar-header{align-items:center;display:flex;height:var(--denhaag-datepicker-calendar-header-height);justify-content:space-between}.denhaag-datepicker__calendar-month{font-family:var(--denhaag-datepicker-font-family);font-size:var(--denhaag-datepicker-calendar-month-font-size);font-weight:var(--denhaag-datepicker-calendar-month-font-weight);line-height:var(--denhaag-datepicker-calendar-month-line-height)}.denhaag-datepicker__calendar-navigation{appearance:none;background-color:transparent;border:0;color:var(--denhaag-icon-button-color);cursor:pointer;outline:0;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}.denhaag-datepicker__calendar-navigation.denhaag-datepicker__calendar-navigation--hover,.denhaag-datepicker__calendar-navigation:hover{color:var(--denhaag-icon-button-hover-color)}.denhaag-datepicker__calendar-navigation.denhaag-datepicker__calendar-navigation--focus,.denhaag-datepicker__calendar-navigation:focus-visible{color:var(--denhaag-icon-button-focus-color);outline-color:var(--denhaag-icon-button-focus-outline-color);outline-offset:var(--denhaag-icon-button-focus-outline-offset);outline-style:var(--denhaag-icon-button-focus-outline-style);outline-width:var(--denhaag-icon-button-focus-outline-width)}.denhaag-datepicker__calendar-navigation .denhaag-icon{font-size:var(--denhaag-datepicker-calendar-navigation-font-size)}.denhaag-datepicker__calendar-heading{color:var(--denhaag-datepicker-calendar-heading-color);font-family:var(--denhaag-datepicker-font-family);font-size:var(--denhaag-datepicker-calendar-day-font-size);font-weight:var(--denhaag-datepicker-calendar-heading-font-weight);height:var(--denhaag-datepicker-calendar-day-width);line-height:var(--denhaag-datepicker-calendar-day-line-height);padding-block-end:var(--denhaag-datepicker-calendar-heading-padding-block-end);padding-block-start:0;padding-inline-end:0;padding-inline-start:0;width:var(--denhaag-datepicker-calendar-day-width)}.denhaag-datepicker__calendar-table{border-collapse:separate;border-spacing:var(--denhaag-datepicker-calendar-table-border-spacing);margin-block-start:calc(var(--denhaag-datepicker-calendar-table-border-spacing)*-1)}.denhaag-datepicker__calendar-day{background:none;border:none;border-radius:var(--denhaag-datepicker-calendar-day-border-radius);color:var(--denhaag-datepicker-calendar-day-color);font-family:var(--denhaag-datepicker-font-family);font-size:var(--denhaag-datepicker-calendar-day-font-size);height:var(--denhaag-datepicker-calendar-day-width);line-height:var(--denhaag-datepicker-calendar-day-line-height);outline:none;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;width:var(--denhaag-datepicker-calendar-day-width)}.denhaag-datepicker__calendar-day.denhaag-datepicker__calendar-day--hover,.denhaag-datepicker__calendar-day:hover{color:var(--denhaag-datepicker-calendar-day-hover-color)}.denhaag-datepicker__calendar-day.denhaag-datepicker__calendar-day--focus,.denhaag-datepicker__calendar-day:focus-visible{outline:var(--denhaag-focus-border)}.denhaag-datepicker__calendar-day.denhaag-datepicker__calendar-day--current{background-color:var(--denhaag-datepicker-calendar-day-current-background-color)}.denhaag-datepicker__calendar-day.denhaag-datepicker__calendar-day--selected{background-color:var(--denhaag-datepicker-calendar-day-selected-background-color);color:var(--denhaag-datepicker-calendar-day-selected-color)}.denhaag-datepicker__calendar-day.denhaag-datepicker__calendar-day--selected.denhaag-datepicker__calendar-day--hover,.denhaag-datepicker__calendar-day.denhaag-datepicker__calendar-day--selected:hover{background-color:var(--denhaag-datepicker-calendar-day-selected-hover-background-color);color:var(--denhaag-datepicker-calendar-day-selected-color)}";
styleInject$i(css_248z$n);/**
 * The DatePicker component allows the user to select a date.
 */
var Datepicker = function (_a) {
    var _b = _a.ref, ref = _b === void 0 ? React__default__default.useRef(null) : _b, _c = _a.inputRef, inputRef = _c === void 0 ? React__default__default.useRef(null) : _c, _d = _a.startDate, startDate = _d === void 0 ? new Date() : _d, _e = _a.locale, locale = _e === void 0 ? nl : _e, _f = _a.placeholder, placeholder = _f === void 0 ? 'Kies een datum' : _f, _g = _a.previousMonthLabel, previousMonthLabel = _g === void 0 ? 'Vorige maand' : _g, _h = _a.nextMonthLabel, nextMonthLabel = _h === void 0 ? 'Volgende maand' : _h, props = __rest$1$5(_a, ["ref", "inputRef", "startDate", "locale", "placeholder", "previousMonthLabel", "nextMonthLabel"]);
    var _j = React__default__default.useState({
        current: startDate,
        selected: undefined,
        opened: false,
        typing: false,
    }), state = _j[0], setState = _j[1];
    var currentDate = new Date();
    var today = setYear(setMonth(setDate(state.current, getDate(currentDate)), getMonth(currentDate)), getYear(currentDate));
    var openButtonRef = React__default__default.useRef(null);
    var backButtonRef = React__default__default.useRef(null);
    var currentButtonRef = React__default__default.useRef(null);
    var firstRender = React__default__default.useRef(true);
    var outsideClickListener = function (e) {
        var _a;
        if (!((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) && state.opened) {
            setState(__assign$1$5(__assign$1$5({}, state), { opened: false }));
        }
    };
    var outsideClickListenerCleanup = function () {
        document.removeEventListener('click', outsideClickListener);
    };
    React__default__default.useEffect(function () {
        if (state.opened) {
            document.addEventListener('click', outsideClickListener);
        }
        return outsideClickListenerCleanup;
    }, [ref, state.opened]);
    React__default__default.useEffect(function () {
        var _a;
        if (state.opened) {
            (_a = currentButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [state.opened && state.current]);
    React__default__default.useEffect(function () {
        var _a;
        if (props.onChange && !firstRender.current) {
            var event_1 = new Event('change');
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event_1);
            props.onChange(event_1);
        }
    }, [state.selected]);
    React__default__default.useEffect(function () {
        firstRender.current = false;
    }, []);
    var onKeyDownInput = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setState(__assign$1$5(__assign$1$5({}, state), { opened: true }));
        }
        else {
            setState(__assign$1$5(__assign$1$5({}, state), { typing: true }));
        }
    };
    var onKeyDownBack = function (e) {
        var _a, _b;
        switch (e.key) {
            case 'Escape':
                (_a = openButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                setState(__assign$1$5(__assign$1$5({}, state), { opened: false }));
                break;
            case 'Tab':
                if (e.shiftKey) {
                    e.preventDefault();
                    (_b = currentButtonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                    break;
                }
        }
    };
    var onKeyDownNext = function (e) {
        var _a;
        if (e.key === 'Escape') {
            (_a = openButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setState(__assign$1$5(__assign$1$5({}, state), { opened: false }));
        }
    };
    var onKeyDownDay = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                setState(__assign$1$5(__assign$1$5({}, state), { current: subDays(state.current, 1) }));
                break;
            case 'ArrowRight':
                setState(__assign$1$5(__assign$1$5({}, state), { current: addDays(state.current, 1) }));
                break;
            case 'ArrowUp':
                setState(__assign$1$5(__assign$1$5({}, state), { current: subDays(state.current, 7) }));
                break;
            case 'ArrowDown':
                setState(__assign$1$5(__assign$1$5({}, state), { current: addDays(state.current, 7) }));
                break;
            case 'Home':
                e.preventDefault();
                setState(__assign$1$5(__assign$1$5({}, state), { current: startOfWeek(state.current, { locale: locale }) }));
                break;
            case 'End':
                e.preventDefault();
                setState(__assign$1$5(__assign$1$5({}, state), { current: endOfWeek(state.current, { locale: locale }) }));
                break;
            case 'PageUp':
                e.preventDefault();
                if (e.shiftKey) {
                    var newDate = setDay(addWeeks(setDate(subYears(state.current, 1), 1), getWeekOfMonth(state.current, { locale: locale }) - 1), getDay(state.current), { locale: locale });
                    if (!isSameMonth(newDate, subYears(state.current, 1))) {
                        if (isSameMonth(newDate, subMonths(subYears(state.current, 1), 1))) {
                            newDate = addWeeks(newDate, 1);
                        }
                        else {
                            newDate = subWeeks(newDate, 1);
                        }
                    }
                    setState(__assign$1$5(__assign$1$5({}, state), { current: newDate }));
                }
                else {
                    var newDate = setDay(addWeeks(setDate(subMonths(state.current, 1), 1), getWeekOfMonth(state.current, { locale: locale }) - 1), getDay(state.current), { locale: locale });
                    if (!isSameMonth(newDate, subMonths(state.current, 1))) {
                        if (isSameMonth(newDate, state.current)) {
                            newDate = subWeeks(newDate, 1);
                        }
                        else {
                            newDate = addWeeks(newDate, 1);
                        }
                    }
                    setState(__assign$1$5(__assign$1$5({}, state), { current: newDate }));
                }
                break;
            case 'PageDown':
                e.preventDefault();
                if (e.shiftKey) {
                    var newDate = setDay(addWeeks(setDate(addYears(state.current, 1), 1), getWeekOfMonth(state.current, { locale: locale }) - 1), getDay(state.current), { locale: locale });
                    if (!isSameMonth(newDate, addYears(state.current, 1))) {
                        if (isSameMonth(newDate, subMonths(addYears(state.current, 1), 1))) {
                            newDate = addWeeks(newDate, 1);
                        }
                        else {
                            newDate = subWeeks(newDate, 1);
                        }
                    }
                    setState(__assign$1$5(__assign$1$5({}, state), { current: newDate }));
                }
                else {
                    var newDate = setDay(addWeeks(setDate(addMonths(state.current, 1), 1), getWeekOfMonth(state.current, { locale: locale }) - 1), getDay(state.current), { locale: locale });
                    if (!isSameMonth(newDate, addMonths(state.current, 1))) {
                        if (isSameMonth(newDate, state.current)) {
                            newDate = addWeeks(newDate, 1);
                        }
                        else {
                            newDate = subWeeks(newDate, 1);
                        }
                    }
                    setState(__assign$1$5(__assign$1$5({}, state), { current: newDate }));
                }
                break;
            case 'Escape':
                setState(__assign$1$5(__assign$1$5({}, state), { opened: false }));
                break;
            case 'Tab':
                if (!e.shiftKey) {
                    e.preventDefault();
                    (_a = backButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    break;
                }
        }
    };
    var renderDay = function (i, j) {
        var _a;
        var date = setDay(addWeeks(setDate(state.current, 1), i), (j + (((_a = locale.options) === null || _a === void 0 ? void 0 : _a.weekStartsOn) || 0)) % 7, {
            locale: locale,
        });
        if (isSameMonth(date, state.current)) {
            return (React__default__default.createElement("td", { key: "datepicker-column-".concat(i, "-").concat(j), "aria-selected": state.selected && isEqual(state.selected, date) ? 'true' : undefined },
                React__default__default.createElement("button", { type: "button", className: clsx$1$7('denhaag-datepicker__calendar-day', {
                        'denhaag-datepicker__calendar-day--current': isEqual(today, date),
                        'denhaag-datepicker__calendar-day--selected': state.selected && isEqual(state.selected, date),
                    }), tabIndex: isEqual(state.current, date) ? 0 : -1, ref: isEqual(state.current, date) ? currentButtonRef : null, onClick: function () {
                        setState(__assign$1$5(__assign$1$5({}, state), { selected: date, opened: false }));
                    }, onKeyDown: onKeyDownDay }, date.getDate())));
        }
        return React__default__default.createElement("td", { key: "datepicker-column-".concat(i, "-").concat(j) });
    };
    var rootStyles = clsx$1$7('denhaag-datepicker', {
        'denhaag-datepicker--error': props.error,
        'denhaag-datepicker--disabled': props.disabled,
        'denhaag-datepicker--has-value': state.selected || state.typing,
    }, props.className);
    return (React__default__default.createElement("div", { className: rootStyles, ref: ref, "data-placeholder": placeholder },
        React__default__default.createElement("button", { type: "button", className: "denhaag-datepicker__button", "aria-label": placeholder, onClick: function () {
                setState(__assign$1$5(__assign$1$5({}, state), { opened: !state.opened }));
            }, tabIndex: props.disabled ? -1 : 0, ref: openButtonRef },
            React__default__default.createElement(CalendarIcon, null)),
        React__default__default.createElement("input", { disabled: props.disabled, type: "date", className: "denhaag-datepicker__input", ref: inputRef, value: state.selected ? formatISO(state.selected, { representation: 'date' }) : '', onChange: function (event) {
                setState(__assign$1$5(__assign$1$5({}, state), { current: event.target.value && new Date(event.target.value).getDate()
                        ? new Date(event.target.value)
                        : state.current, selected: event.target.value !== undefined
                        ? new Date(event.target.value).getDate()
                            ? new Date(event.target.value)
                            : state.selected
                        : undefined }));
            }, onClick: function (event) {
                var _a;
                event.preventDefault();
                if (state.opened) {
                    (_a = currentButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                else {
                    setState(__assign$1$5(__assign$1$5({}, state), { opened: true }));
                }
            }, onKeyDown: onKeyDownInput, tabIndex: props.disabled ? -1 : 0 }),
        props.error && React__default__default.createElement(AlertTriangleIcon, { className: "denhaag-datepicker__error-icon" }),
        React__default__default.createElement("div", { className: clsx$1$7('denhaag-datepicker__calendar', { 'denhaag-datepicker__calendar--hidden': !state.opened }), role: "dialog", "aria-modal": "true", "aria-label": placeholder, "aria-live": "polite" },
            React__default__default.createElement("div", { className: "denhaag-datepicker__calendar-header" },
                React__default__default.createElement("button", { type: "button", className: "denhaag-datepicker__calendar-navigation", onClick: function () {
                        setState(__assign$1$5(__assign$1$5({}, state), { current: subMonths(state.current, 1) }));
                    }, ref: backButtonRef, onKeyDown: onKeyDownBack, "aria-label": previousMonthLabel },
                    React__default__default.createElement(ChevronLeftIcon, null)),
                React__default__default.createElement("span", { className: "denhaag-datepicker__calendar-month", "aria-live": "polite" },
                    React__default__default.createElement("time", { dateTime: format(state.current, 'yyyy-MM') }, format(state.current, 'MMMM yyyy', { locale: locale }))),
                React__default__default.createElement("button", { type: "button", className: "denhaag-datepicker__calendar-navigation", onClick: function () {
                        setState(__assign$1$5(__assign$1$5({}, state), { current: addMonths(state.current, 1) }));
                    }, onKeyDown: onKeyDownNext, "aria-label": nextMonthLabel },
                    React__default__default.createElement(ChevronRightIcon$1, null))),
            React__default__default.createElement("table", { className: "denhaag-datepicker__calendar-table", role: "grid", "aria-label": format(state.current, 'MMMM yyyy', { locale: locale }) },
                React__default__default.createElement("tbody", null,
                    React__default__default.createElement("tr", null, Array.from(Array(7)).map(function (_, i) {
                        var _a, _b, _c, _d;
                        return (React__default__default.createElement("th", { key: "datepicker-day-".concat(i), className: "denhaag-datepicker__calendar-heading", abbr: (_a = locale.localize) === null || _a === void 0 ? void 0 : _a.day((i + (((_b = locale.options) === null || _b === void 0 ? void 0 : _b.weekStartsOn) || 0)) % 7), scope: "col" }, (_c = locale.localize) === null || _c === void 0 ? void 0 : _c.day((i + (((_d = locale.options) === null || _d === void 0 ? void 0 : _d.weekStartsOn) || 0)) % 7, { width: 'short' })));
                    })),
                    Array.from(Array(getWeeksInMonth(state.current, { locale: locale }))).map(function (_, i) { return (React__default__default.createElement("tr", { key: "datepicker-row-".concat(i) }, Array.from(Array(7)).map(function (_, j) { return renderDay(i, j); }))); }))))));
};function styleInject$h(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$m = ".denhaag-divider{background:var(--denhaag-divider-border-color);border:0;flex-shrink:0;height:var(--denhaag-divider-border-width);margin-block-end:var(--denhaag-divider-margin-block-end);margin-block-start:var(--denhaag-divider-margin-block-start)}.denhaag-divider--vertical{height:inherit;margin-inline-end:var(--denhaag-divider-margin-inline-end);margin-inline-start:var(--denhaag-divider-margin-inline-start);width:var(--denhaag-divider-border-width)}";
styleInject$h(css_248z$m);/**
 * A thin line that groups content in lists and layouts.
 * @param props The properties of a Divider component.
 * @constructor Constructs an instance of Divider.
 */
var Divider = function (props) {
    var classes = {
        root: 'denhaag-divider',
        vertical: 'denhaag-divider--vertical',
    };
    return (React__default__default.createElement(Divider$1, { className: props.className, variant: 'fullWidth', classes: classes, role: 'presentation', orientation: props.orientation }));
};var __assign$i = function() {
    __assign$i = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$i.apply(this, arguments);
};/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 * -   FormFieldLabel
 * -   FormHelperText
 * -   Input
 * -   InputLabel
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */
var FormControl = function (props) {
    return React__default__default.createElement(FormControl$1, __assign$i({}, props));
};var __assign$h = function() {
    __assign$h = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$h.apply(this, arguments);
};

function __rest$c(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$g(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$g(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$g () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$g(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function styleInject$g(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$l = ".denhaag-form-control-label__label,.utrecht-form-label{color:var(--utrecht-form-label-color);font-size:var(--utrecht-form-label-font-size);font-weight:var(--utrecht-form-label-font-weight)}.utrecht-form-label--checkbox{color:var(--utrecht-form-label-checkbox-color,var(--utrecht-form-label-color));font-weight:var(--utrecht-form-label-checkbox-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-label--checked{font-weight:var(--utrecht-form-label-checked-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-label--disabled{cursor:var(--utrecht-action-disabled-cursor);font-weight:var(--utrecht-form-label-disabled-color,var(--utrecht-form-label-color))}.utrecht-form-label--radio{color:var(--utrecht-form-label-checkbox-color,var(--utrecht-form-label-color));font-weight:var(--utrecht-form-label-radio-font-weight,var(--utrecht-form-label-font-weight))}.denhaag-form-control-label{align-items:flex-start;cursor:pointer;display:flex;margin-block-end:var(--denhaag-form-control-label-margin-block-end)}.denhaag-form-control-label__input{align-items:center;display:inline-flex;height:calc(var(--denhaag-typography-scale-base-line-height)*var(--utrecht-form-label-font-size));margin-inline-end:var(--denhaag-form-control-label-input-margin-inline-end)}.denhaag-form-control-label__label{font-weight:var(--denhaag-typography-weight-regular);line-height:var(--denhaag-typography-scale-base-line-height)}.denhaag-form-control-label.denhaag-form-control-label--disabled{cursor:default}";
styleInject$g(css_248z$l);/**
 * FormControlLabels allow the developer to add a label to some components
 */
var FormControlLabel = function (_a) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, input = _a.input, label = _a.label, props = __rest$c(_a, ["className", "disabled", "input", "label"]);
    var classes = clsx$g('denhaag-form-control-label', { 'denhaag-form-control-label--disabled': disabled }, className);
    return (React__default__default.createElement("label", __assign$h({ className: classes }, props),
        React__default__default.createElement("span", { className: "denhaag-form-control-label__input" }, input),
        React__default__default.createElement("span", { className: "denhaag-form-control-label__label" }, label)));
};var __assign$g = function() {
    __assign$g = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$g.apply(this, arguments);
};

function __rest$b(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function styleInject$f(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$k = ".denhaag-form-field__label,.utrecht-form-label{color:var(--utrecht-form-label-color);font-size:var(--utrecht-form-label-font-size);font-weight:var(--utrecht-form-label-font-weight)}.utrecht-form-label--checkbox{color:var(--utrecht-form-label-checkbox-color,var(--utrecht-form-label-color));font-weight:var(--utrecht-form-label-checkbox-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-label--checked{font-weight:var(--utrecht-form-label-checked-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-label--disabled{cursor:var(--utrecht-action-disabled-cursor);font-weight:var(--utrecht-form-label-disabled-color,var(--utrecht-form-label-color))}.utrecht-form-label--radio{color:var(--utrecht-form-label-checkbox-color,var(--utrecht-form-label-color));font-weight:var(--utrecht-form-label-radio-font-weight,var(--utrecht-form-label-font-weight))}.denhaag-form-field{--denhaag-form-input-margin-block-end:8px;border:0;margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}.denhaag-form-field__label{line-height:var(--denhaag-typography-scale-base-line-height);margin-block-end:var(--denhaag-form-field-label-margin-block-end);padding-inline-end:0;padding-inline-start:0}.denhaag-form-field__description{color:var(--denhaag-form-field-description-color);font-family:var(--denhaag-form-field-description-font-family);font-size:var(--denhaag-form-field-description-font-size);font-weight:var(--denhaag-form-field-description-font-weight);line-height:var(--denhaag-form-field-description-line-height)}.denhaag-form-field--error .denhaag-form-field__description{color:var(--denhaag-form-field-description-error-color)}";
styleInject$f(css_248z$k);function toVal$f(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$f(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$f () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$f(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var FormFieldLabel = function (_a) {
    var className = _a.className, props = __rest$b(_a, ["className"]);
    var classes = clsx$f('denhaag-form-field__label', className);
    return (React__default__default.createElement("label", __assign$g({ className: classes }, props), props.children));
};
var FormFieldInput = function (_a) {
    var className = _a.className, props = __rest$b(_a, ["className"]);
    var classes = clsx$f('denhaag-form-field__input', className);
    return (React__default__default.createElement("div", __assign$g({ className: classes }, props), props.children));
};
var FormFieldDescription = function (_a) {
    var className = _a.className, props = __rest$b(_a, ["className"]);
    var classes = clsx$f('denhaag-form-field__description', className);
    return (React__default__default.createElement("span", __assign$g({ className: classes }, props), props.children));
};
var FormField = function (_a) {
    var className = _a.className, error = _a.error, props = __rest$b(_a, ["className", "error"]);
    var classes = clsx$f('denhaag-form-field', { 'denhaag-form-field--error': error }, className);
    return (React__default__default.createElement("div", __assign$g({ className: classes }, props), props.children));
};
var FormFieldGroup = function (_a) {
    var className = _a.className, error = _a.error, props = __rest$b(_a, ["className", "error"]);
    var classes = clsx$f('denhaag-form-field', { 'denhaag-form-field--error': error }, className);
    return (React__default__default.createElement("fieldset", __assign$g({ className: classes }, props), props.children));
};
var FormFieldGroupLabel = function (_a) {
    var className = _a.className, props = __rest$b(_a, ["className"]);
    var classes = clsx$f('denhaag-form-field__label', className);
    return (React__default__default.createElement("legend", __assign$g({ className: classes }, props), props.children));
};function toVal$1$6(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$6(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$6 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$6(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function styleInject$1$6(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$9 = ".utrecht-heading-1{--utrecht-heading-1-color:var(--denhaag-heading-color);--utrecht-heading-1-line-height:var(--denhaag-heading-line-height);font-family:var(--utrecht-heading-1-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-1-font-size);font-weight:var(--utrecht-heading-1-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-1-margin-block-end);margin-block-start:var(--utrecht-heading-1-margin-block-start)}.utrecht-heading-1--distanced{--utrecht-heading-1-margin-block-start:var(--utrecht-heading-1-distanced-margin-block-start);--utrecht-heading-1-margin-block-end:var(--utrecht-heading-1-distanced-margin-block-end)}.utrecht-heading-1+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-1-font-size)/4)}[class^=denhaag-]+.utrecht-heading-1{--utrecht-heading-1-margin-block-start:calc(var(--utrecht-heading-1-font-size)*1.125)}.utrecht-heading-2{--utrecht-heading-2-line-height:var(--denhaag-heading-line-height);--utrecht-heading-2-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-2-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-2-font-size);font-weight:var(--utrecht-heading-2-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-2-margin-block-end);margin-block-start:var(--utrecht-heading-2-margin-block-start)}.utrecht-heading-2--distanced{--utrecht-heading-2-margin-block-start:var(--utrecht-heading-2-distanced-margin-block-start);--utrecht-heading-2-margin-block-end:var(--utrecht-heading-2-distanced-margin-block-end)}.utrecht-heading-2+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-2-font-size)/4)}[class^=denhaag-]+.utrecht-heading-2{--utrecht-heading-2-margin-block-start:calc(var(--utrecht-heading-2-font-size)*1.125)}.utrecht-heading-3{--utrecht-heading-3-line-height:var(--denhaag-heading-line-height);--utrecht-heading-3-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-3-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-3-font-size);font-weight:var(--utrecht-heading-3-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-3-margin-block-end);margin-block-start:var(--utrecht-heading-3-margin-block-start)}.utrecht-heading-3--distanced{--utrecht-heading-3-margin-block-start:var(--utrecht-heading-3-distanced-margin-block-start);--utrecht-heading-3-margin-block-end:var(--utrecht-heading-3-distanced-margin-block-end)}.utrecht-heading-3+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-3-font-size)/4)}[class^=denhaag-]+.utrecht-heading-3{--utrecht-heading-3-margin-block-start:calc(var(--utrecht-heading-3-font-size)*1.125)}.utrecht-heading-4{--utrecht-heading-4-line-height:var(--denhaag-heading-line-height);--utrecht-heading-4-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-4-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-4-font-size);font-weight:var(--utrecht-heading-4-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-4-margin-block-end);margin-block-start:var(--utrecht-heading-4-margin-block-start)}.utrecht-heading-4--distanced{--utrecht-heading-4-margin-block-start:var(--utrecht-heading-4-distanced-margin-block-start);--utrecht-heading-4-margin-block-end:var(--utrecht-heading-4-distanced-margin-block-end)}.utrecht-heading-4+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-4-font-size)/4)}[class^=denhaag-]+.utrecht-heading-4{--utrecht-heading-4-margin-block-start:calc(var(--utrecht-heading-4-font-size)*1.125)}.utrecht-heading-5{--utrecht-heading-5-line-height:var(--denhaag-heading-line-height);--utrecht-heading-5-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-5-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-5-font-size);font-weight:var(--utrecht-heading-5-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-5-margin-block-end);margin-block-start:var(--utrecht-heading-5-margin-block-start)}.utrecht-heading-5--distanced{--utrecht-heading-5-margin-block-start:var(--utrecht-heading-5-distanced-margin-block-start);--utrecht-heading-5-margin-block-end:var(--utrecht-heading-5-distanced-margin-block-end)}.utrecht-heading-5+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-5-font-size)/4)}[class^=denhaag-]+.utrecht-heading-5{--utrecht-heading-5-margin-block-start:calc(var(--utrecht-heading-5-font-size)*1.125)}";
styleInject$1$6(css_248z$1$9);function toVal$e(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$e(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$e () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$e(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var Heading5$1 = function (props) {
    var rootClassNames = clsx$e('utrecht-heading-5', 'utrecht-heading-5--distanced', props.className);
    return React__default__default.createElement("h5", { className: rootClassNames }, props.children);
};var css_248z$2$5 = ".utrecht-paragraph{color:var(--utrecht-paragraph-color,var(--utrecht-document-color,inherit));font-family:var(--utrecht-paragraph-font-family,var(--utrecht-document-font-family,inherit));font-size:var(--utrecht-paragraph-font-size,var(--utrecht-document-font-size,inherit));font-weight:var(--utrecht-paragraph-font-weight,inherit);line-height:var(--utrecht-paragraph-line-height,var(--utrecht-document-line-height,normal));margin-block-end:var(--utrecht-paragraph-margin-block-end);margin-block-start:var(--utrecht-paragraph-margin-block-start)}.utrecht-paragraph--lead{font-size:var(--utrecht-paragraph-lead-font-size,inherit);font-weight:var(--utrecht-paragraph-lead-font-weight,inherit);line-height:var(--utrecht-paragraph-lead-line-height,inherit)}.utrecht-paragraph--distanced{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-distanced-margin-block-start);--utrecht-paragraph-margin-block-end:var(--utrecht-paragraph-distanced-margin-block-end)}.denhaag-paragraph--detail{font-family:var(--denhaag-posttypelabel-font-family,inherit);font-size:var(--denhaag-posttypelabel-font-size,.75rem);letter-spacing:var(--denhaag-posttypelabel-letter-spacing,1px);line-height:var(--denhaag-posttypelabel-line-height,1.5);text-transform:var(--denhaag-posttypelabel-text-transform,uppercase)}.utrecht-paragraph+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-paragraph-margin-block-start,inherit)}.utrecht-paragraph--lead+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-lead-paragraph-margin-block-start,inherit)}.denhaag-list+.utrecht-paragraph,.denhaag-list__wrapper+.utrecht-paragraph,.denhaag-ordered-list+.utrecht-paragraph,.denhaag-unordered-list+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-list-margin-block-start,inherit)}.denhaag-list+.utrecht-paragraph--lead,.denhaag-list__wrapper+.utrecht-paragraph--lead,.denhaag-ordered-list+.utrecht-paragraph--lead,.denhaag-unordered-list+.utrecht-paragraph--lead{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-lead-list-margin-block-start,inherit)}";
styleInject$1$6(css_248z$2$5);var Paragraph$1 = function (props) {
    var rootClassNames = clsx$e('utrecht-paragraph', 'utrecht-paragraph--distanced', props.className);
    return React__default__default.createElement("p", { className: rootClassNames },
        " ",
        props.children);
};function styleInject$e(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$j = ".denhaag-form-group{--utrecht-heading-5-color:var(--denhaag-form-group-label-color);--utrecht-paragraph-font-size:var(--denhaag-form-group-helper-text-size);--denhaag-paragraph-color:var(--denhaag-form-group-helper-text-color);--utrecht-paragraph-margin-block-start:var(--denhaag-form-group-helper-text-margin-block-start);--denhaag-form-control-label-margin-block-end:0;--denhaag-form-control-label-margin-inline-start:0;display:flex;flex-direction:column;margin-block-end:var(--denhaag-form-group-margin-block-end);margin-block-start:var(--denhaag-form-group-margin-block-start);margin-inline-end:var(--denhaag-form-group-margin-inline-end);margin-inline-start:var(--denhaag-form-group-margin-inline-start)}.denhaag-form-group--error{--denhaag-paragraph-color:var(--denhaag-form-group-helper-text-error-color)}";
styleInject$e(css_248z$j);/**
 *  FormGroup wraps controls such as Checkbox and Switch.
 *  For the Radio, you should be using the RadioGroup component instead of this one.
 */
var FormGroup = function (props) {
    var rootStyles = clsx$1$6('denhaag-form-group', {
        'denhaag-form-group--error': props.error,
    });
    return (React__default__default.createElement("div", { className: rootStyles },
        props.label && React__default__default.createElement(Heading5$1, null, props.label),
        props.children,
        props.helperText && React__default__default.createElement(Paragraph$1, null, props.helperText)));
};var __assign$2$2 = function() {
    __assign$2$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2$2.apply(this, arguments);
};

function __rest$2$2(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var __assign$1$4 = function() {
    __assign$1$4 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$4.apply(this, arguments);
};

function __rest$1$4(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$1$5(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$5(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$5 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$5(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function styleInject$2$2(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$2$4 = ".denhaag-link{color:var(--denhaag-link-color);cursor:var(--denhaag-link-cursor,pointer);font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;padding-block-end:var(--denhaag-link-padding);padding-block-start:var(--denhaag-link-padding);position:relative;text-decoration:underline}.denhaag-link--with-icon{text-decoration:none}.denhaag-link--with-icon-start{padding-inline-start:calc(var(--denhaag-link-icon-size) + var(--denhaag-link-icon-margin-start))}.denhaag-link--with-icon-end{padding-inline-end:calc(var(--denhaag-link-icon-size) + var(--denhaag-link-icon-margin-end))}.denhaag-link--focus,.denhaag-link:focus{--denhaag-link-color:var(--denhaag-link-focus-color);outline:var(--denhaag-link-focus-outline)}.denhaag-link--hover,.denhaag-link:hover{--denhaag-link-color:var(--denhaag-link-hover-color);cursor:pointer}.denhaag-link--disabled,.denhaag-link--disabled--hover,.denhaag-link--disabled:hover{--denhaag-link-color:var(--denhaag-link-disabled-color);--denhaag-link-cursor:none;pointer-events:none}.denhaag-link__icon{align-items:center;display:inline-flex;height:100%;justify-content:center;position:absolute;top:0;vertical-align:text-top;width:var(--denhaag-link-icon-size)}.denhaag-link--with-icon-start .denhaag-link__icon{left:0}.denhaag-link--with-icon-end .denhaag-link__icon{right:0}.denhaag-link__icon>:first-child{font-size:inherit;height:var(--denhaag-link-icon-size);width:inherit}.denhaag-link__sr-only{clip:rect(0,0,0,0);border:0;height:1px;margin-block-end:-1px;margin-block-start:-1px;margin-inline-end:-1px;margin-inline-start:-1px;overflow:hidden;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;position:absolute;width:1px}";
styleInject$2$2(css_248z$2$4);/**
 * An easily customizable anchor element.
 * @param props The properties of a Link component.
 * @constructor Constructs an instance of Link.
 */
var Link$1 = function (_a) {
    var href = _a.href, id = _a.id, _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.icon, icon = _d === void 0 ? undefined : _d, _e = _a.iconAlign, iconAlign = _e === void 0 ? 'end' : _e, _f = _a.tabIndex, tabIndex = _f === void 0 ? 0 : _f, _g = _a.component, component = _g === void 0 ? undefined : _g, props = __rest$1$4(_a, ["href", "id", "children", "disabled", "icon", "iconAlign", "tabIndex", "component"]);
    var rootClassNames = clsx$1$5('denhaag-link', {
        'denhaag-link--disabled': disabled,
        'denhaag-link--with-icon': icon !== undefined,
        'denhaag-link--with-icon-start': icon !== undefined && iconAlign === 'start',
        'denhaag-link--with-icon-end': icon !== undefined && iconAlign === 'end',
    }, props.className);
    var iconClassName = clsx$1$5('denhaag-link__icon');
    var iconWrapped = React__default__default.createElement("span", { className: iconClassName }, icon);
    var Component = component || 'a';
    return (React__default__default.createElement(Component, __assign$1$4({ id: id, href: href, tabIndex: disabled ? -1 : tabIndex }, props, { className: rootClassNames }),
        icon !== undefined && iconAlign === 'start' ? iconWrapped : '',
        React__default__default.createElement("span", null, children),
        icon !== undefined && iconAlign === 'end' ? iconWrapped : ''));
};var __assign$f = function() {
    __assign$f = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};

function __rest$a(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$d(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$d(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$d () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$d(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$5 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$a(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$d({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$f({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$1$5(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$8 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$1$5(css_248z$1$8);var _path$I;

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

function SvgArrowLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$K({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$I || (_path$I = /*#__PURE__*/React__default.createElement("path", {
    d: "M11.707 18.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 111.414 1.414L7.414 11H19a1 1 0 110 2H7.414l4.293 4.293a1 1 0 010 1.414z",
    fill: "currentColor"
  })));
}

var MemoSvgArrowLeft = /*#__PURE__*/React__default.memo(SvgArrowLeft);var buildIcon$5 = function (svg, props) { return (React__default__default.createElement(SvgIcon$5, __assign$f({ component: svg }, props))); };
// Arrows
var ArrowLeftIcon = function (props) { return buildIcon$5(MemoSvgArrowLeft, props); };function styleInject$d(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$i = ".denhaag-form-progress{display:flex;flex-direction:column}.denhaag-form-progress__header{align-items:center;display:flex;justify-content:center;margin-block-end:var(--denhaag-form-progress-header-margin-block-end);position:relative}.denhaag-form-progress__previous{inset-inline-start:0;position:absolute}.denhaag-form-progress__label{color:var(--denhaag-form-progress-label-color);font-family:var(--denhaag-form-progress-label-font-family);font-size:var(--denhaag-form-progress-label-font-size);font-weight:var(--denhaag-form-progress-label-font-weight);line-height:var(--denhaag-form-progress-label-line-height)}.denhaag-form-progress__progress{appearance:none;background-color:var(--denhaag-form-progress-progress-background-color);border:none;height:var(--denhaag-form-progress-progress-height);width:100%}.denhaag-form-progress__progress::-webkit-progress-bar{background-color:var(--denhaag-form-progress-progress-background-color)}.denhaag-form-progress__progress::-moz-progress-bar,.denhaag-form-progress__progress::-webkit-progress-value{background-color:var(--denhaag-form-progress-progress-bar-background-color)}";
styleInject$d(css_248z$i);/**
 * Primary UI component for user interaction
 */
var FormProgress = function (_a) {
    var value = _a.value, max = _a.max, label = _a.label, _b = _a.previousHref, previousHref = _b === void 0 ? 'javascript:history.back()' : _b, _c = _a.previousLabel, previousLabel = _c === void 0 ? 'Vorige stap' : _c, _d = _a.id, id = _d === void 0 ? 'denhaag-form-progress-bar' : _d, props = __rest$2$2(_a, ["value", "max", "label", "previousHref", "previousLabel", "id"]);
    return (React__default__default.createElement("div", __assign$2$2({ className: "denhaag-form-progress" }, props),
        React__default__default.createElement("div", { className: "denhaag-form-progress__header" },
            value > 1 && (React__default__default.createElement("div", { className: "denhaag-form-progress__previous" },
                React__default__default.createElement(Link$1, { href: previousHref, icon: React__default__default.createElement(ArrowLeftIcon, null), iconAlign: "start" }, previousLabel))),
            React__default__default.createElement("label", { className: "denhaag-form-progress__label", htmlFor: id }, label)),
        React__default__default.createElement("progress", { id: id, className: "denhaag-form-progress__progress", max: max, value: value })));
};var __assign$e = function() {
    __assign$e = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$e.apply(this, arguments);
};var InputLabel = function (props) {
    return React__default__default.createElement(InputLabel$1, __assign$e({}, props), props.children);
};var __assign$d = function() {
    __assign$d = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$d.apply(this, arguments);
};

function __rest$9(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function styleInject$c(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$7 = ".denhaag-icon-button--hover,.denhaag-icon-button:hover{background-color:transparent}";
styleInject$c(css_248z$1$7);var css_248z$h = ".denhaag-icon-button{appearance:none;background-color:transparent;border:0;border-radius:0;color:var(--denhaag-icon-button-color);cursor:pointer;display:inline-flex;outline:0;padding-block-end:var(--denhaag-icon-button-padding-block-end);padding-block-start:var(--denhaag-icon-button-padding-block-start);padding-inline-end:var(--denhaag-icon-button-padding-inline-end);padding-inline-start:var(--denhaag-icon-button-padding-inline-start)}.denhaag-icon-button--hover,.denhaag-icon-button:hover{color:var(--denhaag-icon-button-hover-color)}.denhaag-icon-button--focus,.denhaag-icon-button:focus{color:var(--denhaag-icon-button-focus-color);outline-color:var(--denhaag-icon-button-focus-outline-color);outline-offset:var(--denhaag-icon-button-focus-outline-offset);outline-style:var(--denhaag-icon-button-focus-outline-style);outline-width:var(--denhaag-icon-button-focus-outline-width)}";
styleInject$c(css_248z$h);function toVal$c(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$c(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$c () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$c(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Displays a Button with an Icon as content.
 * @param props The properties of an IconButton component.
 * @constructor Constructs an instance of IconButton.
 */
var IconButton$1 = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = __rest$9(_a, ["disabled"]);
    var rootClassNames = clsx$c('denhaag-icon-button', props.className);
    return (React__default__default.createElement(IconButton$3, __assign$d({}, props, { className: rootClassNames, disabled: disabled, disableRipple: true, disableFocusRipple: true }), props.children));
};var __assign$c = function() {
    __assign$c = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};

function __rest$8(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$b(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$b(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$b () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$b(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function styleInject$b(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$g = ".denhaag-link{color:var(--denhaag-link-color);cursor:var(--denhaag-link-cursor,pointer);font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;padding-block-end:var(--denhaag-link-padding);padding-block-start:var(--denhaag-link-padding);position:relative;text-decoration:underline}.denhaag-link--with-icon{text-decoration:none}.denhaag-link--with-icon-start{padding-inline-start:calc(var(--denhaag-link-icon-size) + var(--denhaag-link-icon-margin-start))}.denhaag-link--with-icon-end{padding-inline-end:calc(var(--denhaag-link-icon-size) + var(--denhaag-link-icon-margin-end))}.denhaag-link--focus,.denhaag-link:focus{--denhaag-link-color:var(--denhaag-link-focus-color);outline:var(--denhaag-link-focus-outline)}.denhaag-link--hover,.denhaag-link:hover{--denhaag-link-color:var(--denhaag-link-hover-color);cursor:pointer}.denhaag-link--disabled,.denhaag-link--disabled--hover,.denhaag-link--disabled:hover{--denhaag-link-color:var(--denhaag-link-disabled-color);--denhaag-link-cursor:none;pointer-events:none}.denhaag-link__icon{align-items:center;display:inline-flex;height:100%;justify-content:center;position:absolute;top:0;vertical-align:text-top;width:var(--denhaag-link-icon-size)}.denhaag-link--with-icon-start .denhaag-link__icon{left:0}.denhaag-link--with-icon-end .denhaag-link__icon{right:0}.denhaag-link__icon>:first-child{font-size:inherit;height:var(--denhaag-link-icon-size);width:inherit}.denhaag-link__sr-only{clip:rect(0,0,0,0);border:0;height:1px;margin-block-end:-1px;margin-block-start:-1px;margin-inline-end:-1px;margin-inline-start:-1px;overflow:hidden;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;position:absolute;width:1px}";
styleInject$b(css_248z$g);/**
 * An easily customizable anchor element.
 * @param props The properties of a Link component.
 * @constructor Constructs an instance of Link.
 */
var Link = function (_a) {
    var href = _a.href, id = _a.id, _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.icon, icon = _d === void 0 ? undefined : _d, _e = _a.iconAlign, iconAlign = _e === void 0 ? 'end' : _e, _f = _a.tabIndex, tabIndex = _f === void 0 ? 0 : _f, _g = _a.component, component = _g === void 0 ? undefined : _g, props = __rest$8(_a, ["href", "id", "children", "disabled", "icon", "iconAlign", "tabIndex", "component"]);
    var rootClassNames = clsx$b('denhaag-link', {
        'denhaag-link--disabled': disabled,
        'denhaag-link--with-icon': icon !== undefined,
        'denhaag-link--with-icon-start': icon !== undefined && iconAlign === 'start',
        'denhaag-link--with-icon-end': icon !== undefined && iconAlign === 'end',
    }, props.className);
    var iconClassName = clsx$b('denhaag-link__icon');
    var iconWrapped = React__default__default.createElement("span", { className: iconClassName }, icon);
    var Component = component || 'a';
    return (React__default__default.createElement(Component, __assign$c({ id: id, href: href, tabIndex: disabled ? -1 : tabIndex }, props, { className: rootClassNames }),
        icon !== undefined && iconAlign === 'start' ? iconWrapped : '',
        React__default__default.createElement("span", null, children),
        icon !== undefined && iconAlign === 'end' ? iconWrapped : ''));
};var __assign$2$1 = function() {
    __assign$2$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2$1.apply(this, arguments);
};

function __rest$2$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$2$1(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$2$1(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$2$1 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$2$1(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function styleInject$2$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$7$1 = ".denhaag-list__wrapper{margin-block-end:var(--denhaag-list-wrapper-margin-block);margin-block-start:var(--denhaag-list-wrapper-margin-block);padding-block-end:var(--denhaag-list-wrapper-padding-block);padding-block-start:var(--denhaag-list-wrapper-padding-block)}.denhaag-list,.denhaag-list__wrapper.denhaag-list__wrapper--with-subheader{padding-block-start:0}.denhaag-list{list-style:none;margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;padding-block-end:0;padding-inline-end:0;padding-inline-start:0}";
styleInject$2$1(css_248z$7$1);/**
 * Primary UI component for user interaction
 */
var List = function (_a) {
    var subheader = _a.subheader, props = __rest$2$1(_a, ["subheader"]);
    var rootClassNames = clsx$2$1('denhaag-list__wrapper', {
        'denhaag-list__wrapper--with-subheader': subheader,
    }, props.className);
    return (React__default__default.createElement("div", __assign$2$1({}, props, { className: rootClassNames }),
        subheader,
        React__default__default.createElement("ul", { className: "denhaag-list" }, props.children)));
};var __assign$1$3 = function() {
    __assign$1$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$3.apply(this, arguments);
};

function __rest$1$3(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$1$4(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$4(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$4 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$4(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$4 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$1$3(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$1$4({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$1$3({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$1$4(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$6$1 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$1$4(css_248z$6$1);var _path$F;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function SvgChevronRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$H({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/React__default.createElement("path", {
    d: "M9.293 18.707a1 1 0 010-1.414L14.586 12 9.293 6.707a1 1 0 011.414-1.414l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0z",
    fill: "currentColor"
  })));
}

var MemoSvgChevronRight = /*#__PURE__*/React__default.memo(SvgChevronRight);var buildIcon$4 = function (svg, props) { return (React__default__default.createElement(SvgIcon$4, __assign$1$3({ component: svg }, props))); };
var ChevronRightIcon = function (props) { return buildIcon$4(MemoSvgChevronRight, props); };var __assign$b = function() {
    __assign$b = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$b.apply(this, arguments);
};

function __rest$7(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function styleInject$a(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$1$1 = ".denhaag-icon-button--hover,.denhaag-icon-button:hover{background-color:transparent}";
styleInject$a(css_248z$1$1$1);var css_248z$5$1 = ".denhaag-icon-button{appearance:none;background-color:transparent;border:0;border-radius:0;color:var(--denhaag-icon-button-color);cursor:pointer;display:inline-flex;outline:0;padding-block-end:var(--denhaag-icon-button-padding-block-end);padding-block-start:var(--denhaag-icon-button-padding-block-start);padding-inline-end:var(--denhaag-icon-button-padding-inline-end);padding-inline-start:var(--denhaag-icon-button-padding-inline-start)}.denhaag-icon-button--hover,.denhaag-icon-button:hover{color:var(--denhaag-icon-button-hover-color)}.denhaag-icon-button--focus,.denhaag-icon-button:focus{color:var(--denhaag-icon-button-focus-color);outline-color:var(--denhaag-icon-button-focus-outline-color);outline-offset:var(--denhaag-icon-button-focus-outline-offset);outline-style:var(--denhaag-icon-button-focus-outline-style);outline-width:var(--denhaag-icon-button-focus-outline-width)}";
styleInject$a(css_248z$5$1);function toVal$a(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$a(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$a () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$a(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Displays a Button with an Icon as content.
 * @param props The properties of an IconButton component.
 * @constructor Constructs an instance of IconButton.
 */
var IconButton = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = __rest$7(_a, ["disabled"]);
    var rootClassNames = clsx$a('denhaag-icon-button', props.className);
    return (React__default__default.createElement(IconButton$3, __assign$b({}, props, { className: rootClassNames, disabled: disabled, disableRipple: true, disableFocusRipple: true }), props.children));
};var css_248z$4$1 = ".denhaag-list__item-icon{color:var(--denhaag-list-item-icon-color);display:inline-flex;flex-shrink:0;margin-inline-end:var(--denhaag-list-item-icon-margin-inline-end)}";
styleInject$2$1(css_248z$4$1);/**
 * Primary UI component for user interaction
 */
var ListItemIcon = function (props) {
    return (React__default__default.createElement("div", __assign$2$1({}, props, { className: clsx$2$1('denhaag-list__item-icon', props.className) }), props.children));
};var css_248z$3$2 = ".denhaag-list__secondary-action{--denhaag-icon-button-padding-inline-start:0;--denhaag-icon-button-padding-inline-end:0;--denhaag-icon-button-padding-block-start:0;--denhaag-icon-button-padding-block-end:0;--denhaag-icon-button-hover-color:var(--denhaag-list-item-hover-color);color:var(--denhaag-list-item-secondary-action-color);display:flex;flex-shrink:0;margin-inline-start:calc(var(--denhaag-list-item-secondary-action-margin-inline-start))}";
styleInject$2$1(css_248z$3$2);/**
 * Primary UI component for user interaction
 */
var ListItemSecondaryAction = function (props) {
    return (React__default__default.createElement("div", __assign$2$1({}, props, { className: clsx$2$1('denhaag-list__secondary-action', props.className) }), props.children));
};var css_248z$2$3 = ".denhaag-list__item-text{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column}.denhaag-list__item-text-primary{color:var(--denhaag-list-item-text-primary-color);font-family:var(--denhaag-list-font-family);font-size:var(--denhaag-list-item-text-primary-font-size);font-weight:var(--denhaag-list-item-text-primary-font-weight);line-height:var(--denhaag-list-item-text-primary-line-height)}.denhaag-list__item-text-secondary{color:var(--denhaag-list-item-text-secondary-color);font-family:var(--denhaag-list-font-family);font-size:var(--denhaag-list-item-text-secondary-font-size);font-weight:var(--denhaag-list-item-text-secondary-font-weight);line-height:var(--denhaag-list-item-text-secondary-line-height);padding-block-end:var(--denhaag-list-item-text-secondary-padding-block-end)}";
styleInject$2$1(css_248z$2$3);/**
 * Primary UI component for user interaction
 */
var ListItemText = function (_a) {
    var primary = _a.primary, secondary = _a.secondary, props = __rest$2$1(_a, ["primary", "secondary"]);
    var rootClassNames = clsx$2$1('denhaag-list__item-text', {
        'denhaag-list__item-text--with-secondary': secondary,
    }, props.className);
    return (React__default__default.createElement("div", __assign$2$1({}, props, { className: rootClassNames }),
        primary && React__default__default.createElement("span", { className: "denhaag-list__item-text-primary" }, primary),
        secondary && React__default__default.createElement("span", { className: "denhaag-list__item-text-secondary" }, secondary)));
};var css_248z$1$6 = ".denhaag-list__item,.denhaag-list__item-button{align-items:center;display:flex;padding-block-end:var(--denhaag-list-item-padding-block);padding-block-start:var(--denhaag-list-item-padding-block);padding-inline-end:var(--denhaag-list-item-padding-inline);padding-inline-start:var(--denhaag-list-item-padding-inline)}.denhaag-list__item-button{background:none;border:0;cursor:pointer;flex:1 1 auto;outline:0}.denhaag-list__item-button.denhaag-list__item-button-hover .denhaag-list__item-icon,.denhaag-list__item-button.denhaag-list__item-button-hover .denhaag-list__item-text-primary,.denhaag-list__item-button.denhaag-list__item-button-hover .denhaag-list__secondary-action,.denhaag-list__item-button:hover .denhaag-list__item-icon,.denhaag-list__item-button:hover .denhaag-list__item-text-primary,.denhaag-list__item-button:hover .denhaag-list__secondary-action{color:var(--denhaag-list-item-hover-color)}.denhaag-list__item-button.denhaag-list__item-button-focus,.denhaag-list__item-button:focus{outline:var(--denhaag-focus-border)}.denhaag-list__item-button.denhaag-list__item-button-focus .denhaag-list__item-icon,.denhaag-list__item-button.denhaag-list__item-button-focus .denhaag-list__item-text-primary,.denhaag-list__item-button.denhaag-list__item-button-focus .denhaag-list__secondary-action,.denhaag-list__item-button:focus .denhaag-list__item-icon,.denhaag-list__item-button:focus .denhaag-list__item-text-primary,.denhaag-list__item-button:focus .denhaag-list__secondary-action{color:var(--denhaag-list-item-focus-color)}.denhaag-list__item-button.denhaag-list__item-button--active,.denhaag-list__item-button:active{outline:var(--denhaag-list-item-active-border-size) solid var(--denhaag-list-item-active-border-color)}.denhaag-list__item.denhaag-list__item--with-secondary,.denhaag-list__item.denhaag-list__item--with-secondary .denhaag-list__item-button{padding-block-end:var(--denhaag-list-item-secondary-padding-block);padding-block-start:var(--denhaag-list-item-secondary-padding-block)}.denhaag-list__item.denhaag-list__item--with-secondary .denhaag-list__item-text-primary{line-height:var(--denhaag-list-item-text-multiline-primary-line-height)}.denhaag-list__item.denhaag-list__item--nav{padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}";
styleInject$2$1(css_248z$1$6);/**
 * Primary UI component for user interaction
 */
var ListItem = function (_a) {
    var actionType = _a.actionType, onClick = _a.onClick, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, primaryText = _a.primaryText, secondaryText = _a.secondaryText, props = __rest$2$1(_a, ["actionType", "onClick", "leftIcon", "rightIcon", "primaryText", "secondaryText"]);
    var rootClassNames = clsx$2$1('denhaag-list__item', {
        'denhaag-list__item--with-secondary': secondaryText,
        'denhaag-list__item--nav': actionType && actionType === 'nav',
    }, props.className);
    var children = [];
    if (leftIcon) {
        children.push(React__default__default.createElement(ListItemIcon, { key: 0 }, leftIcon));
    }
    children.push(React__default__default.createElement(ListItemText, { key: 1, primary: primaryText, secondary: secondaryText }));
    if (actionType === 'nav') {
        children.push(React__default__default.createElement(ListItemSecondaryAction, { key: 2 },
            React__default__default.createElement(ChevronRightIcon, null)));
    }
    else if (actionType === 'action') {
        children.push(React__default__default.createElement(ListItemSecondaryAction, { key: 2 },
            React__default__default.createElement(IconButton, { className: "denhaag-icon-button", "aria-label": "Action", onClick: onClick }, rightIcon)));
    }
    if (actionType === 'nav') {
        return (React__default__default.createElement("li", __assign$2$1({}, props, { className: rootClassNames }),
            React__default__default.createElement("button", { className: "denhaag-list__item-button", onClick: onClick }, children)));
    }
    return (React__default__default.createElement("li", __assign$2$1({}, props, { className: rootClassNames }), children));
};var css_248z$f = ".denhaag-list__subheader{color:var(--denhaag-list-subheader-color);font-family:var(--denhaag-typography-sans-serif-font-family);font-size:var(--denhaag-typography-scale-base-font-size);font-weight:var(--denhaag-list-subheader-font-weight);line-height:var(--denhaag-list-subheader-line-height);margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;padding-block-end:var(--denhaag-list-item-padding-block);padding-block-start:var(--denhaag-list-item-padding-block);padding-inline-end:var(--denhaag-list-item-padding-inline);padding-inline-start:var(--denhaag-list-item-padding-inline)}";
styleInject$2$1(css_248z$f);/**
 * Primary UI component for user interaction
 */
var ListSubheader = function (props) {
    return (React__default__default.createElement("p", __assign$2$1({}, props, { className: clsx$2$1('denhaag-list__subheader', props.className) }), props.children));
};function styleInject$1$3(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$2$2 = ".denhaag-menu{column-gap:var(--denhaag-menu-group-spacing);display:flex}";
styleInject$1$3(css_248z$2$2);function toVal$1$3(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$3(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$3 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$3(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$1$2(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var __assign$a = function() {
    __assign$a = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};

function __rest$6(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$9(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$9(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$9 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$9(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$3 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$6(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$9({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$a({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$9(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$5 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$9(css_248z$1$5);var _path$G$1;

function _extends$I$1() { _extends$I$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I$1.apply(this, arguments); }

function SvgChevronDown$1(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$I$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G$1 || (_path$G$1 = /*#__PURE__*/React__default.createElement("path", {
    d: "M5.293 8.293a1 1 0 011.414 0L12 13.586l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

var MemoSvgChevronDown$1 = /*#__PURE__*/React__default.memo(SvgChevronDown$1);var buildIcon$3 = function (svg, props) { return (React__default__default.createElement(SvgIcon$3, __assign$a({ component: svg }, props))); };
var ChevronDownIcon$1 = function (props) { return buildIcon$3(MemoSvgChevronDown$1, props); };var css_248z$e = ".denhaag-menu-button{background-color:inherit;border:inherit;color:var(--denhaag-menu-button-color);cursor:pointer;display:inline-block;font-family:var(--denhaag-menu-button-font-family);font-size:var(--denhaag-menu-button-font-size);font-weight:var(--denhaag-menu-button-font-size);line-height:var(--denhaag-menu-button-line-height);padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0;text-align:center;text-decoration:none;user-select:none}.denhaag-menu-button--active,.denhaag-menu-button:active{color:var(--denhaag-menu-button-active-color);font-weight:var(--denhaag-menu-button-active-font-weight)}.denhaag-menu-button--focus,.denhaag-menu-button:focus{outline:var(--denhaag-focus-border)}.denhaag-menu-button--hover,.denhaag-menu-button:hover{color:var(--denhaag-menu-button-hover-color);text-decoration:none}.denhaag-menu-button__chevron .denhaag-icon{height:var(--denhaag-menu-button-chevron-size);padding-inline-start:var(--denhaag-menu-button-chevron-padding-inline-start);width:var(--denhaag-menu-button-chevron-size)}.denhaag-menu-button--active .denhaag-menu-button__chevron,.denhaag-menu-button:active .denhaag-menu-button__chevron{color:var(--denhaag-menu-button-chevron-active-color)}.denhaag-menu-button--hover .denhaag-menu-button__chevron,.denhaag-menu-button:hover .denhaag-menu-button__chevron{color:var(--denhaag-menu-button-chevron-hover-color)}.denhaag-menu-button:after{color:transparent;content:attr(title);display:block;font-weight:var(--denhaag-menu-button-active-font-weight);height:1px;overflow:hidden;visibility:hidden}.denhaag-menu-button--expandable:after{padding-inline-end:calc(var(--denhaag-menu-button-chevron-size) + var(--denhaag-menu-button-chevron-padding-inline-start))}";
styleInject$1$3(css_248z$e);var MenuButton = function (_a) {
    var _b;
    var _c = _a.active, active = _c === void 0 ? false : _c, props = __rest$1$2(_a, ["active"]);
    var className = clsx$1$3('denhaag-menu-button', {
        'denhaag-menu-button--active': active,
    }, props.className);
    return (React__default__default.createElement("a", { id: props.id, href: props.href, hrefLang: props.hrefLang, download: props.download, media: props.media, ping: props.ping, rel: props.rel, target: props.target, type: props.type, referrerPolicy: props.referrerPolicy, className: className, title: (_b = props.children) === null || _b === void 0 ? void 0 : _b.toString() }, props.children));
};
var MenuButtonExpandable = function (_a) {
    var _b;
    var _c = _a.active, active = _c === void 0 ? false : _c, props = __rest$1$2(_a, ["active"]);
    var rootClassNames = clsx$1$3('denhaag-menu-button', 'denhaag-menu-button--expandable', {
        'denhaag-menu-button--active': active,
    }, props.className);
    return (React__default__default.createElement("button", { id: props.id, onClick: props.onClick, className: rootClassNames, title: (_b = props.children) === null || _b === void 0 ? void 0 : _b.toString() },
        props.children,
        React__default__default.createElement("span", { className: "denhaag-menu-button__chevron" },
            React__default__default.createElement(ChevronDownIcon$1, { "aria-label": "ChevronDownIcon" }))));
};var Menu = function (props) {
    var rootClassNames = clsx$1$3('denhaag-menu', props.className);
    return (React__default__default.createElement("div", { className: rootClassNames, id: props.id }, props.children));
};var __assign$9 = function() {
    __assign$9 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};function toVal$8(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$8(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$8 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$8(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var PostTypeLabel = function (props) {
    return (React__default__default.createElement("p", __assign$9({}, props, { className: clsx$8('denhaag-posttypelabel', props.className) }), props.children));
};var __assign$1$2 = function() {
    __assign$1$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$2.apply(this, arguments);
};

function __rest$1$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$1$2(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$2(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$2 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$2(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var StepContext = React__default__default.createContext({
    context: { current: false, checked: false, expanded: false },
    setContext: function () { },
});
var Step = function (_a) {
    var children = _a.children, _b = _a.current, current = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.expanded, expanded = _d === void 0 ? false : _d, props = __rest$1$1(_a, ["children", "current", "checked", "expanded"]);
    var _e = React__default__default.useState({ current: current, checked: checked, expanded: expanded }), state = _e[0], setState = _e[1];
    var context = { context: state, setContext: setState };
    return (React__default__default.createElement(StepContext.Provider, { value: context },
        React__default__default.createElement("li", __assign$1$2({}, props, { className: clsx$1$2('denhaag-process-steps__step', state.checked && 'denhaag-process-steps__step--checked', state.current && 'denhaag-process-steps__step--current', state.expanded && 'denhaag-process-steps__step--expanded'), "aria-current": state.current ? 'step' : undefined }), children)));
};var __assign$8 = function() {
    __assign$8 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};

function __rest$5(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$7(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$7(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$7 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$7(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$2 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$5(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$7({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$8({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$1$2(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$4 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$1$2(css_248z$1$4);var _path$G;

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

function SvgChevronDown(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$I({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/React__default.createElement("path", {
    d: "M5.293 8.293a1 1 0 011.414 0L12 13.586l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

var MemoSvgChevronDown = /*#__PURE__*/React__default.memo(SvgChevronDown);var _path$E;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

function SvgChevronUp(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$G({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/React__default.createElement("path", {
    d: "M11.293 7.293a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L12 9.414l-5.293 5.293a1 1 0 01-1.414-1.414l6-6z",
    fill: "currentColor"
  })));
}

var MemoSvgChevronUp = /*#__PURE__*/React__default.memo(SvgChevronUp);var _path$y;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function SvgChecked(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path$y || (_path$y = /*#__PURE__*/React__default.createElement("path", {
    d: "M20.664 5.253a1 1 0 01.083 1.411l-10.666 12a1 1 0 01-1.495 0l-5.333-6a1 1 0 011.494-1.328l4.586 5.159 9.92-11.16a1 1 0 011.411-.082z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })));
}

var MemoSvgChecked = /*#__PURE__*/React__default.memo(SvgChecked);var buildIcon$2 = function (svg, props) { return (React__default__default.createElement(SvgIcon$2, __assign$8({ component: svg }, props))); };
var ChevronDownIcon = function (props) { return buildIcon$2(MemoSvgChevronDown, props); };
var ChevronUpIcon = function (props) { return buildIcon$2(MemoSvgChevronUp, props); };
var CheckedIcon = function (props) { return buildIcon$2(MemoSvgChecked, props); };var StepExpandedIcon = function (_a) {
    var className = _a.className, props = __rest$1$1(_a, ["className"]);
    var context = React__default__default.useContext(StepContext).context;
    return (React__default__default.createElement("div", __assign$1$2({}, props, { className: clsx$1$2('denhaag-process-steps__step-expanded-icon', context.expanded && 'denhaag-process-steps__step-expanded-icon--expanded', className) }), context.expanded ? React__default__default.createElement(ChevronUpIcon, null) : React__default__default.createElement(ChevronDownIcon, null)));
};var StepList = function (_a) {
    var className = _a.className, children = _a.children, props = __rest$1$1(_a, ["className", "children"]);
    return (React__default__default.createElement("ol", __assign$1$2({}, props, { className: clsx$1$2('denhaag-process-steps', className) }), children));
};var StepSection = function (_a) {
    var children = _a.children;
    return React__default__default.createElement("div", { className: "denhaag-process-steps__step-section" }, children);
};var StepHeader = function (_a) {
    var children = _a.children, props = __rest$1$1(_a, ["children"]);
    var _b = React__default__default.useContext(StepContext), context = _b.context, setContext = _b.setContext;
    return (React__default__default.createElement("button", __assign$1$2({}, props, { className: clsx$1$2('denhaag-process-steps__step-header', context.checked && 'denhaag-process-steps__step-header--checked', context.current && 'denhaag-process-steps__step-header--current'), onClick: function () {
            setContext(__assign$1$2(__assign$1$2({}, context), { expanded: !context.expanded }));
        }, "aria-expanded": context.expanded }), children));
};var StepHeading = function (_a) {
    var children = _a.children, props = __rest$1$1(_a, ["children"]);
    var context = React__default__default.useContext(StepContext).context;
    return (React__default__default.createElement("div", __assign$1$2({}, props, { className: clsx$1$2('denhaag-process-steps__step-heading', context.checked && 'denhaag-process-steps__step-heading--checked', context.current && 'denhaag-process-steps__step-heading--current') }), children));
};var StepMarker = function (_a) {
    var children = _a.children, props = __rest$1$1(_a, ["children"]);
    var context = React__default__default.useContext(StepContext).context;
    return (React__default__default.createElement("div", __assign$1$2({}, props, { className: clsx$1$2('denhaag-process-steps__step-marker', context.checked && 'denhaag-process-steps__step-marker--checked', context.current && 'denhaag-process-steps__step-marker--current') }), context.checked ? React__default__default.createElement(CheckedIcon, null) : children));
};var SubStep = function (_a) {
    var children = _a.children, checked = _a.checked;
    return (React__default__default.createElement("li", { className: clsx$1$2('denhaag-process-steps__sub-step', checked && 'denhaag-process-steps__sub-step--checked') }, children));
};var SubStepList = function (_a) {
    var children = _a.children;
    return React__default__default.createElement("ol", { className: 'denhaag-process-steps__sub-step-list' }, children);
};var SubStepMarker = function (props) { return (React__default__default.createElement("div", { className: clsx$1$2('denhaag-process-steps__sub-step-marker', 'denhaag-process-steps__sub-step-marker--checked', props.className) })); };var SubStepHeading = function (_a) {
    var children = _a.children;
    return (React__default__default.createElement("p", { className: 'denhaag-process-steps__sub-step-heading' }, children));
};function styleInject$8(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$d = ".denhaag-process-steps__step{padding-block-end:0;padding-block-start:0;position:relative}.denhaag-process-steps__step+.denhaag-process-steps__step{margin-block-start:var(--denhaag-process-steps-step-distance)}.denhaag-process-steps__step+.denhaag-process-steps__step:after,.denhaag-process-steps__step-line{content:\"\";height:calc(var(--denhaag-process-steps-step-distance) + 10px);left:calc(max(var(--denhaag-process-steps-step-marker-size, 2em), 32px)/2);outline:1px dashed var(--denhaag-process-steps-step-line-color);position:absolute;top:calc((var(--denhaag-process-steps-step-distance) + 10px)*-1)}.denhaag-process-steps__step+.denhaag-process-steps__step--checked:after,.denhaag-process-steps__step+.denhaag-process-steps__step--current:after,.denhaag-process-steps__step-line--connected{outline-color:var(--denhaag-process-steps-step-line-connected-color,var(--denhaag-process-steps-step-line-color));outline-style:solid}.denhaag-process-steps{--denhaag-process-steps-step-distance:40px;--denhaag-process-steps-sub-step-distance:24px;font-family:var(--denhaag-process-steps-font-family);font-size:var(--denhaag-process-steps-font-size);line-height:var(--denhaag-process-steps-line-height);list-style:none;margin-block-end:0;margin-block-start:0;padding-inline-start:0;position:relative}.denhaag-process-steps__step-marker{align-items:center;background-color:var(--denhaag-process-steps-step-marker-background-color);block-size:var(--denhaag-process-steps-step-marker-size,2em);border-color:var(--denhaag-process-steps-step-marker-border-color,transparent);border-radius:50%;border-style:solid;border-width:2px;box-sizing:border-box;color:var(--denhaag-process-steps-step-marker-color);display:flex;flex-grow:0;font-size:var(--denhaag-process-steps-step-marker-font-size);font-weight:400;inline-size:var(--denhaag-process-steps-step-marker-size,2em);justify-content:center;margin-block-end:var(--denhaag-process-steps-step-marker-margin);margin-block-start:var(--denhaag-process-steps-step-marker-margin);min-block-size:32px;min-inline-size:32px;padding-inline-end:0;position:relative;z-index:1}.denhaag-process-steps__step-marker .denhaag-icon{block-size:20px;inline-size:20px}.denhaag-process-steps__step-marker--checked{background-color:var(--denhaag-process-steps-step-marker-checked-background-color,var(--denhaag-process-steps-step-marker-background-color));border-color:var(--denhaag-process-steps-step-marker-checked-border-color,var(--denhaag-process-steps-step-marker-border-color,transparent));color:var(--denhaag-process-steps-step-marker-checked-color,var(--denhaag-process-steps-step-marker-color))}.denhaag-process-steps__step-marker--current{background-color:var(--denhaag-process-steps-step-marker-current-background-color,var(--denhaag-process-steps-step-marker-background-color));color:var(--denhaag-process-steps-step-marker-current-color,var(--denhaag-process-steps-step-marker-color))}.denhaag-process-steps__step-header{align-items:center;appearance:none;background-color:inherit;border:0;cursor:pointer;display:flex;gap:16px;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}.denhaag-process-steps__step-header--current{color:var(--denhaag-process-steps-step-heading-current-color);font-weight:var(--denhaag-process-steps-step-heading-current-font-weight)}.denhaag-process-steps__step-header--checked{color:var(--denhaag-process-steps-step-heading-checked-color)}.denhaag-process-steps__step-heading{align-items:center;color:var(--denhaag-process-steps-step-heading-color);display:flex;font-family:var(--denhaag-process-steps-step-heading-font-family);font-size:var(--denhaag-process-steps-step-heading-font-size);font-weight:var(--denhaag-process-steps-step-heading-font-weight);line-height:var(--denhaag-process-steps-step-heading-line-height);text-align:start}.denhaag-process-steps__step-heading--checked{color:var(--denhaag-process-steps-step-heading-checked-color,var(--denhaag-process-steps-step-heading-color));font-family:var(--denhaag-process-steps-step-heading-checked-font-family,var(--denhaag-process-steps-step-heading-font-family));font-size:var(--denhaag-process-steps-step-heading-checked-font-size,var(--denhaag-process-steps-step-heading-font-size));font-weight:var(--denhaag-process-steps-step-heading-checked-font-weight,var(--denhaag-process-steps-step-heading-font-weight))}.denhaag-process-steps__step-heading--current{color:var(--denhaag-process-steps-step-heading-current-color,var(--denhaag-process-steps-step-heading-color));font-family:var(--denhaag-process-steps-step-heading-current-font-family,var(--denhaag-process-steps-step-heading-font-family));font-size:var(--denhaag-process-steps-step-heading-current-font-size,var(--denhaag-process-steps-step-heading-font-size));font-weight:var(--denhaag-process-steps-step-heading-current-font-weight,var(--denhaag-process-steps-step-heading-font-weight))}.denhaag-process-steps__sub-step{align-items:baseline;display:flex;flex-direction:row;gap:23px;margin-block-start:var(--denhaag-process-steps-sub-step-distance);position:relative}.denhaag-process-steps__sub-step-line,.denhaag-process-steps__sub-step:after{content:\"\";height:calc(var(--denhaag-process-steps-sub-step-distance) + 15px);left:calc(max(var(--denhaag-process-steps-step-marker-size, 2em), 32px)/2);outline:1px solid var(--denhaag-process-steps-sub-step-line-color);position:absolute;top:calc((var(--denhaag-process-steps-sub-step-distance) + var(--denhaag-process-steps-sub-step-marker-size, 16px)/2)*-1)}.denhaag-process-steps__sub-step-heading,.denhaag-process-steps__sub-step-list{margin-block-end:0;margin-block-start:0}.denhaag-process-steps__sub-step-list{display:none;list-style:none;padding-inline-start:0}.denhaag-process-steps__step--expanded .denhaag-process-steps__sub-step-list,.denhaag-process-steps__step[aria-expanded=true] .denhaag-process-steps__sub-step-list{display:block}.denhaag-process-steps__sub-step-marker{align-items:center;background-color:var(--denhaag-process-steps-sub-step-marker-background-color);border-color:var(--denhaag-process-steps-sub-step-marker-border-color);border-radius:50%;border-style:solid;border-width:2px;box-sizing:border-box;display:flex;flex-grow:0;justify-content:center;margin-inline-start:calc((max(var(--denhaag-process-steps-step-marker-size, 2em), 32px) - var(--denhaag-process-steps-sub-step-marker-size, 16px))/2);min-block-size:var(--denhaag-process-steps-sub-step-marker-size,16px);min-inline-size:var(--denhaag-process-steps-sub-step-marker-size,16px);position:relative;z-index:1}.denhaag-process-steps__sub-step-marker--checked{background-color:var(--denhaag-process-steps-sub-step-marker-checked-background-color,var(--denhaag-process-steps-sub-step-marker-background-color));border-color:var(--denhaag-process-steps-sub-step-marker-checked-border-color,var(--denhaag-process-steps-sub-step-marker-border-color))}";
styleInject$8(css_248z$d);var StepHeadingLabel = function (_a) {
    var children = _a.children, current = _a.current, checked = _a.checked;
    return (React__default__default.createElement("div", { className: clsx$1$2('denhaag-process-steps__step-heading-label', checked && 'denhaag-process-steps__step-heading-label--checked', current && 'denhaag-process-steps__step-heading-label--current') }, children));
};/**
 * The `Timeline` displays a progress through a sequence by breaking it up into
 * multiple logical and numbered steps. Use the timeline when a series of
 * information needs to be ordered by time (ascending or descending). It
 * represents the steps in a process in a chronological order. This process is
 * part of, for example, a request that the user has made.
 *
 * @param props The properties of a ProcessSteps component.
 * @constructor Constructs an instance of ProcessSteps.
 */
var ProcessSteps = function (_a) {
    var props = __rest$1$1(_a, []);
    return (React__default__default.createElement(StepList, __assign$1$2({}, props),
        React__default__default.createElement(Step, { checked: true, expanded: true },
            React__default__default.createElement(StepSection, null,
                React__default__default.createElement(StepHeader, null,
                    React__default__default.createElement(StepMarker, null,
                        React__default__default.createElement("div", null, "1")),
                    React__default__default.createElement(StepHeading, null, "Deelname aan geluidsonderzoek"),
                    React__default__default.createElement(StepExpandedIcon, null))),
            React__default__default.createElement(SubStepList, null,
                React__default__default.createElement(SubStep, null,
                    React__default__default.createElement(SubStepMarker, null),
                    React__default__default.createElement(SubStepHeading, null, "Aanmelding ontvangen")))),
        React__default__default.createElement(Step, { current: true, expanded: true },
            React__default__default.createElement(StepSection, null,
                React__default__default.createElement(StepHeader, null,
                    React__default__default.createElement(StepMarker, null,
                        React__default__default.createElement("div", null, "2")),
                    React__default__default.createElement(StepHeading, null, "Onderzoek naar geluidsoverlast"),
                    React__default__default.createElement(StepExpandedIcon, null))),
            React__default__default.createElement(SubStepList, null,
                React__default__default.createElement(SubStep, null,
                    React__default__default.createElement(SubStepMarker, null),
                    React__default__default.createElement(SubStepHeading, null, "Afspraak meten geluidsoverlast gemaakt")),
                React__default__default.createElement(SubStep, null,
                    React__default__default.createElement(SubStepMarker, null),
                    React__default__default.createElement(SubStepHeading, null, "Geluidsoverlast gemeten")),
                React__default__default.createElement(SubStep, null,
                    React__default__default.createElement(SubStepMarker, null),
                    React__default__default.createElement(SubStepHeading, null, "Onderzoek resultaten verwerkt")))),
        React__default__default.createElement(Step, null,
            React__default__default.createElement(StepSection, null,
                React__default__default.createElement(StepHeader, null,
                    React__default__default.createElement(StepMarker, null, "3"),
                    React__default__default.createElement(StepHeading, null, "Uitvoeren van maatregelen")))),
        React__default__default.createElement(Step, null,
            React__default__default.createElement(StepSection, null,
                React__default__default.createElement(StepHeader, null,
                    React__default__default.createElement(StepMarker, null, "4"),
                    React__default__default.createElement(StepHeading, null, "Maatregelen zijn uitgevoerd"))))));
};var __assign$7 = function() {
    __assign$7 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};

function __rest$4(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$6(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$6(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$6 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$6(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}function styleInject$7(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$c = ".denhaag-radio{align-items:center;display:inline-flex;justify-content:center;position:relative}.denhaag-radio__input{left:0;margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;opacity:0;position:absolute;top:0;z-index:1}.denhaag-radio__icon,.denhaag-radio__input{aspect-ratio:1;cursor:pointer;width:var(--denhaag-radio-size)}.denhaag-radio__icon{align-items:center;background-color:var(--denhaag-radio-background-color);border-color:var(--denhaag-radio-border-color);border-radius:50%;border-style:solid;border-width:var(--denhaag-radio-border-width);box-sizing:border-box;display:flex;justify-content:center}.denhaag-radio__icon-inner{aspect-ratio:1;background-color:var(--denhaag-radio-checked-inner-background-color);border-radius:50%;display:none;width:var(--denhaag-radio-checked-inner-size)}.denhaag-radio__input:disabled{cursor:default}.denhaag-radio__input:checked+.denhaag-radio__icon{background-color:var(--denhaag-radio-checked-background-color);border-color:var(--denhaag-radio-checked-border-color)}.denhaag-radio__input:checked+.denhaag-radio__icon .denhaag-radio__icon-inner{display:block}.denhaag-radio.denhaag-radio--error .denhaag-radio__icon{border-color:var(--denhaag-radio-invalid-border-color)}.denhaag-radio.denhaag-radio--focus .denhaag-radio__icon,.denhaag-radio:focus-within .denhaag-radio__icon{outline:var(--denhaag-focus-border)}.denhaag-form-control-label:hover .denhaag-radio__icon,.denhaag-radio.denhaag-radio--hover .denhaag-radio__icon,.denhaag-radio:hover .denhaag-radio__icon{border-color:var(--denhaag-radio-hover-border-color)}.denhaag-radio .denhaag-radio__input:disabled+.denhaag-radio__icon{background-color:var(--denhaag-radio-disabled-background-color);border-color:var(--denhaag-radio-border-color);cursor:default}.denhaag-form-control-label:hover .denhaag-radio.denhaag-radio--error .denhaag-radio__icon,.denhaag-radio.denhaag-radio--error.denhaag-radio.denhaag-radio--hover .denhaag-radio__icon,.denhaag-radio.denhaag-radio--error:hover .denhaag-radio__icon{border-color:var(--denhaag-radio-hover-invalid-border-color)}.denhaag-form-control-label:hover .denhaag-radio__input:checked+.denhaag-radio__icon,.denhaag-radio.denhaag-radio--hover .denhaag-radio__input:checked+.denhaag-radio__icon,.denhaag-radio:hover .denhaag-radio__input:checked+.denhaag-radio__icon{background-color:var(--denhaag-radio-hover-checked-background-color);border-color:var(--denhaag-radio-hover-checked-border-color)}.denhaag-radio .denhaag-radio__input:checked:disabled+.denhaag-radio__icon{background-color:var(--denhaag-radio-checked-disabled-background-color);border-color:var(--denhaag-radio-checked-disabled-border-color)}.denhaag-radio.denhaag-radio--error .denhaag-radio__input:checked+.denhaag-radio__icon{background-color:var(--denhaag-radio-checked-invalid-background-color)}.denhaag-form-control-label:hover .denhaag-radio.denhaag-radio--error .denhaag-radio__input:checked+.denhaag-radio__icon,.denhaag-radio.denhaag-radio--error.denhaag-radio--hover .denhaag-radio__input:checked+.denhaag-radio__icon,.denhaag-radio.denhaag-radio--error:hover .denhaag-radio__input:checked+.denhaag-radio__icon{background-color:var(--denhaag-radio-hover-invalid-background-color);border-color:var(--denhaag-radio-hover-invalid-border-color)}";
styleInject$7(css_248z$c);/**
 * Radio buttons allow the user to select one item from a set.
 */
var Radio = function (_a) {
    var className = _a.className, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, onChange = _a.onChange, props = __rest$4(_a, ["className", "error", "checked", "onChange"]);
    var classes = clsx$6('denhaag-radio', { 'denhaag-radio--error': error }, className);
    return (React__default__default.createElement("span", { className: classes },
        React__default__default.createElement("input", __assign$7({ type: "radio", className: "denhaag-radio__input", defaultChecked: checked, onChange: function (event) {
                if (onChange) {
                    onChange(event);
                }
            } }, props)),
        React__default__default.createElement("span", { className: "denhaag-radio__icon" },
            React__default__default.createElement("span", { className: "denhaag-radio__icon-inner" }))));
};var __assign$6 = function() {
    __assign$6 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};/**
 * Select components are used for collecting user provided information from a list of options.
 */
var Select = function (props) {
    return React__default__default.createElement(Select$1, __assign$6({}, props), props.children);
};function styleInject$6(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$b = ".denhaag-sidenav{display:flex;flex-direction:column;row-gap:var(--denhaag-sidenav-row-gap)}.denhaag-sidenav__list{list-style:none;margin-block-end:0;margin-block-start:0;padding-block-end:0;padding-block-start:0;padding-inline-start:0}.denhaag-sidenav__list--child{margin-inline-start:var(--denhaag-sidenav-list-child-margin-inline-start)}.denhaag-sidenav__item{font-family:var(--denhaag-sidenav-item-font-family,sans-serif);font-size:var(--denhaag-sidenav-item-font-size);font-weight:var(--denhaag-sidenav-item-font-weight,normal);line-height:1.5}.denhaag-sidenav__item,.denhaag-sidenav__link{align-items:center;display:flex;flex-direction:row}.denhaag-sidenav__link{color:var(--denhaag-sidenav-link-color);column-gap:16px;flex-grow:1;padding-block-end:var(--denhaag-sidenav-link-padding-block-end);padding-block-start:var(--denhaag-sidenav-link-padding-block-start);text-decoration:none}.denhaag-sidenav__link--hover,.denhaag-sidenav__link:hover{color:var(--denhaag-sidenav-link-hover-color);cursor:pointer}.denhaag-sidenav__link--focus,.denhaag-sidenav__link:focus{outline:var(--denhaag-focus-border)}.denhaag-sidenav__link--current{color:var(--denhaag-sidenav-link-active-color)}.denhaag-sidenav__link--child{padding-inline-start:var(--denhaag-sidenav-link-child-padding-inline-start)}";
styleInject$6(css_248z$b);/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$5 = function() {
    __assign$5 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};

function __rest$3(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$5(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$5(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$5 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$5(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var Sidenav = function (props) {
    var className = clsx$5('denhaag-sidenav', props.className);
    return (React__default__default.createElement("nav", __assign$5({}, props, { className: className }), props.children));
};var SidenavItem = function (props) {
    var className = clsx$5('denhaag-sidenav__item', props.className);
    return (React__default__default.createElement("li", __assign$5({}, props, { className: className }), props.children));
};var SidenavList = function (props) {
    var className = clsx$5('denhaag-sidenav__list', props.className);
    return (React__default__default.createElement("ul", __assign$5({}, props, { className: className }), props.children));
};var SidenavLink = function (_a) {
    var current = _a.current, props = __rest$3(_a, ["current"]);
    var className = clsx$5('denhaag-sidenav__link', current && 'denhaag-sidenav__link--current', props.className);
    return (React__default__default.createElement("a", __assign$5({}, props, { "aria-current": current || props['aria-current'] ? 'page' : undefined, className: className }), props.children));
};var __assign$4 = function() {
    __assign$4 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};/**
 * Switches allow a user to toggle the state of a setting on or off.
 */
var Switch = function (props) {
    return React__default__default.createElement(Switch$1, __assign$4({}, props));
};function styleInject$5(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$a = "@charset \"UTF-8\";.utrecht-article{max-inline-size:var(--utrecht-article-max-inline-size)}.utrecht-badge-counter{background-color:var(--utrecht-badge-counter-background-color,var(--utrecht-badge-background-color,#000));border-radius:var(--utrecht-badge-counter-border-radius,var(--utrecht-badge-border-radius,.5ch));color:var(--utrecht-badge-counter-color,var(--utrecht-badge-color,#fff));display:inline-block;font-family:var(--utrecht-document-font-family,sans-serif);font-style:var(--utrecht-badge-counter-font-style,normal);font-weight:var(--utrecht-badge-counter-font-weight,var(--utrecht-badge-font-weight,bold));padding-block-end:var(--utrecht-badge-counter-padding-block,var(--utrecht-badge-padding-block,.5ex));padding-block-start:var(--utrecht-badge-counter-padding-block,var(--utrecht-badge-padding-block,.5ex));padding-inline-end:var(--utrecht-badge-counter-padding-inline,var(--utrecht-badge-padding-inline,.5ch));padding-inline-start:var(--utrecht-badge-counter-padding-inline,var(--utrecht-badge-padding-inline,.5ch));text-decoration:none}.utrecht-badge-data{letter-spacing:var(--utrecht-badge-data-letter-spacing,inherit);text-transform:var(--utrecht-badge-data-text-transform,inherit)}.utrecht-badge,.utrecht-badge-data,.utrecht-badge-status{background-color:var(--utrecht-badge-background-color,#000);border-radius:var(--utrecht-badge-border-radius,.5ch);color:var(--utrecht-badge-color,#fff);display:inline-block;font-family:var(--utrecht-document-font-family,sans-serif);font-size:var(--utrecht-badge-font-size,inherit);font-style:var(--utrecht-badge-font-style,normal);font-weight:var(--utrecht-badge-font-weight,bold);line-height:var(--utrecht-badge-line-height);padding-block-end:var(--utrecht-badge-padding-block,.5ex);padding-block-start:var(--utrecht-badge-padding-block,.5ex);padding-inline-end:var(--utrecht-badge-padding-inline,.5ch);padding-inline-start:var(--utrecht-badge-padding-inline,.5ch);text-decoration:none}.utrecht-badge-status{letter-spacing:var(--utrecht-badge-status-letter-spacing,inherit);text-transform:var(--utrecht-badge-status-text-transform,inherit)}.utrecht-badge-status--danger{background-color:var(--utrecht-feedback-danger-fill-background-color,red);color:var(--utrecht-feedback-danger-fill-color,#fff)}.utrecht-badge-status--warning{background-color:var(--utrecht-feedback-warning-fill-background-color,#ffa600);color:var(--utrecht-feedback-warning-fill-color,#fff)}.utrecht-badge-status--safe{background-color:var(--utrecht-feedback-safe-fill-background-color,green);color:var(--utrecht-feedback-safe-fill-color,#fff)}.utrecht-badge-status--neutral{background-color:var(--utrecht-feedback-neutral-fill-background-color,#000);color:var(--utrecht-feedback-neutral-fill-color,#fff)}.utrecht-badge-status--valid{background-color:var(--utrecht-feedback-valid-fill-background-color,var(--utrecht-feedback-safe-fill-background-color,red));color:var(--utrecht-feedback-valid-fill-color,var(--utrecht-feedback-safe-fill-color,#fff))}.utrecht-badge-status--invalid{background-color:var(--utrecht-feedback-invalid-fill-background-color,var(--utrecht-feedback-danger-fill-background-color,#ffa600));color:var(--utrecht-feedback-invalid-fill-color,var(--utrecht-feedback-danger-fill-color,#fff))}.utrecht-badge-status--error{background-color:var(--utrecht-feedback-error-fill-background-color,var(--utrecht-feedback-danger-fill-background-color,#ffa600));color:var(--utrecht-feedback-error-fill-color,var(--utrecht-feedback-danger-fill-color,#fff))}.utrecht-badge-status--success{background-color:var(--utrecht-feedback-success-fill-background-color,var(--utrecht-feedback-safe-fill-background-color,#ffa600));color:var(--utrecht-feedback-success-fill-color,var(--utrecht-feedback-safe-fill-color,#fff))}.utrecht-badge-status--active{background-color:var(--utrecht-feedback-active-fill-background-color,var(--utrecht-feedback-safe-fill-background-color,#ffa600));color:var(--utrecht-feedback-active-fill-color,var(--utrecht-feedback-safe-fill-color,#fff))}.utrecht-badge-status--inactive{background-color:var(--utrecht-feedback-inactive-fill-background-color,var(--utrecht-feedback-danger-fill-background-color,#ffa600));color:var(--utrecht-feedback-inactive-fill-color,var(--utrecht-feedback-danger-fill-color,#fff))}.utrecht-blockquote{font-family:var(--utrecht-document-font-family);font-size:var(--utrecht-blockquote-font-size);margin-inline-end:var(--utrecht-blockquote-margin-inline-end);margin-inline-start:var(--utrecht-blockquote-margin-inline-start)}.utrecht-blockquote__attribution{color:var(--utrecht-blockquote-attribution-color,inherit);font-size:var(--utrecht-blockquote-attribution-font-size,inherit)}.utrecht-blockquote__content{--utrecht-document-color:var(--utrecht-blockquote-content-color,inherit);--utrecht-paragraph-font-size:var(--utrecht-blockquote-content-font-size,inherit);color:var(--utrecht-blockquote-content-color,inherit);font-size:var(--utrecht-blockquote-content-font-size,inherit)}.utrecht-blockquote--distanced{margin-block-end:var(--utrecht-blockquote-margin-block-end);margin-block-start:var(--utrecht-blockquote-margin-block-start)}.utrecht-breadcrumb{--utrecht-focus-background-color:var(--utrecht-breadcrumb-link-focus-background-color);--utrecht-link-background-color:var(--utrecht-breadcrumb-link-background-color);--utrecht-link-color:var(--utrecht-breadcrumb-link-color);--utrecht-link-focus-color:var(--utrecht-breadcrumb-link-focus-color,var(--utrecht-breadcrumb-link-color));--utrecht-link-focus-text-decoration:var(--utrecht-link-text-decoration);--utrecht-link-hover-color:var(--utrecht-breadcrumb-link-color);--utrecht-link-hover-text-decoration:var(--utrecht-link-text-decoration);--utrecht-link-visited-color:var(--utrecht-breadcrumb-link-color);--utrecht-link-visited-text-decoration:var(--utrecht-link-text-decoration);font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-breadcrumb-font-size);text-transform:var(--utrecht-document-text-transform,inherit)}.utrecht-breadcrumb__list{block-size:var(--utrecht-breadcrumb-block-size);display:flex}ol.utrecht-breadcrumb__list{list-style:none;margin-block-end:0;margin-block-start:0;padding-inline-start:0}.utrecht-breadcrumb__item{block-size:100%}.utrecht-breadcrumb__link{background-color:var(--utrecht-breadcrumb-link-background-color);display:block;padding-block-end:var(--utrecht-breadcrumb-item-padding-block-end,8px);padding-block-start:var(--utrecht-breadcrumb-item-padding-block-start,8px);padding-inline-end:var(--utrecht-breadcrumb-item-padding-inline-end,8px);padding-inline-start:var(--utrecht-breadcrumb-item-padding-inline-start,8px)}.utrecht-breadcrumb--arrows{--utrecht-breadcrumb-arrow-size:24px;overflow:hidden}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link{padding-inline-end:0;position:relative}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link:after,.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link:before{border-block-end-width:var(--utrecht-breadcrumb-block-size);border-block-start-width:var(--utrecht-breadcrumb-block-size);border-color:transparent;border-style:solid;content:\" \";display:block;height:0;left:100%;margin-block-start:calc(var(--utrecht-breadcrumb-block-size)*-1);position:absolute;top:50%;width:0}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link:after{border-inline-start-color:var(--utrecht-breadcrumb-link-background-color);border-inline-start-width:var(--utrecht-breadcrumb-arrow-size);z-index:2}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link:before{border-inline-start-color:var(--utrecht-document-background-color);border-inline-start-width:var(--utrecht-breadcrumb-arrow-size);margin-block-start:calc(var(--utrecht-breadcrumb-block-size)*-1);margin-inline-start:1px;z-index:1}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link--focus,.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link:focus{background-color:var(--utrecht-breadcrumb-link-focus-background-color)}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link--focus:after,.utrecht-breadcrumb--arrows .utrecht-breadcrumb__link:focus:after{border-inline-start-color:var(--utrecht-breadcrumb-link-focus-background-color)}.utrecht-breadcrumb--arrows .utrecht-breadcrumb__item~.utrecht-breadcrumb__item .utrecht-breadcrumb__link{padding-inline-start:calc(var(--utrecht-breadcrumb-item-padding-inline-start) + var(--utrecht-breadcrumb-arrow-size))}.utrecht-breadcrumb__item~.utrecht-breadcrumb__item{margin-inline-start:var(--utrecht-breadcrumb-item-divider-inline-size)}.utrecht-button{background-color:var(--utrecht-button-primary-action-background-color,var(--utrecht-button-background-color));border-radius:var(--utrecht-button-border-radius);border-style:solid;border-width:var(--utrecht-button-border-width,0);color:var(--utrecht-button-primary-action-color,var(--utrecht-button-color));font-family:var(--utrecht-button-font-family,var(--utrecht-document-font-family));font-size:var(--utrecht-button-font-size,var(--utrecht-document-font-family));font-weight:var(--utrecht-button-font-weight);inline-size:var(--utrecht-button-inline-size,auto);letter-spacing:var(--utrecht-button-letter-spacing);min-block-size:var(--utrecht-button-min-block-size,auto);min-inline-size:var(--utrecht-button-min-inline-size,0);padding-block-end:var(--utrecht-button-padding-block-end);padding-block-start:var(--utrecht-button-padding-block-start);padding-inline-end:var(--utrecht-button-padding-inline-end);padding-inline-start:var(--utrecht-button-padding-inline-start);text-transform:var(--utrecht-button-text-transform);user-select:none}.utrecht-button--distanced{margin-block-end:var(--utrecht-button-margin-block-end);margin-block-start:var(--utrecht-button-margin-block-start);margin-inline-end:var(--utrecht-button-margin-inline-end);margin-inline-start:var(--utrecht-button-margin-inline-start)}.utrecht-button--submit{cursor:var(--utrecht-action-submit-cursor)}.utrecht-button--busy{cursor:var(--utrecht-action-busy-cursor)}.utrecht-button--disabled,.utrecht-button:disabled{background-color:var(--utrecht-button-disabled-background-color,var(--utrecht-button-background-color));color:var(--utrecht-button-disabled-color,var(--utrecht-button-color));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-button--active,.utrecht-button:active:not(:disabled):not([aria-disabled=true]):not(.utrecht-button--disabled){background-color:var(--utrecht-button-active-background-color,var(--utrecht-button-background-color));color:var(--utrecht-button-active-color,var(--utrecht-button-color))}.utrecht-button--focus-visible,.utrecht-button:focus:not(:disabled):not([aria-disabled=true]):not(.utrecht-button--disabled){box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-button--focus,.utrecht-button:focus:not(:disabled):not([aria-disabled=true]):not(.utrecht-button--disabled){background-color:var(--utrecht-button-focus-background-color,var(--utrecht-button-background-color));color:var(--utrecht-button-focus-color,var(--utrecht-button-color))}.utrecht-button:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-button--hover:not(:disabled),.utrecht-button:hover:not(:disabled):not([aria-disabled=true]):not(.utrecht-button--disabled){background-color:var(--utrecht-button-hover-background-color,var(--utrecht-button-background-color));color:var(--utrecht-button-hover-color,var(--utrecht-button-color));transform:scale(var(--utrecht-button-focus-transform-scale,1))}.utrecht-checkbox{margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0}.utrecht-checkbox--disabled,.utrecht-checkbox--html-input:disabled{cursor:var(--utrecht-action-disabled-cursor)}.utrecht-checkbox--focus-visible,.utrecht-checkbox--html-input:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-checkbox--html-input:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-custom-checkbox{--utrecht-icon-size:var(--utrecht-custom-checkbox-icon-size,calc(var(--utrecht-custom-checkbox-size)*0.75));display:inline-block;height:var(--utrecht-custom-checkbox-size);position:relative;width:var(--utrecht-custom-checkbox-size)}.utrecht-custom-checkbox__box,.utrecht-custom-checkbox__input{left:0;position:absolute;top:0}.utrecht-custom-checkbox__input{margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;opacity:0;z-index:10}.utrecht-custom-checkbox__box,.utrecht-custom-checkbox__input{height:var(--utrecht-custom-checkbox-size);width:var(--utrecht-custom-checkbox-size)}.utrecht-custom-checkbox__box{align-items:center;background-color:var(--utrecht-custom-checkbox-background-color);border-color:var(--utrecht-custom-checkbox-border-color,var(--utrecht-form-input-border-color));border-radius:var(--utrecht-custom-checkbox-border-radius,var(--utrecht-form-input-border-radius));border-style:solid;border-width:var(--utrecht-custom-checkbox-border-width,var(--utrecht-form-input-border-width));box-sizing:border-box;color:var(--utrecht-custom-checkbox-color);display:flex;justify-content:center;pointer-events:none;z-index:1000}.utrecht-custom-checkbox__box--checked{background-color:var(--utrecht-custom-checkbox-checked-background-color,var(--utrecht-custom-checkbox-background-color));border-color:var(--utrecht-custom-checkbox-checked-border-color,var(--utrecht-custom-checkbox-border-color));border-width:var(--utrecht-custom-checkbox-checked-border-width,var(--utrecht-custom-checkbox-border-width));color:var(--utrecht-custom-checkbox-checked-color,var(--utrecht-custom-checkbox-color))}.utrecht-custom-checkbox__box--disabled{background-color:var(--utrecht-custom-checkbox-disabled-background-color,var(--utrecht-custom-checkbox-background-color));border-color:var(--utrecht-custom-checkbox-disabled-border-color,var(--utrecht-custom-checkbox-border-color));border-width:var(--utrecht-custom-checkbox-disabled-border-width,var(--utrecht-custom-checkbox-border-width));color:var(--utrecht-custom-checkbox-disabled-color,var(--utrecht-custom-checkbox-color));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-custom-checkbox__box--indeterminate,.utrecht-custom-checkbox__input:indeterminate~.utrecht-custom-checkbox__box{color:var(--utrecht-custom-checkbox-indeterminate-color,var(--utrecht-custom-checkbox-color))}.utrecht-custom-checkbox__box--invalid{background-color:var(--utrecht-custom-checkbox-invalid-background-color,var(--utrecht-custom-checkbox-background-color));border-color:var(--utrecht-custom-checkbox-invalid-border-color,var(--utrecht-custom-checkbox-border-color));border-width:var(--utrecht-custom-checkbox-invalid-border-width,var(--utrecht-custom-checkbox-border-width));color:var(--utrecht-custom-checkbox-invalid-color,var(--utrecht-custom-checkbox-color))}.utrecht-custom-checkbox__box--active{background-color:var(--utrecht-custom-checkbox-active-background-color,var(--utrecht-custom-checkbox-background-color));border-color:var(--utrecht-custom-checkbox-active-border-color,var(--utrecht-custom-checkbox-border-color));border-width:var(--utrecht-custom-checkbox-active-border-width,var(--utrecht-custom-checkbox-border-width));color:var(--utrecht-custom-checkbox-active-color,var(--utrecht-custom-checkbox-color))}.utrecht-custom-checkbox__box--focus,.utrecht-custom-checkbox__input:focus~.utrecht-custom-checkbox__box{background-color:var(--utrecht-custom-checkbox-focus-background-color,var(--utrecht-custom-checkbox-background-color));border-color:var(--utrecht-custom-checkbox-focus-border-color,var(--utrecht-custom-checkbox-border-color));border-width:var(--utrecht-custom-checkbox-focus-border-width,var(--utrecht-custom-checkbox-border-width));color:var(--utrecht-custom-checkbox-focus-color,var(--utrecht-custom-checkbox-color))}.utrecht-custom-checkbox__box--focus-visible,.utrecht-custom-checkbox__input:focus~.utrecht-custom-checkbox__box{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-custom-checkbox__input:focus:not(:focus-visible)~.utrecht-custom-checkbox__box{box-shadow:none;outline-style:none}.utrecht-custom-checkbox__icon--checked,.utrecht-custom-checkbox__icon--indeterminate{display:none}.utrecht-custom-checkbox__box--checked .utrecht-custom-checkbox__icon--checked{display:block}.utrecht-custom-checkbox__box--indeterminate .utrecht-custom-checkbox__icon--indeterminate,.utrecht-custom-checkbox__input:indeterminate~.utrecht-custom-checkbox__box .utrecht-custom-checkbox__icon--indeterminate{display:block}.utrecht-digid-button{--utrecht-button-min-block-size:var(--utrecht-digid-button-block-size,50px);--utrecht-logo-max-height:var(--utrecht-digid-button-block-size,50px);--utrecht-logo-max-width:var(--utrecht-digid-button-block-size,50px);block-size:var(--utrecht-digid-button-block-size,50px);display:inline-flex;gap:var(--utrecht-space-inline-sm)}.utrecht-digid-button__logo{order:1}.utrecht-digid-button__button{order:2}.utrecht-document{text-rendering:optimizeLegibility;color:var(--utrecht-document-color,inherit);font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-document-font-size,inherit);font-weight:var(--utrecht-document-font-weight,inherit);line-height:var(--utrecht-document-line-height,inherit)}.utrecht-document :lang(ar){letter-spacing:0!important}.utrecht-document--surface{background-color:var(--utrecht-document-background-color,inherit)}.utrecht-emphasis--stressed{font-style:var(--utrecht-emphasis-stressed-font-style,italic)}.utrecht-emphasis--strong{font-weight:var(--utrecht-emphasis-strong-font-weight,bold)}.utrecht-form-field-checkbox-group{font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-paragraph-font-size)}.utrecht-form-field-checkbox-group--distanced{margin-block-end:var(--utrecht-form-field-margin-block-end,var(--utrecht-paragraph-margin-block-end));margin-block-start:var(--utrecht-form-field-margin-block-start,var(--utrecht-paragraph-margin-block-start))}.utrecht-form-field-checkbox-group__label{margin-block-end:var(--utrecht-paragraph-margin-block-end);margin-block-start:var(--utrecht-paragraph-margin-block-start)}.utrecht-form-field__label--checkbox{margin-inline-start:1ch}.utrecht-form-field-description{color:var(--utrecht-form-field-description-color);font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-form-field-description-font-size,inherit);font-style:var(--utrecht-form-field-description-font-style)}.utrecht-form-field-description--distanced{margin-block-end:var(--utrecht-form-field-description-margin-block-end,var(--utrecht-paragraph-margin-block-end));margin-block-start:var(--utrecht-form-field-description-margin-block-start,var(--utrecht-paragraph-margin-block-start))}.utrecht-form-field-description--invalid{color:var(--utrecht-form-field-description-invalid-color,var(--utrecht-feedback-invalid-color,var(--utrecht-feedback-danger-color)))}.utrecht-form-field-description--valid{color:var(--utrecht-form-field-description-valid-color,var(--utrecht-feedback-valid-color,var(--utrecht-feedback-safe-color)))}.utrecht-form-field-description--warning{color:var(--utrecht-form-field-description-warning-color,var(--utrecht-feedback-warning-color))}.utrecht-form-field-radio-group{font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-paragraph-font-size)}.utrecht-form-field-radio-group--distanced{margin-block-end:var(--utrecht-form-field-margin-block-end,var(--utrecht-paragraph-margin-block-end));margin-block-start:var(--utrecht-form-field-margin-block-start,var(--utrecht-paragraph-margin-block-start))}.utrecht-form-field-radio-group__label{margin-block-end:var(--utrecht-paragraph-margin-block-end);margin-block-start:var(--utrecht-paragraph-margin-block-start)}.utrecht-form-field-radio{font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-paragraph-font-size)}.utrecht-form-field-radio--distanced{margin-block-end:var(--utrecht-form-field-margin-block-end,var(--utrecht-paragraph-margin-block-end));margin-block-start:var(--utrecht-form-field-margin-block-start,var(--utrecht-paragraph-margin-block-start))}.utrecht-form-field-radio__label{margin-inline-start:1ch}.utrecht-form-field,.utrecht-form-field-textbox{font-family:var(--utrecht-document-font-family,inherit)}.utrecht-form-field{max-inline-size:var(--utrecht-form-field-max-inline-size)}.utrecht-form-field--distanced{margin-block-end:var(--utrecht-form-field-margin-block-end,var(--utrecht-paragraph-margin-block-end));margin-block-start:var(--utrecht-form-field-margin-block-start,var(--utrecht-paragraph-margin-block-start))}.utrecht-form-fieldset--reset-fieldset{border:0;margin-inline-end:0;margin-inline-start:0;min-width:0;padding-block-end:0;padding-block-start:.01em}.utrecht-form-fieldset--reset-fieldset,.utrecht-form-fieldset__legend--reset-legend{padding-inline-end:0;padding-inline-start:0}.utrecht-form-fieldset--distanced{margin-block-end:var(--utrecht-form-fieldset-margin-block-end,0);margin-block-start:var(--utrecht-form-fieldset-margin-block-start,0)}.utrecht-form-fieldset__legend{color:var(--utrecht-form-fieldset-legend-color,var(--utrecht-document-color,inherit));font-family:var(--utrecht-form-fieldset-legend-font-family,var(--utrecht-document-font-family));font-size:var(--utrecht-form-fieldset-legend-font-size);font-weight:var(--utrecht-form-fieldset-legend-font-weight);line-height:var(--utrecht-form-fieldset-legend-line-height);text-transform:var(--utrecht-form-fieldset-legend-text-transform)}.utrecht-form-fieldset__legend--distanced{margin-block-end:var(--utrecht-form-fieldset-legend-margin-block-end);margin-block-start:var(--utrecht-form-fieldset-legend-margin-block-start)}.utrecht-form-label{color:var(--utrecht-form-label-color);font-size:var(--utrecht-form-label-font-size);font-weight:var(--utrecht-form-label-font-weight)}.utrecht-form-label--checkbox{color:var(--utrecht-form-label-checkbox-color,var(--utrecht-form-label-color));font-weight:var(--utrecht-form-label-checkbox-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-label--checked{font-weight:var(--utrecht-form-label-checked-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-label--disabled{cursor:var(--utrecht-action-disabled-cursor);font-weight:var(--utrecht-form-label-disabled-color,var(--utrecht-form-label-color))}.utrecht-form-label--radio{color:var(--utrecht-form-label-checkbox-color,var(--utrecht-form-label-color));font-weight:var(--utrecht-form-label-radio-font-weight,var(--utrecht-form-label-font-weight))}.utrecht-form-toggle{align-items:center;border-color:var(--utrecht-form-toggle-border-color,currentColor);border-radius:var(--utrecht-form-toggle-border-radius,999rem);border-style:var(--utrecht-form-toggle-border-style,solid);border-width:var(--utrecht-form-toggle-border-width,1px);color:var(--utrecht-form-toggle-color);display:flex;height:var(--utrecht-form-toggle-height,2em);padding-block-end:var(--utrecht-form-toggle-padding-block-end);padding-block-start:var(--utrecht-form-toggle-padding-block-start);padding-inline-end:var(--utrecht-form-toggle-padding-inline-end);padding-inline-start:var(--utrecht-form-toggle-padding-inline-start);position:relative;user-select:none;width:var(--utrecht-form-toggle-width,6em)}.utrecht-form-toggle--focus{border-color:var(--utrecht-form-toggle-focus-border-color,var(--utrecht-form-toggle-border-color,currentColor));border-style:var(--utrecht-form-toggle-focus-border-style,var(--utrecht-form-toggle-border-style,solid));border-width:var(--utrecht-form-toggle-focus-border-width,var(--utrecht-form-toggle-border-width,1px))}.utrecht-form-toggle--hover{background-color:var(--utrecht-form-toggle-hover-background-color,var(--utrecht-form-toggle-background-color));color:var(--utrecht-form-toggle-hover-color,var(--utrecht-form-toggle-color))}.utrecht-form-toggle--disabled{border-color:var(--utrecht-form-toggle-disabled-border-color,var(--utrecht-form-toggle-border-color,currentColor));border-style:var(--utrecht-form-toggle-disabled-border-style,var(--utrecht-form-toggle-border-style,solid));border-width:var(--utrecht-form-toggle-disabled-border-width,var(--utrecht-form-toggle-border-width,1px));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-form-toggle__thumb{background-color:var(--utrecht-form-toggle-thumb-background-color,currentColor);border-radius:var(--utrecht-form-toggle-thumb-border-radius,50%);box-shadow:var(--utrecht-form-toggle-thumb-box-shadow);margin-inline-end:var(--utrecht-form-toggle-thumb-margin-inline-end,0);margin-inline-start:var(--utrecht-form-toggle-thumb-margin-inline-start,0);min-block-size:var(--utrecht-form-toggle-thumb-min-inline-size,1.5em);min-inline-size:var(--utrecht-form-toggle-thumb-min-inline-size,1.5em);z-index:20}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox:checked~.utrecht-form-toggle__track .utrecht-form-toggle__thumb,.utrecht-form-toggle__thumb--checked{margin-inline-start:auto}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox:not(:checked)~.utrecht-form-toggle__track .utrecht-form-toggle__thumb,.utrecht-form-toggle__thumb--not-checked{margin-inline-end:auto}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox:disabled~.utrecht-form-toggle__track .utrecht-form-toggle__thumb,.utrecht-form-toggle__thumb--disabled{background-color:var(--utrecht-form-toggle-thumb-disabled-background-color,#aaa);box-shadow:var(--utrecht-form-toggle-thumb-disabled-box-shadow,0)}.utrecht-form-toggle__track{align-items:center;background-color:var(--utrecht-form-toggle-accent-color);border-radius:var(--utrecht-form-toggle-track-border-radius,var(--utrecht-form-toggle-border-radius));display:flex;height:100%;width:100%}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox:checked~.utrecht-form-toggle__track,.utrecht-form-toggle__track--checked{background-color:var(--utrecht-form-toggle-checked-accent-color,var(--utrecht-form-toggle-accent-color))}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox:disabled~.utrecht-form-toggle__track,.utrecht-form-toggle__track--disabled{background-color:var(--utrecht-form-toggle-background-disabled-background-color,#ddd);color:var(--utrecht-form-toggle-disabled-color,#000)}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox{clip:rect(1px,1px,1px,1px)!important;border:0!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;margin:-1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:1px!important}.utrecht-form-toggle--html-checkbox .utrecht-form-toggle__checkbox:focus~.utrecht-form-toggle__track{outline-color:var(--utrecht-form-toggle-focus-border-color,var(--utrecht-form-toggle-border-color,currentColor));outline-style:var(--utrecht-form-toggle-focus-border-style,var(--utrecht-form-toggle-border-style,solid));outline-width:var(--utrecht-form-toggle-focus-border-width,var(--utrecht-form-toggle-border-width,1px))}.utrecht-heading-1{color:var(--utrecht-heading-1-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-heading-1-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-1-font-size);font-weight:var(--utrecht-heading-1-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-heading-1-letter-spacing);line-height:var(--utrecht-heading-1-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-heading-1-text-transform,inherit)}.utrecht-heading-1--distanced{margin-block-end:var(--utrecht-heading-1-margin-block-end);margin-block-start:var(--utrecht-heading-1-margin-block-start)}.utrecht-heading-2{color:var(--utrecht-heading-2-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-heading-2-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-2-font-size);font-weight:var(--utrecht-heading-2-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-heading-2-letter-spacing);line-height:var(--utrecht-heading-2-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-heading-2-text-transform,inherit)}.utrecht-heading-2--distanced{margin-block-end:var(--utrecht-heading-2-margin-block-end);margin-block-start:var(--utrecht-heading-2-margin-block-start)}.utrecht-heading-3{color:var(--utrecht-heading-3-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-heading-3-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-3-font-size);font-weight:var(--utrecht-heading-3-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-heading-3-letter-spacing);line-height:var(--utrecht-heading-3-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-heading-3-text-transform,inherit)}.utrecht-heading-3--distanced{margin-block-end:var(--utrecht-heading-3-margin-block-end);margin-block-start:var(--utrecht-heading-3-margin-block-start)}.utrecht-heading-4{color:var(--utrecht-heading-4-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-heading-4-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-4-font-size);font-weight:var(--utrecht-heading-4-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-heading-4-letter-spacing);line-height:var(--utrecht-heading-4-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-heading-4-text-transform,inherit)}.utrecht-heading-4--distanced{margin-block-end:var(--utrecht-heading-4-margin-block-end);margin-block-start:var(--utrecht-heading-4-margin-block-start)}.utrecht-heading-5{color:var(--utrecht-heading-5-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-heading-5-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-5-font-size);font-weight:var(--utrecht-heading-5-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-heading-5-letter-spacing);line-height:var(--utrecht-heading-5-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-heading-5-text-transform,inherit)}.utrecht-heading-5--distanced{margin-block-end:var(--utrecht-heading-5-margin-block-end);margin-block-start:var(--utrecht-heading-5-margin-block-start)}.utrecht-heading-6{color:var(--utrecht-heading-6-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-heading-6-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-6-font-size);font-weight:var(--utrecht-heading-6-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-heading-6-letter-spacing);line-height:var(--utrecht-heading-6-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-heading-6-text-transform,inherit)}.utrecht-heading-6--distanced{margin-block-end:var(--utrecht-heading-6-margin-block-end);margin-block-start:var(--utrecht-heading-6-margin-block-start)}.utrecht-link-list,.utrecht-link-list--html-ul{margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;padding-inline-start:0}.utrecht-link-list--html-ul>li,.utrecht-link-list>li{list-style:none}.utrecht-link-list{--utrecht-link-text-decoration:none;--utrecht-link-hover-text-decoration:underline;--utrecht-link-focus-text-decoration:underline}.utrecht-link-list--distanced{margin-block-end:var(--utrecht-link-list-margin-block-end,0);margin-block-start:var(--utrecht-link-list-margin-block-start,0)}.utrecht-link-list__item>a:before,.utrecht-link-list__marker{background-image:var(--utrecht-link-list-marker-background-image);background-position-x:left;background-position-y:bottom;background-repeat:no-repeat;display:inline-block;inline-size:var(--utrecht-link-list-marker-inline-size)}.utrecht-link-list__item{display:block;font-weight:var(--utrecht-link-list-item-font-weight)}.utrecht-link-list__item+.utrecht-link-list__item{margin-block-start:var(--utrecht-link-list-item-margin-block-start)}.utrecht-link-list__item>a{display:block}.utrecht-link-list__item>a:before{content:\"\";display:inline-block;height:1em}.utrecht-link-social{--utrecht-icon-color:var(--utrecht-color-white);background-color:var(--utrecht-color-red-40);border:2px solid var(--utrecht-color-white);border-radius:50%;color:var(--utrecht-color-white);display:inline-block;height:2.4em;width:2.4em}.utrecht-link-social--distanced{margin-inline-end:.6em}.utrecht-link{color:var(--utrecht-link-color,blue);text-decoration:var(--utrecht-link-text-decoration,underline);text-decoration-skip-ink:all;text-decoration-thickness:max(var(--utrecht-link-text-decoration-thickness),1px);text-underline-offset:var(--utrecht-link-text-underline-offset)}.utrecht-link-icon-left{background-image:var(--utrecht-link-icon-left-background-image,none);background-position:0 .25em;background-repeat:no-repeat;color:var(--utrecht-link-color,blue);font-weight:var(--utrecht-typography-weight-scale-bold-font-weight);padding-inline-start:var(--utrecht-space-block-md);text-decoration:none}.utrecht-link--visited,.utrecht-link:visited{color:var(--utrecht-link-visited-color,var(--utrecht-link-color))}.utrecht-link--hover,.utrecht-link:hover{text-decoration-skip:none;color:var(--utrecht-link-hover-color,var(--utrecht-link-color));text-decoration:var(--utrecht-link-hover-text-decoration,var(--utrecht-link-text-decoration,underline));text-decoration-skip-ink:none;text-decoration-thickness:max(var(--utrecht-link-hover-text-decoration-thickness,var(--utrecht-link-text-decoration-thickness)),1px)}.utrecht-link--active,.utrecht-link:active{color:var(--utrecht-link-active-color,var(--utrecht-link-color))}.utrecht-link--focus,.utrecht-link:focus{text-decoration-skip:none;color:var(--utrecht-link-focus-color,var(--utrecht-link-color));text-decoration:var(--utrecht-link-focus-text-decoration,var(--utrecht-link-text-decoration,underline));text-decoration-skip-ink:none;text-decoration-thickness:max(var(--utrecht-link-focus-text-decoration-thickness,var(--utrecht-link-text-decoration-thickness)),1px)}.utrecht-link--focus-visible,.utrecht-link:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-link:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-link--telephone{white-space:nowrap}.utrecht-logo-button{--utrecht-button-min-block-size:var(--utrecht-logo-button-block-size,50px);--utrecht-logo-max-height:var(--utrecht-logo-button-block-size,50px);--utrecht-logo-max-width:var(--utrecht-logo-button-block-size,50px);display:inline-flex;gap:var(--utrecht-space-inline-sm)}.utrecht-logo-button__logo{order:1}.utrecht-logo-button__button{order:2}.utrecht-logo{max-height:var(--utrecht-logo-max-height,192px);max-width:var(--utrecht-logo-max-width,96px)}.utrecht-logo__decoration-1{fill:var(--utrecht-logo-decoration-1-color,#fff)}.utrecht-logo__decoration-2{fill:var(--utrecht-logo-decoration-2-color,#c00)}.utrecht-logo__decoration-3{fill:var(--utrecht-logo-decoration-3-color,#ffb70b)}.utrecht-mapcontrolbutton{--utrecht-icon-size:var(--utrecht-mapcontrolbutton-min-block-size);--utrecht-icon-color:var(--utrecht-mapcontrolbutton-color);align-items:center;background-color:var(--utrecht-mapcontrolbutton-background-color);border-color:var(--utrecht-mapcontrolbutton-border-color);border-radius:var(--utrecht-mapcontrolbutton-border-radius);border-style:var(--utrecht-mapcontrolbutton-border-style);border-width:var(--utrecht-mapcontrolbutton-border-width);color:var(--utrecht-mapcontrolbutton-color);display:flex;flex-direction:row;justify-content:center;min-block-size:var(--utrecht-mapcontrolbutton-min-block-size);min-inline-size:var(--utrecht-mapcontrolbutton-min-inline-size);padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}.utrecht-mapcontrolbutton--disabled,.utrecht-mapcontrolbutton:disabled{--utrecht-icon-color:var(--utrecht-mapcontrolbutton-disabled-color,var(--utrecht-mapcontrolbutton-color));background-color:var(--utrecht-mapcontrolbutton-disabled-background-color);border-color:var(--utrecht-mapcontrolbutton-disabled-border-color);color:var(--utrecht-mapcontrolbutton-disabled-color)}.utrecht-mapcontrolbutton--focus-visible,.utrecht-mapcontrolbutton:focus:not(:disabled):not([aria-disabled=true]):not(.utrecht-mapcontrolbutton--disabled){box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-mapcontrolbutton--focus,.utrecht-mapcontrolbutton:focus:not(:disabled):not([aria-disabled=true]):not(.utrecht-mapcontrolbutton--disabled){--utrecht-icon-color:var(--utrecht-mapcontrolbutton-focus-color,var(--utrecht-mapcontrolbutton-color))}.utrecht-mapcontrolbutton:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-mapcontrolbutton--hover:not(:disabled),.utrecht-mapcontrolbutton:hover:not(:disabled):not(.utrecht-mapcontrolbutton--disabled){background-color:var(--utrecht-mapcontrolbutton-hover-background-color);color:var(--utrecht-mapcontrolbutton-color)}.utrecht-mapcontrolbutton__label{display:block;padding-inline-end:var(--utrecht-mapcontrolbutton-label-margin-inline-end);padding-inline-start:var(--utrecht-mapcontrolbutton-label-margin-inline-start)}.utrecht-menulijst{border-bottom:var(--utrecht-border-width-md) solid var(--utrecht-color-grey-90);border-top:var(--utrecht-border-width-md) solid var(--utrecht-color-grey-90);font-family:var(--utrecht-document-font-family);padding-block-end:var(--utrecht-space-block-sm);padding-block-start:var(--utrecht-space-block-sm);padding-inline-start:0}.utrecht-menulijst__item{list-style:none;margin-block-end:var(--utrecht-space-block-sm);margin-block-start:var(--utrecht-space-block-sm)}.utrecht-menulijst__item a:link{background-image:var(--utrecht-menulijst-item-background-image,none);background-position:0 .25em;background-repeat:no-repeat;color:var(--utrecht-menulijst-item-color,var(--utrecht-link-color,blue));display:block;font-weight:var(--utrecht-typography-weight-scale-bold-font-weight);padding-inline-start:var(--utrecht-space-block-md);text-decoration:none}.utrecht-menulijst__item a:hover{color:var(--utrecht-menulijst-item-hover-color,var(--utrecht-link-hover-color,red))}.utrecht-menulijst__link--focus-visible,.utrecht-menulijst__link:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-menulijst__link:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-topnav__link--focus,.utrecht-topnav__link:focus{background-color:var(--utrecht-topnav-link-focus-background-color);text-decoration:var(--utrecht-topnav-link-focus-text-decoration,var(--utrecht-topnav-link-text-decoration,underline))}.utrecht-sidenav{--utrecht-sidenav-connection-color:var(--utrecht-sidenav-item-marker-color);--utrecht-sidenav-connection-inline-size:2px;--utrecht-sidenav-marker-current-color:var(--utrecht-sidenav-link-hover-color);--utrecht-sidenav-marker-offset:26px;--utrecht-sidenav-connection-block-size:100%;--utrecht-sidenav-marker-height:8px;--utrecht-sidenav-marker-outline-width:2px;border-block-end:1px solid var(--utrecht-color-grey-80);border-block-start:1px solid var(--utrecht-color-grey-80);margin-block-start:0;width:19rem}.utrecht-sidenav,.utrecht-sidenav__list{margin-block-end:0;padding-block-end:0;padding-block-start:0}.utrecht-sidenav__list{margin-block-start:.2rem;padding-inline-start:0}.utrecht-sidenav__list--child{margin-block-start:0;padding-inline-end:0;padding-inline-start:1.4rem}.utrecht-sidenav__item{list-style:none;margin-inline-start:0;position:relative}.utrecht-sidenav__item--current{color:var(--utrecht-sidenav-item-hover-color,var(--utrecht-link-hover-color,red))}.utrecht-sidenav__item--last{border-block-end:none}.utrecht-sidenav__item-separator:not(.utrecht-sidenav__item--last .utrecht-sidenav__item-separator){border-block-end:1px solid var(--utrecht-color-grey-80);display:block;margin-inline-start:var(--utrecht-space-inline-lg)}.utrecht-sidenav__link{color:var(--utrecht-sidenav-link-color,var(--utrecht-link-color,blue));display:block;margin-inline-start:0;padding-block-end:var(--utrecht-space-block-xs);padding-block-start:var(--utrecht-space-block-xs);padding-inline-end:var(--utrecht-space-inline-3xs);padding-inline-start:var(--utrecht-space-inline-lg);text-decoration:none}.utrecht-sidenav__link:hover{color:var(--utrecht-sidenav-link-hover-color,var(--utrecht-link-hover-color,red));text-decoration:underline}.utrecht-sidenav__link--focus-visible,.utrecht-sidenav__link:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-sidenav__link--parent{padding-block-end:0}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:not(.utrecht-sidenav__link--sibling):not(.utrecht-sidenav__link--parent):not(.utrecht-sidenav__link--child):after,.utrecht-sidenav__connection{background:var(--utrecht-sidenav-connection-color);bottom:0;content:\"\";display:block;height:calc(var(--utrecht-sidenav-connection-block-size) - var(--utrecht-sidenav-marker-height) - var(--utrecht-sidenav-marker-outline-width)*2);left:3px;overflow:hidden;position:absolute;top:calc(var(--utrecht-sidenav-marker-offset));width:var(--utrecht-sidenav-connection-inline-size);z-index:5}.utrecht-sidenav__connection--last,.utrecht-sidenav__connection--parent,.utrecht-sidenav__connection--sibling{display:none}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:before,.utrecht-sidenav__marker{background-color:var(--utrecht-sidenav-item-marker-color);border-radius:100%;content:\"\";height:var(--utrecht-sidenav-marker-height);left:var(--utrecht-sidenav-marker-offset);overflow:hidden;position:absolute;top:20px;transform:translateY(-50%) translateX(calc(var(--utrecht-sidenav-marker-offset)*-1));width:8px;z-index:10}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link--child:before,.utrecht-sidenav__marker--child{background-color:transparent;border:2px solid var(--utrecht-sidenav-link-color);height:4px;left:1.2rem;top:16px;transform:translateY(-50%) translateX(-19.5px);width:4px}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link--current-child:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link--current:before,.utrecht-sidenav__marker--current{background-color:var(--utrecht-sidenav-marker-current-color)}.utrecht-sidenav__link--child,.utrecht-sidenav__link--current-child{color:var(--utrecht-sidenav-link-color,var(--utrecht-link-color,blue));margin-block-end:0;margin-block-start:0;padding-block-end:var(--utrecht-space-block-2xs);padding-block-start:var(--utrecht-space-block-2xs);padding-inline-end:var(--utrecht-space-inline-3xs);padding-inline-start:var(--utrecht-space-inline-lg);text-decoration:none}.utrecht-sidenav__link--current,.utrecht-sidenav__link--current-child{font-weight:var(--utrecht-typography-weight-scale-bold-font-weight)}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:hover .utrecht-sidenav__link:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:hover:before,.utrecht-sidenav__link:hover .utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:before,.utrecht-sidenav__link:hover .utrecht-sidenav__marker,.utrecht-sidenav__marker--hover{background-color:var(--utrecht-sidenav-link-hover-color)}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link--child.utrecht-sidenav__link:hover:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:hover .utrecht-sidenav__link.utrecht-sidenav__link--child:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:hover .utrecht-sidenav__marker--child.utrecht-sidenav__link:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link:hover .utrecht-sidenav__marker.utrecht-sidenav__link--child:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__marker--child.utrecht-sidenav__link:hover:before,.utrecht-sidenav--pseudo-elements .utrecht-sidenav__marker--hover.utrecht-sidenav__link--child:before,.utrecht-sidenav__link:hover .utrecht-sidenav--pseudo-elements .utrecht-sidenav__link.utrecht-sidenav__link--child:before,.utrecht-sidenav__link:hover .utrecht-sidenav--pseudo-elements .utrecht-sidenav__marker--child.utrecht-sidenav__link:before,.utrecht-sidenav__link:hover .utrecht-sidenav--pseudo-elements .utrecht-sidenav__marker.utrecht-sidenav__link--child:before,.utrecht-sidenav__link:hover .utrecht-sidenav__marker--child.utrecht-sidenav__marker,.utrecht-sidenav__marker--child.utrecht-sidenav__marker--hover{background-color:var(--utrecht-sidenav-link-hover-color);border:2px solid var(--utrecht-sidenav-link-hover-color)}.utrecht-sidenav--pseudo-elements .utrecht-sidenav__link--child:after{display:none}.utrecht-sidenav__link:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-navhtml{font-family:var(--utrecht-font-family-sans-serif)}.utrecht-topnav__list{background-color:var(--utrecht-topnav-list-background-color);display:flex;justify-content:space-between;list-style:none;list-style-image:none;margin-block-end:0;margin-block-start:0;overflow:visible;padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}.utrecht-topnav__item{border-inline-end:1px solid var(--utrecht-topnav-list-border-color);flex:1 0 auto;margin-inline-start:0;text-align:center}.utrecht-topnav__item li:first-child{border-inline-start:1px solid var(--utrecht-topnav-list-border-color);padding-inline-start:0}.utrecht-topnav__link{color:var(--utrecht-topnav-link-color);display:block;padding-block-end:1rem;padding-block-start:1rem;text-decoration:none}.utrecht-topnav__link:hover{background-color:var(--utrecht-topnav-link-hover-background-color);color:var(--utrecht-topnav-link-color);text-decoration:underline}.utrecht-topnav__link--current{background-color:var(--utrecht-topnav-list-background-active);text-decoration:underline}.utrecht-topnav__link--focus,.utrecht-topnav__link:focus{background-color:var(--utrecht-topnav-link-focus-background-color,var(--utrecht-topnav-link-background-color));color:var(--utrecht-topnav-link-focus-color,var(--utrecht-topnav-link-color))}.utrecht-topnav__link--focus-visible,.utrecht-topnav__link:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-topnav__link:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-ordered-list{font-family:var(--utrecht-document-font-family,inherit);margin-block-end:0;margin-block-start:0;padding-inline-start:var(--utrecht-ordered-list-padding-inline-start,var(--utrecht-unordered-list-padding-inline-start,2ch))}.utrecht-ordered-list--distanced{margin-block-end:var(--utrecht-ordered-list-margin-block-end,var(--utrecht-unordered-list-margin-block-end));margin-block-start:var(--utrecht-ordered-list-margin-block-start,var(--utrecht-unordered-list-margin-block-start))}.utrecht-ordered-list--arabic{list-style:arabic-indic}.utrecht-ordered-list__item{margin-block-end:var(--utrecht-ordered-list-item-margin-block-end,var(--utrecht-unordered-list-item-margin-block-end));margin-block-start:var(--utrecht-ordered-list-item-margin-block-start,var(--utrecht-unordered-list-item-margin-block-start));padding-inline-start:var(--utrecht-ordered-list-item-padding-inline-start,var(--utrecht-unordered-list-item-padding-inline-start,1ch))}.utrecht-page-content{padding-block-end:var(--utrecht-page-content-padding-block-end);padding-block-start:var(--utrecht-page-content-padding-block-start);padding-inline-end:var(--utrecht-page-padding-inline-end);padding-inline-start:var(--utrecht-page-padding-inline-start)}.utrecht-page-content__main{grid-area:main}.utrecht-page-content__aside{grid-area:aside}.utrecht-page-footer{--utrecht-document-color:currentColor;--utrecht-heading-color:currentColor;--utrecht-link-color:currentColor;--utrecht-link-focus-color:currentColor;--utrecht-link-hover-color:currentColor;--utrecht-link-active-color:currentColor;--utrecht-link-visited-color:currentColor;background-color:var(--utrecht-page-footer-background-color);background-image:var(--utrecht-page-footer-background-image);color:var(--utrecht-page-footer-color);font-family:var(--utrecht-document-font-family);font-size:var(--utrecht-document-font-size);padding-block-end:var(--utrecht-page-footer-padding-block-end);padding-block-start:var(--utrecht-page-footer-padding-block-start);padding-inline-end:var(--utrecht-page-footer-padding-inline-end);padding-inline-start:var(--utrecht-page-footer-padding-inline-start)}.utrecht-page-footer .utrecht-link--telephone,.utrecht-page-footer .utrecht-paragraph{color:#fff}.utrecht-page-footer__address--reset-address{font-style:inherit;margin-block-end:0;margin-block-start:0}.utrecht-page-header{background-color:var(--utrecht-page-header-background-color);color:var(--utrecht-page-header-color);grid-area:\"utrecht-header\";padding-block-end:var(--utrecht-page-header-padding-block-end);padding-block-start:var(--utrecht-page-header-padding-block-start);padding-inline-end:var(--utrecht-page-padding-inline-end);padding-inline-start:var(--utrecht-page-padding-inline-start)}.utrecht-page-header__content{max-inline-size:var(--utrecht-page-max-inline-size)}.utrecht-page{margin-inline-end:auto;margin-inline-start:auto;max-inline-size:calc(var(--utrecht-page-max-inline-size) - var(--utrecht-page-margin-inline-start, 0px) - var(--utrecht-page-margin-inline-end, 0px));padding-inline-end:var(--utrecht-page-margin-inline-end);padding-inline-start:var(--utrecht-page-margin-inline-start)}.utrecht-page__content{background-color:var(--utrecht-page-background-color);color:var(--utrecht-page-color);max-inline-size:var(--utrecht-page-max-inline-size)}.utrecht-pagination{font-family:var(--utrecht-pagination-font-family,var(--utrecht-document-font-family));font-size:var(--utrecht-pagination-font-size,var(--utrecht-document-font-family))}.utrecht-pagination--distanced{margin-block-end:var(--utrecht-pagination-margin-block-end);margin-block-start:var(--utrecht-pagination-margin-block-start)}.utrecht-pagination__relative-link{background-color:var(--utrecht-pagination-relative-link-background-color);border-color:var(--utrecht-pagination-relative-link-border-color);border-radius:var(--utrecht-pagination-relative-link-border-radius);border-style:solid;border-width:var(--utrecht-pagination-relative-link-border-width,0);color:var(--utrecht-pagination-relative-link-color);display:inline-block;font-weight:var(--utrecht-pagination-relative-link-font-weight);padding-block-end:var(--utrecht-pagination-relative-link-padding-block-end);padding-block-start:var(--utrecht-pagination-relative-link-padding-block-start);padding-inline-end:var(--utrecht-pagination-relative-link-padding-inline-end);padding-inline-start:var(--utrecht-pagination-relative-link-padding-inline-start);text-decoration:var(--utrecht-pagination-relative-link-text-decoration);text-transform:var(--utrecht-pagination-relative-link-text-transform)}.utrecht-pagination__relative-link--next{margin-inline-start:var(--utrecht-pagination-relative-link-distanced-margin-inline-start)}.utrecht-pagination__relative-link--prev{margin-inline-end:var(--utrecht-pagination-relative-link-distanced-margin-inline-end)}.utrecht-pagination__relative-link--disabled{background-color:var(--utrecht-pagination-relative-link-disabled-background-color,var(--utrecht-pagination-relative-link-background-color));color:var(--utrecht-pagination-relative-link-disabled-color,var(--utrecht-pagination-relative-link-color))}.utrecht-pagination__relative-link--hover,.utrecht-pagination__relative-link:hover{background-color:var(--utrecht-pagination-relative-link-hover-background-color,var(--utrecht-pagination-relative-link-background-color));border-color:var(--utrecht-pagination-relative-link-hover-border-color,var(--utrecht-pagination-relative-link-border-color));color:var(--utrecht-pagination-relative-link-hover-color,var(--utrecht-pagination-relative-link-color))}.utrecht-pagination__page-link{background-color:var(--utrecht-pagination-page-link-background-color);border-color:var(--utrecht-pagination-page-link-border-color,0);border-radius:var(--utrecht-pagination-page-link-border-radius);border-style:solid;border-width:var(--utrecht-pagination-page-link-border-width);color:var(--utrecht-pagination-page-link-color);display:inline-block;font-weight:var(--utrecht-pagination-page-link-font-weight);padding-block-end:var(--utrecht-pagination-page-link-padding-block-end);padding-block-start:var(--utrecht-pagination-page-link-padding-block-start);padding-inline-end:var(--utrecht-pagination-page-link-padding-inline-end);padding-inline-start:var(--utrecht-pagination-page-link-padding-inline-start);text-decoration:var(--utrecht-pagination-page-link-text-decoration)}.utrecht-pagination__page-link--current{--utrecht-pagination-page-link-background-color:var(--utrecht-pagination-page-link-current-background-color);--utrecht-pagination-page-link-border-color:var(--utrecht-pagination-page-link-current-border-color);--utrecht-pagination-page-link-color:var(--utrecht-pagination-page-link-current-color)}.utrecht-pagination__page-link--distanced,.utrecht-pagination__page-link~.utrecht-pagination__page-link{margin-inline-start:var(--utrecht-pagination-page-link-distanced-margin-inline-start)}.utrecht-pagination__page-link--hover,.utrecht-pagination__page-link:hover{background-color:var(--utrecht-pagination-page-link-hover-background-color,var(--utrecht-pagination-page-link-background-color));border-color:var(--utrecht-pagination-page-link-hover-border-color,var(--utrecht-pagination-page-link-border-color));color:var(--utrecht-pagination-page-link-hover-color,var(--utrecht-pagination-page-link-color))}.utrecht-pagination__page-link:focus,.utrecht-pagination__relative-link:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-pagination__page-link:focus:not(:focus-visible),.utrecht-pagination__relative-link:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-paragraph{color:var(--utrecht-paragraph-color,var(--utrecht-document-color,inherit));font-family:var(--utrecht-paragraph-font-family,var(--utrecht-document-font-family,inherit));font-size:var(--utrecht-paragraph-font-size,var(--utrecht-document-font-size,inherit));font-weight:var(--utrecht-paragraph-font-weight,inherit);line-height:var(--utrecht-paragraph-line-height,var(--utrecht-document-line-height,inherit));margin-block-end:0;margin-block-start:0}.utrecht-paragraph--lead{color:var(--utrecht-paragraph-lead-color,var(--utrecht-document-color,inherit));font-size:var(--utrecht-paragraph-lead-font-size,inherit);font-weight:var(--utrecht-paragraph-lead-font-weight,inherit);line-height:var(--utrecht-paragraph-lead-line-height,inherit)}.utrecht-paragraph--distanced{margin-block-end:var(--utrecht-paragraph-margin-block-end);margin-block-start:var(--utrecht-paragraph-margin-block-start)}.utrecht-pre-heading{color:var(--utrecht-pre-heading-color,var(--utrecht-heading-color,var(--utrecht-document-color,inherit)));font-family:var(--utrecht-pre-heading-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-pre-heading-font-size);font-weight:var(--utrecht-pre-heading-font-weight,var(--utrecht-heading-font-weight,bold));letter-spacing:var(--utrecht-pre-heading-letter-spacing);line-height:var(--utrecht-pre-heading-line-height);margin-block-end:0;margin-block-start:0;text-transform:var(--utrecht-pre-heading-text-transform,inherit)}.utrecht-pre-heading--distanced{margin-block-end:var(--utrecht-pre-heading-margin-block-end);margin-block-start:var(--utrecht-pre-heading-margin-block-start)}.utrecht-radio-button{margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0}.utrecht-radio-button--disabled,.utrecht-radio-button--html-input:disabled{cursor:var(--utrecht-action-disabled-cursor)}.utrecht-radio-button--focus-visible,.utrecht-radio-button--html-input:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-radio-button--html-input:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-search-bar{--utrecht-button-border-color:var(--utrecht-search-bar-button-border-color);--utrecht-button-focus-transform-scale:var(--utrecht-search-bar-hover-transform);--utrecht-button-font-size:var(--utrecht-search-bar-button-font-size);--utrecht-button-font-weight:var(--utrecht-search-bar-button-font-weight);--utrecht-button-letter-spacing:var(--utrecht-search-bar-button-letter-spacing);--utrecht-button-primary-action-background-color:var(--utrecht-search-bar-button-background-color);--utrecht-button-primary-action-color:var(--utrecht-search-bar-button-color);--utrecht-button-primary-action-hover-background-color:var(--utrecht-search-bar-hover-background-color);--utrecht-button-text-transform:var(--utrecht-search-bar-button-text-transform);--utrecht-textbox-border-color:var(--utrecht-search-bar-textbox-border-color);--utrecht-textbox-padding-inline-start:var(--utrecht-search-bar-textbox-padding-inline-start);--utrecht-textbox-border-bottom-width:var(--utrecht-search-bar-textbox-border-bottom-width);display:flex}.utrecht-search-bar__input{background-image:var(--utrecht-search-bar-input-background-image,none);background-position-x:var(--utrecht-search-bar-textbox-background-position-x);background-position-y:var(--utrecht-search-bar-textbox-background-position-y);background-repeat:no-repeat;background-size:var(--utrecht-search-bar-textbox-background-size)}.utrecht-select{-moz-appearance:none;-webkit-appearance:none;appearance:none;background-color:var(--utrecht-select-background-color,var(--utrecht-form-input-background-color));background-image:var(--utrecht-select-background-image);background-position:100%;background-repeat:no-repeat;background-size:1.4em;border-block-end-width:var(--utrecht-select-border-block-end-width,var(--utrecht-select-border-width,var(--utrecht-form-input-border-width)));border-block-start-width:var(--utrecht-select-border-width,var(--utrecht-form-input-border-width));border-color:var(--utrecht-select-border-color,var(--utrecht-form-input-border-color));border-inline-end-width:var(--utrecht-select-border-width,var(--utrecht-form-input-border-width));border-inline-start-width:var(--utrecht-select-border-width,var(--utrecht-form-input-border-width));border-radius:var(--utrecht-select-border-radius,var(--utrecht-form-input-border-radius,0));border-style:solid;color:var(--utrecht-select-color,var(--utrecht-form-input-color));font-family:var(--utrecht-select-font-family,var(--utrecht-form-input-font-family));font-size:var(--utrecht-select-font-size,var(--utrecht-form-input-font-size));max-inline-size:var(--utrecht-select-max-inline-size,var(--utrecht-form-input-max-inline-size));padding-block-end:var(--utrecht-select-padding-block-end,var(--utrecht-form-input-padding-block-end));padding-block-start:var(--utrecht-select-padding-block-start,var(--utrecht-form-input-padding-block-start));padding-inline-end:var(--utrecht-select-padding-inline-end,var(--utrecht-form-input-padding-inline-end));padding-inline-start:var(--utrecht-select-padding-inline-start,var(--utrecht-form-input-padding-inline-start));width:100%}.utrecht-select--disabled,.utrecht-select--html-select:disabled{background-color:var(--utrecht-select-disabled-background-color,var(--utrecht-form-input-disabled-background-color,var(--utrecht-select-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-select-disabled-border-color,var(--utrecht-form-input-disabled-border-color,var(--utrecht-select-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-select-disabled-color,var(--utrecht-form-input-disabled-color,var(--utrecht-select-color,var(--utrecht-form-input-color))));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-select--focus,.utrecht-select--html-select:focus{background-color:var(--utrecht-select-focus-background-color,var(--utrecht-form-input-focus-background-color,var(--utrecht-select-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-select-focus-border-color,var(--utrecht-form-input-focus-border-color,var(--utrecht-select-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-select-focus-color,var(--utrecht-form-input-focus-color,var(--utrecht-select-color,var(--utrecht-form-input-color))))}.utrecht-select--focus-visible,.utrecht-select--html-select:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-select--html-select:invalid,.utrecht-select--html-select[aria-invalid=true],.utrecht-select--invalid{background-color:var(--utrecht-select-invalid-background-color,var(--utrecht-form-input-invalid-background-color,var(--utrecht-select-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-select-invalid-border-color,var(--utrecht-form-input-invalid-border-color,var(--utrecht-select-border-color,var(--utrecht-form-input-border-color))));border-width:var(--utrecht-select-invalid-border-width,var(--utrecht-form-input-invalid-border-width,var(--utrecht-select-border-width,var(--utrecht-form-input-border-width))))}.utrecht-select--html-select:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-separator{border-color:var(--utrecht-separator-color);border-style:solid;border-width:0 0 var(--utrecht-separator-block-size) 0}.utrecht-separator--distanced{margin-block-end:var(--utrecht-separator-margin-block-end);margin-block-start:var(--utrecht-separator-margin-block-start)}.utrecht-surface{background-color:var(--utrecht-surface-background-color,inherit);color:var(--utrecht-surface-color,inherit)}.utrecht-surface--reset-body{margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0}.utrecht-table{border-collapse:collapse;border-color:var(--utrecht-table-border-color,0);border-style:solid;border-width:var(--utrecht-table-border-width,0);font-family:var(--utrecht-table-font-family,var(--utrecht-document-font-family));font-size:var(--utrecht-table-font-size,inherit);width:100%}.utrecht-table--distanced{margin-block-end:var(--utrecht-table-margin-block-end);margin-block-start:var(--utrecht-table-margin-block-start)}.utrecht-table__caption{color:var(--utrecht-table-caption-color);font-family:var(--utrecht-table-caption-font-family);font-size:var(--utrecht-table-caption-font-size);font-weight:var(--utrecht-table-caption-font-weight);line-height:var(--utrecht-table-caption-line-height);margin-block-end:var(--utrecht-table-caption-margin-block-end);text-align:var(--utrecht-table-caption-text-align,center)}.utrecht-table__header{background-color:var(--utrecht-table-header-background-color);color:var(--utrecht-table-header-color);font-weight:var(--utrecht-table-header-font-weight);text-transform:var(--utrecht-table-header-text-transform);vertical-align:bottom}.utrecht-table__cell--last-header-row{border-block-end-color:var(--utrecht-table-header-border-block-end-color,transparent);border-block-end-style:solid;border-block-end-width:var(--utrecht-table-header-border-block-end-width,0)}.utrecht-table__body{vertical-align:baseline}.utrecht-table__heading{color:var(--utrecht-table-heading-color);font-size:var(--utrecht-table-heading-font-size);font-weight:var(--utrecht-table-heading-font-weight);text-transform:var(--utrecht-table-heading-text-transform)}.utrecht-table__cell{border-block-end-color:var(--utrecht-table-row-border-block-end-color,transparent);border-block-end-style:solid;border-block-end-width:var(--utrecht-table-row-border-block-end-width,0);line-height:var(--utrecht-table-cell-line-height,inherit);padding-block-end:var(--utrecht-table-cell-padding-block-end,0);padding-block-start:var(--utrecht-table-cell-padding-block-start,0);padding-inline-end:var(--utrecht-table-cell-padding-inline-end,0);padding-inline-start:var(--utrecht-table-cell-padding-inline-start,0);text-align:start}.utrecht-table__cell--first{padding-inline-start:var(--utrecht-table-row-padding-inline-start,var(--utrecht-table-cell-padding-inline-start,0))}.utrecht-table__cell--last{padding-inline-end:var(--utrecht-table-row-padding-inline-end,var(--utrecht-table-cell-padding-inline-end,0))}.utrecht-table__cell--numeric-column{text-align:right}.utrecht-table__cell--numeric-data{font-variant-numeric:lining-nums tabular-nums}.utrecht-table__row--alternate-odd{background-color:var(--utrecht-table-row-alternate-odd-background-color);color:var(--utrecht-table-row-alternate-odd-color)}.utrecht-table__row--alternate-even{background-color:var(--utrecht-table-row-alternate-even-background-color);color:var(--utrecht-table-row-alternate-even-color)}.utrecht-textarea{background-color:var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color));border-width:var(--utrecht-textarea-border-width,var(--utrecht-form-input-border-width));border-bottom-width:var(--utrecht-textarea-border-bottom-width,var(--utrecht-textarea-border-width,var(--utrecht-form-input-border-width)));border-color:var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color));border-radius:var(--utrecht-textarea-border-radius,var(--utrecht-form-input-border-radius,0));border-style:solid;box-sizing:border-box;color:var(--utrecht-textarea-color,var(--utrecht-form-input-color));font-family:var(--utrecht-textarea-font-family,var(--utrecht-form-input-font-family));font-size:var(--utrecht-textarea-font-size,var(--utrecht-form-input-font-size,1em));max-inline-size:var(--utrecht-textarea-max-inline-size,var(--utrecht-form-input-max-inline-size));min-block-size:var(--utrecht-textarea-min-block-size);padding-block-end:var(--utrecht-textarea-padding-block-end,var(--utrecht-form-input-padding-block-end));padding-block-start:var(--utrecht-textarea-padding-block-start,var(--utrecht-form-input-padding-block-start));padding-inline-end:var(--utrecht-textarea-padding-inline-end,var(--utrecht-form-input-padding-inline-end));padding-inline-start:var(--utrecht-textarea-padding-inline-start,var(--utrecht-form-input-padding-inline-start));resize:vertical;width:100%}.utrecht-textarea--html-textarea:invalid,.utrecht-textarea--html-textarea[aria-invalid=true],.utrecht-textarea--invalid{background-color:var(--utrecht-textarea-invalid-background-color,var(--utrecht-form-input-invalid-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textarea-invalid-border-color,var(--utrecht-form-input-invalid-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));border-width:var(--utrecht-textarea-invalid-border-width,var(--utrecht-form-input-invalid-border-width,var(--utrecht-textarea-border-width,var(--utrecht-form-input-border-width))))}.utrecht-textarea--disabled,.utrecht-textarea--html-textarea:disabled{background-color:var(--utrecht-textarea-disabled-background-color,var(--utrecht-form-input-disabled-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textarea-disabled-border-color,var(--utrecht-form-input-disabled-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textarea-disabled-color,var(--utrecht-form-input-disabled-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-textarea--focus,.utrecht-textarea--html-textarea:focus{background-color:var(--utrecht-textarea-focus-background-color,var(--utrecht-form-input-focus-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textarea-focus-border-color,var(--utrecht-form-input-focus-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textarea-focus-color,var(--utrecht-form-input-focus-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))))}.utrecht-textarea--focus-visible,.utrecht-textarea--html-textarea:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-textarea--html-textarea:read-only,.utrecht-textarea--read-only{border-color:var(--utrecht-textarea-read-only-border,var(--utrecht-form-input-read-only-border-color,var(--utrecht-textarea-border,var(--utrecht-form-input-border-color))));color:var(--utrecht-textarea-read-only-color,var(--utrecht-form-input-read-only-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))))}.utrecht-textarea--html-textarea::placeholder,.utrecht-textarea__placeholder{color:var(--utrecht-textarea-placeholder-color,var(--utrecht-form-input-placeholder-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))));font-style:var(--utrecht-form-input-placeholder-font-style);opacity:100%}.utrecht-textarea--html-textarea:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-textbox{background-color:var(--utrecht-textbox-background-color,var(--utrecht-form-input-background-color));border-width:var(--utrecht-textbox-border-width,var(--utrecht-form-input-border-width));border-bottom-width:var(--utrecht-textbox-border-bottom-width,var(--utrecht-textbox-border-width,var(--utrecht-form-input-border-width)));border-color:var(--utrecht-textbox-border-color,var(--utrecht-form-input-border-color));border-radius:var(--utrecht-textbox-border-radius,var(--utrecht-form-input-border-radius,0));border-style:solid;box-sizing:border-box;color:var(--utrecht-textbox-color,var(--utrecht-form-input-color));font-family:var(--utrecht-textbox-font-family,var(--utrecht-form-input-font-family));font-size:var(--utrecht-textbox-font-size,var(--utrecht-form-input-font-size,1em));max-inline-size:var(--utrecht-textbox-max-inline-size,var(--utrecht-form-input-max-inline-size));padding-block-end:var(--utrecht-textbox-padding-block-end,var(--utrecht-form-input-padding-block-end));padding-block-start:var(--utrecht-textbox-padding-block-start,var(--utrecht-form-input-padding-block-start));padding-inline-end:var(--utrecht-textbox-padding-inline-end,var(--utrecht-form-input-padding-inline-end));padding-inline-start:var(--utrecht-textbox-padding-inline-start,var(--utrecht-form-input-padding-inline-start));width:100%}.utrecht-textbox--html-input:invalid,.utrecht-textbox--html-input[aria-invalid=true],.utrecht-textbox--invalid{background-color:var(--utrecht-textbox-invalid-background-color,var(--utrecht-form-input-invalid-background-color,var(--utrecht-textbox-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textbox-invalid-border-color,var(--utrecht-form-input-invalid-border-color,var(--utrecht-textbox-border-color,var(--utrecht-form-input-border-color))));border-width:var(--utrecht-textbox-invalid-border-width,var(--utrecht-form-input-invalid-border-width,var(--utrecht-textbox-border-width,var(--utrecht-form-input-border-width))))}.utrecht-textbox--disabled,.utrecht-textbox--html-input:disabled{background-color:var(--utrecht-textbox-disabled-background-color,var(--utrecht-form-input-disabled-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textbox-disabled-border-color,var(--utrecht-form-input-disabled-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textbox-disabled-color,var(--utrecht-form-input-disabled-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-textbox--focus,.utrecht-textbox--html-input:focus{background-color:var(--utrecht-textbox-focus-background-color,var(--utrecht-form-input-focus-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textbox-focus-border-color,var(--utrecht-form-input-focus-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textbox-focus-color,var(--utrecht-form-input-focus-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))))}.utrecht-textbox--focus-visible,.utrecht-textbox--html-input:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-textbox--html-input:read-only,.utrecht-textbox--read-only{border-color:var(--utrecht-textbox-read-only-border-color,var(--utrecht-form-input-read-only-border-color,var(--utrecht-textbox-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textbox-read-only-color,var(--utrecht-form-input-read-only-color,var(--utrecht-textbox-color,var(--utrecht-form-input-color))))}.utrecht-textbox--html-input::placeholder,.utrecht-textbox__placeholder{color:var(--utrecht-textbox-placeholder-color,var(--utrecht-form-input-placeholder-color,var(--utrecht-textbox-color,var(--utrecht-form-input-color))));font-style:var(--utrecht-form-input-placeholder-font-style);opacity:100%}.utrecht-textbox--numeric{font-variant-numeric:lining-nums tabular-nums}.utrecht-textbox--password{font-variant-numeric:slashed-zero}.utrecht-textbox--password,.utrecht-textbox--url{font-variant-ligatures:none}.utrecht-textbox--html-input:focus:not(:focus-visible){box-shadow:none;outline-style:none}.utrecht-unordered-list{font-family:var(--utrecht-document-font-family,inherit);font-size:var(--utrecht-document-font-size,inherit);line-height:var(--utrecht-document-line-height,inherit);margin-block-end:0;margin-block-start:0;padding-inline-start:var(--utrecht-unordered-list-padding-inline-start,2ch)}.utrecht-unordered-list--distanced{margin-block-end:var(--utrecht-unordered-list-margin-block-end,var(--utrecht-paragraph-margin-block-end));margin-block-start:var(--utrecht-unordered-list-margin-block-start,var(--utrecht-paragraph-margin-block-start))}.utrecht-unordered-list--nested{margin-block-end:0;margin-inline-start:2ch}.utrecht-unordered-list__item{margin-block-end:var(--utrecht-unordered-list-item-margin-block-end);margin-block-start:var(--utrecht-unordered-list-item-margin-block-start);padding-inline-start:var(--utrecht-unordered-list-item-padding-inline-start,1ch)}.utrecht-unordered-list__item::marker,.utrecht-unordered-list__marker{color:var(--utrecht-unordered-list-marker-color);content:\"●\"}.utrecht-url{font-variant-ligatures:none}";
styleInject$5(css_248z$a);/**
 * Styles provider to be placed at the root of your application in which all other denhaag-components will exist.
 * @param props Only allow for children
 */
var StylesProvider = function (props) {
    return (React__default__default.createElement("div", { className: 'utrecht-document utrecht-document--surface' },
        React__default__default.createElement(StylesProvider$1, { injectFirst: true }, props.children)));
};var __assign$3 = function() {
    __assign$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};function styleInject$4(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$3$1 = ".denhaag-tabs__tab{color:var(--denhaag-tabs-tab-color);font-family:var(--denhaag-tabs-tab-font-family);font-size:var(--denhaag-tabs-tab-font-size);font-weight:var(--denhaag-tabs-tab-font-weight);line-height:1.5;padding-block-end:var(--denhaag-tabs-tab-padding-block-end);padding-block-start:var(--denhaag-tabs-tab-padding-block-start);padding-inline-end:var(--denhaag-tabs-tab-padding-inline-end);padding-inline-start:var(--denhaag-tabs-tab-padding-inline-start)}.denhaag-tabs__tab.denhaag-tabs__tab--selected{font-weight:var(--denhaag-tabs-tab-selected-font-weight)}.denhaag-tabs__tab--focus:after,.denhaag-tabs__tab:focus:after{border:var(--denhaag-focus-border);bottom:0;content:\"\";left:0;position:absolute;right:0;top:0}";
styleInject$4(css_248z$3$1);function toVal$4(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$4(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$4 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$4(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * Tabs make it easy to explore and switch between different views.
 * @param props The properties of a Tab component.
 * @constructor Construct an instance of Tab.
 */
var Tab = function (props) {
    var rootClassNames = clsx$4('denhaag-tabs__tab', props.className);
    return (React__default__default.createElement(Tab$1, __assign$3({}, props, { classes: { selected: 'denhaag-tabs__tab--selected' }, className: rootClassNames, disableRipple: true })));
};/**
 * Serves as a wrapper for the Tabs component.
 * @param props The properties of a TabContext component.
 * @constructor Constructs an instance of TabContext.
 */
var TabContext = function (props) {
    return React__default__default.createElement(TabContext$1, __assign$3({}, props), props.children);
};/**
 * Wraps Tab components in a single list.
 * @param props The properties of a TabList component.
 * @constructor Constructs an instance of TabList.
 */
var TabList = function (props) {
    return React__default__default.createElement(TabList$1, __assign$3({}, props), props.children);
};var css_248z$2$1 = ".denhaag-tabs__tab-panel{padding-block-end:var(--denhaag-tabs-tab-panel-padding-block-end);padding-block-start:var(--denhaag-tabs-tab-panel-padding-block-start);padding-inline-end:var(--denhaag-tabs-tab-panel-padding-inline-end);padding-inline-start:var(--denhaag-tabs-tab-panel-padding-inline-start)}";
styleInject$4(css_248z$2$1);/**
 * A wrapper for the selected Tab component in a Tabs component.
 * @param props The properties of a TabPanel component.
 * @constructor Constructs an instance of TabPanel.
 */
var TabPanel = function (props) {
    var rootClassNames = clsx$4(props.className, 'denhaag-tabs__tab-panel');
    return (React__default__default.createElement(TabPanel$1, __assign$3({}, props, { className: rootClassNames }), props.children));
};/**
 * A TabScrollButton allows users to scroll vertically or horizontally through tabs. Appears and hides based on viewport width.
 * @param props The properties of a TabScrollButton component.
 * @constructor Constructs an instance of TabScrollButton.
 */
var TabScrollButton = function (props) {
    return React__default__default.createElement(TabScrollButton$1, __assign$3({}, props), props.children);
};var css_248z$1$3 = ".denhaag-tabs__container{border-bottom:var(--denhaag-tabs-border-width) var(--denhaag-tabs-border-style) var(--denhaag-tabs-border-color)}.denhaag-tabs__tab-indicator{background-color:var(--denhaag-tabs-tab-indicator-border-color);height:var(--denhaag-tabs-tab-indicator-border-width)}";
styleInject$4(css_248z$1$3);var css_248z$9 = ".denhaag-tabs{min-height:0}.denhaag-tabs__tab{min-height:0;opacity:inherit;text-transform:none}.denhaag-tabs__tab-indicator{transition:none}.denhaag-tabs__tab-panel{padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}";
styleInject$4(css_248z$9);/**
 * Tabs make it easy to explore and switch between different views.
 * @param props The properties of a Tabs component.
 * @constructor Constructs an instance of Tabs.
 */
var Tabs = function (props) {
    var rootClassNames = clsx$4(props.className);
    return (React__default__default.createElement(Tabs$1, __assign$3({ classes: {
            root: 'denhaag-tabs',
            flexContainer: 'denhaag-tabs__container',
            indicator: 'denhaag-tabs__tab-indicator',
        } }, props, { className: rootClassNames }), props.children));
};var __assign$1$1 = function() {
    __assign$1$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1$1.apply(this, arguments);
};function styleInject$1$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1$2 = ".denhaag-textfield__input,.utrecht-textbox{background-color:var(--utrecht-textbox-background-color,var(--utrecht-form-input-background-color));border-width:var(--utrecht-textbox-border-width,var(--utrecht-form-input-border-width));border-bottom-width:var(--utrecht-textbox-border-bottom-width,var(--utrecht-textbox-border-width,var(--utrecht-form-input-border-width)));border-color:var(--utrecht-textbox-border-color,var(--utrecht-form-input-border-color));border-radius:var(--utrecht-textbox-border-radius,var(--utrecht-form-input-border-radius,0));border-style:solid;box-sizing:border-box;color:var(--utrecht-textbox-color,var(--utrecht-form-input-color));font-family:var(--utrecht-textbox-font-family,var(--utrecht-form-input-font-family));font-size:var(--utrecht-textbox-font-size,var(--utrecht-form-input-font-size,1em));max-inline-size:var(--utrecht-textbox-max-inline-size,var(--utrecht-form-input-max-inline-size));padding-block-end:var(--utrecht-textbox-padding-block-end,var(--utrecht-form-input-padding-block-end));padding-block-start:var(--utrecht-textbox-padding-block-start,var(--utrecht-form-input-padding-block-start));padding-inline-end:var(--utrecht-textbox-padding-inline-end,var(--utrecht-form-input-padding-inline-end));padding-inline-start:var(--utrecht-textbox-padding-inline-start,var(--utrecht-form-input-padding-inline-start));width:100%}.denhaag-textfield__input--invalid,.denhaag-textfield__input:invalid,.utrecht-textbox--html-input:invalid,.utrecht-textbox--html-input[aria-invalid=true],.utrecht-textbox--invalid{background-color:var(--utrecht-textbox-invalid-background-color,var(--utrecht-form-input-invalid-background-color,var(--utrecht-textbox-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textbox-invalid-border-color,var(--utrecht-form-input-invalid-border-color,var(--utrecht-textbox-border-color,var(--utrecht-form-input-border-color))));border-width:var(--utrecht-textbox-invalid-border-width,var(--utrecht-form-input-invalid-border-width,var(--utrecht-textbox-border-width,var(--utrecht-form-input-border-width))))}.denhaag-textfield__input--disabled,.denhaag-textfield__input:disabled,.utrecht-textbox--disabled,.utrecht-textbox--html-input:disabled{background-color:var(--utrecht-textbox-disabled-background-color,var(--utrecht-form-input-disabled-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textbox-disabled-border-color,var(--utrecht-form-input-disabled-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textbox-disabled-color,var(--utrecht-form-input-disabled-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))));cursor:var(--utrecht-action-disabled-cursor)}.utrecht-textbox--focus,.utrecht-textbox--html-input:focus{background-color:var(--utrecht-textbox-focus-background-color,var(--utrecht-form-input-focus-background-color,var(--utrecht-textarea-background-color,var(--utrecht-form-input-background-color))));border-color:var(--utrecht-textbox-focus-border-color,var(--utrecht-form-input-focus-border-color,var(--utrecht-textarea-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textbox-focus-color,var(--utrecht-form-input-focus-color,var(--utrecht-textarea-color,var(--utrecht-form-input-color))))}.utrecht-textbox--focus-visible,.utrecht-textbox--html-input:focus{box-shadow:0 0 0 var(--utrecht-focus-box-shadow-spread-radius,0) var(--utrecht-focus-box-shadow-color,transparent);outline-color:var(--utrecht-focus-outline-color,transparent);outline-offset:0;outline-style:var(--utrecht-focus-outline-style,solid);outline-width:var(--utrecht-focus-outline-width,0)}.utrecht-textbox--html-input:read-only,.utrecht-textbox--read-only{border-color:var(--utrecht-textbox-read-only-border-color,var(--utrecht-form-input-read-only-border-color,var(--utrecht-textbox-border-color,var(--utrecht-form-input-border-color))));color:var(--utrecht-textbox-read-only-color,var(--utrecht-form-input-read-only-color,var(--utrecht-textbox-color,var(--utrecht-form-input-color))))}.denhaag-textfield__input::placeholder,.utrecht-textbox--html-input::placeholder,.utrecht-textbox__placeholder{color:var(--utrecht-textbox-placeholder-color,var(--utrecht-form-input-placeholder-color,var(--utrecht-textbox-color,var(--utrecht-form-input-color))));font-style:var(--utrecht-form-input-placeholder-font-style);opacity:100%}.utrecht-textbox--numeric{font-variant-numeric:lining-nums tabular-nums}.utrecht-textbox--password{font-variant-numeric:slashed-zero}.utrecht-textbox--password,.utrecht-textbox--url{font-variant-ligatures:none}.utrecht-textbox--html-input:focus:not(:focus-visible){box-shadow:none;outline-style:none}.denhaag-textfield{display:inline-block;margin-block-end:var(--denhaag-form-input-margin-block-end);margin-block-start:var(--denhaag-form-input-margin-block-start);position:relative;width:100%}.denhaag-textfield--focus-within:after,.denhaag-textfield:focus-within:after{border:var(--denhaag-focus-border);border-radius:var(--denhaag-border-radius);bottom:-2px;content:\"\";display:block;left:-2px;position:absolute;right:-2px;top:-2px}.denhaag-textfield__input{line-height:var(--denhaag-form-input-line-height);margin-block-end:0;margin-block-start:0}.denhaag-textfield__input:focus{outline:none}.denhaag-textfield__input:focus-visible{outline:none}.denhaag-textfield__input--disabled::placeholder,.denhaag-textfield__input:disabled::placeholder{color:var(--utrecht-form-input-disabled-color)}.denhaag-textfield__input--invalid,.denhaag-textfield__input:invalid{padding-inline-end:calc(var(--utrecht-form-input-padding-inline-end)*2 + var(--denhaag-form-input-icon-font-size)*2)}.denhaag-textfield__icons{align-items:center;color:var(--utrecht-form-input-color);column-gap:8px;display:flex;flex-direction:row;height:100%;padding-inline-end:var(--utrecht-form-input-padding-inline-end);position:absolute;right:0;top:0}.denhaag-textfield__icons svg{font-size:var(--denhaag-form-input-icon-font-size)}.denhaag-textfield__invalid-icon{color:var(--utrecht-form-input-invalid-border-color)}.denhaag-textfield__input--disabled~.denhaag-textfield__icons svg,.denhaag-textfield__input:disabled~.denhaag-textfield__icons svg{color:var(--utrecht-form-input-disabled-color);cursor:var(--utrecht-action-disabled-cursor)}";
styleInject$1$1(css_248z$1$2);function toVal$1$1(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1$1(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1$1 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1$1(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest$2(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$3(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$3(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$3 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$3(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon$1 = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest$2(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$3({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign$2({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$3(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$8 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$3(css_248z$8);var _path$i, _path2$3;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function SvgCircleWarning(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$i({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React__default.createElement("path", {
    d: "M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z",
    fill: "currentColor"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React__default.createElement("path", {
    d: "M12 14a1 1 0 01-1-1V7a1 1 0 112 0v6a1 1 0 01-1 1zM10.5 16.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    fill: "currentColor"
  })));
}

var MemoSvgCircleWarning = /*#__PURE__*/React__default.memo(SvgCircleWarning);var buildIcon$1 = function (svg, props) { return (React__default__default.createElement(SvgIcon$1, __assign$2({ component: svg }, props))); };
var CircleWarningIcon = function (props) { return buildIcon$1(MemoSvgCircleWarning, props); };var TextField = forwardRef(function DenHaagTextField(props, ref) {
    var inputClasses = clsx$1$1('denhaag-textfield__input', {
        'denhaag-textfield__input--invalid': props.invalid,
        'denhaag-textfield__input--disabled': props.disabled,
    });
    var invalidIcon = React__default__default.cloneElement(props.invalidIcon || React__default__default.createElement(CircleWarningIcon, null), {
        className: 'denhaag-textfield__invalid-icon',
    });
    return (React__default__default.createElement("div", { className: 'denhaag-textfield' },
        React__default__default.createElement("input", __assign$1$1({ className: inputClasses, ref: ref, "aria-invalid": props.invalid || undefined }, props)),
        React__default__default.createElement("div", { className: 'denhaag-textfield__icons' },
            props.invalid && invalidIcon,
            props.icon)));
});function toVal$1(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}/**
 * The `Timeline` displays a progress through a sequence by breaking it up into
 * multiple logical and numbered steps. Use the timeline when a series of
 * information needs to be ordered by time (ascending or descending). It
 * represents the steps in a process in a chronological order. This process is
 * part of, for example, a request that the user has made.
 *
 * @param props The properties of a Timeline component.
 * @constructor Constructs an instance of Timeline.
 */
var Timeline = function (_a) {
    var activeStep = _a.activeStep, children = _a.children, _b = _a.id, id = _b === void 0 ? undefined : _b, className = _a.className;
    var timelineClassName = clsx$1('denhaag-timeline', className);
    return (React__default__default.createElement(Stepper, { activeStep: activeStep, connector: React__default__default.createElement(React__default__default.Fragment, null), id: id, nonLinear: true, orientation: "vertical", className: timelineClassName }, children));
};function styleInject$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$6 = ".denhaag-timeline{padding-block-end:0;padding-block-start:0;padding-inline-end:0;padding-inline-start:0}.denhaag-timeline__step-content{border-left:none}.denhaag-timeline__step-content:empty{margin-block-start:0}.denhaag-timeline__step-label{display:flex}.denhaag-timeline__step-label-text{align-items:center;display:flex;margin-block-end:0;margin-block-start:0;margin-inline-end:0;margin-inline-start:0;overflow:hidden;text-overflow:ellipsis}.denhaag-timeline__step-label-text--hover,.denhaag-timeline__step-label-text:hover{height:auto;overflow:visible;white-space:normal}";
styleInject$1(css_248z$6);var css_248z$5 = ".denhaag-timeline__step-content:not(:empty){color:var(--denhaag-timeline-step-content-color);margin-block-start:var(--denhaag-timeline-step-content-margin)}";
styleInject$1(css_248z$5);var css_248z$4 = ".denhaag-timeline__step-icon{color:var(--denhaag-timeline-step-icon-color);height:var(--denhaag-timeline-step-icon-size);margin-block-end:var(--denhaag-timeline-step-icon-margin);margin-block-start:var(--denhaag-timeline-step-icon-margin);padding-inline-end:var(--denhaag-timeline-step-icon-padding);width:var(--denhaag-timeline-step-icon-size)}.denhaag-timeline__step-icon--active{color:var(--denhaag-timeline-step-icon-active-color)}.denhaag-timeline__step-icon--completed{color:var(--denhaag-timeline-step-icon-completed-color)}.denhaag-timeline__step-icon--disabled{color:var(--denhaag-timeline-step-icon-disabled-color)}.denhaag-timeline__step-icon-text{font-size:var(--denhaag-timeline-step-icon-text-font-size)}.denhaag-timeline__step-icon-text--active{fill:var(--denhaag-timeline-step-icon-text-active-color)}";
styleInject$1(css_248z$4);var css_248z$3 = ".denhaag-timeline__step-label--active{color:var(--denhaag-timeline-step-label-active-color);font-weight:var(--denhaag-timeline-step-label-active-font-weight)}.denhaag-timeline__step-label--completed--hover,.denhaag-timeline__step-label--completed:not(:only-child):hover{color:var(--denhaag-timeline-step-label-completed-hover-color);cursor:pointer}.denhaag-timeline__step-label--disabled{color:var(--denhaag-timeline-step-label-disabled-color)}";
styleInject$1(css_248z$3);var css_248z$2 = ".denhaag-timeline__step{padding-block-end:var(--denhaag-timeline-step-padding);padding-block-start:var(--denhaag-timeline-step-padding)}.denhaag-timeline__step--focus,.denhaag-timeline__step:focus,.denhaag-timeline__step:focus-visible{outline:var(--denhaag-timeline-step-outline);outline-offset:var(--denhaag-timeline-step-outline-offset)}.denhaag-timeline__step-collapse-icon{height:var(--denhaag-timeline-step-collapse-icon-size);padding-inline-start:var(--denhaag-timeline-step-collapse-icon-padding);width:var(--denhaag-timeline-step-collapse-icon-size)}";
styleInject$1(css_248z$2);var css_248z$1$1 = ".denhaag-timeline{font-family:var(--denhaag-timeline-font-family);font-size:var(--denhaag-timeline-font-size);line-height:var(--denhaag-timeline-line-height)}";
styleInject$1(css_248z$1$1);/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}function toVal$2(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$2(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$2 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$2(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var SvgIcon = function (_a) {
    var _b;
    var className = _a.className, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.focusable, focusable = _d === void 0 ? 'false' : _d, _e = _a.shapeRendering, shapeRendering = _e === void 0 ? 'auto' : _e, _f = _a.useDefaultClass, useDefaultClass = _f === void 0 ? true : _f, props = __rest(_a, ["className", "component", "focusable", "shapeRendering", "useDefaultClass"]);
    var iconClassName = clsx$2({ 'denhaag-icon': useDefaultClass }, className);
    var Component = component;
    return (React__default__default.createElement(Component, __assign({ className: iconClassName, focusable: focusable, "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true, "shape-rendering": shapeRendering }, props), props.children));
};function styleInject$2(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$7 = ".denhaag-icon{fill:currentcolor;display:inline-block;flex-shrink:0;font-size:1.5rem;height:1em;transition:fill .2s cubic-bezier(.4,0,.2,1) 0ms;width:1em}";
styleInject$2(css_248z$7);var _path$l, _path2$6;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function SvgCheckCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends$l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React__default.createElement("path", {
    d: "M22 11.08V12a10 10 0 11-5.93-9.14",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React__default.createElement("path", {
    d: "M22 4L12 14.01l-3-3",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var MemoSvgCheckCircle = /*#__PURE__*/React__default.memo(SvgCheckCircle);var buildIcon = function (svg, props) { return (React__default__default.createElement(SvgIcon, __assign({ component: svg }, props))); };
var CheckCircleIcon = function (props) { return buildIcon(MemoSvgCheckCircle, props); };/**
 * Represents a single Step in a Stepper component.
 * @param props The properties of a Step component.
 * @constructor Constructs an instance of Step.
 */
var StepContent = function (_a) {
    var TransitionComponent = _a.TransitionComponent, TransitionProps = _a.TransitionProps, transitionDuration = _a.transitionDuration, children = _a.children, _b = _a.id, id = _b === void 0 ? undefined : _b, props = __rest$1(_a, ["TransitionComponent", "TransitionProps", "transitionDuration", "children", "id"]);
    var rootClassNames = clsx$1('denhaag-timeline__step-content', props.className);
    return (React__default__default.createElement(StepContent$1, __assign$1({ id: id, TransitionComponent: TransitionComponent, TransitionProps: TransitionProps, transitionDuration: transitionDuration }, props, { className: rootClassNames }), children));
};/**
 * Displays an icon in a Step component within a Stepper component.
 * @param props The properties of a StepIcon component.
 * @constructor Constructs an instance of StepIcon.
 */
var StepIcon = function (_a) {
    var icon = _a.icon, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.completed, completed = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.id, id = _e === void 0 ? undefined : _e;
    var textClasses = clsx$1('denhaag-timeline__step-icon-text', {
        'denhaag-timeline__step-icon-text--active': active,
    });
    // Exported from https://www.figma.com/file/JpoY3waVoQGlLQzQXTL9nn/Design-System-Gemeente-Den-Haag?node-id=1908%3A9407
    var circleProps = {
        cx: 10,
        cy: 10,
        r: active ? 10 : 9.25,
        fill: active ? 'currentColor' : 'none',
        stroke: active ? 'none' : 'currentColor',
        strokeWidth: active ? 0 : 1.5,
    };
    var completedClassName = clsx$1('denhaag-timeline__step-icon', 'denhaag-timeline__step-icon--completed');
    if (completed) {
        return React__default__default.createElement(CheckCircleIcon, { useDefaultClass: false, className: completedClassName });
    }
    var className = clsx$1('denhaag-timeline__step-icon', {
        'denhaag-timeline__step-icon--active': active,
        'denhaag-timeline__step-icon--disabled': disabled,
    });
    return (React__default__default.createElement(SvgIcon, { fill: 'currentColor', useDefaultClass: false, id: id, viewBox: "0 0 20 20", className: className },
        React__default__default.createElement("circle", __assign$1({}, circleProps)),
        React__default__default.createElement("text", { x: "10", y: "14", textAnchor: "middle", className: textClasses }, icon)));
};/**
 * Shows a label in a Step component within a Stepper component.
 * @param props The properties of a StepLabel component.
 * @constructor Constructs an instance of StepLabel.
 */
var StepLabel = function (_a) {
    var children = _a.children, icon = _a.icon, StepIconComponent = _a.StepIconComponent, StepIconProps = _a.StepIconProps, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.completed, completed = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.expanded, expanded = _e === void 0 ? false : _e, _f = _a.id, id = _f === void 0 ? undefined : _f, className = _a.className;
    var UpdatedStepIconComponent;
    if (StepIconComponent === undefined) {
        UpdatedStepIconComponent = (React__default__default.createElement(StepIcon, __assign$1({ active: active, completed: completed, disabled: disabled, icon: icon }, StepIconProps)));
    }
    else {
        UpdatedStepIconComponent = StepIconComponent;
        UpdatedStepIconComponent.props = __assign$1(__assign$1({}, StepIconComponent.props), StepIconProps);
    }
    var classes = clsx$1('denhaag-timeline__step-label', {
        'denhaag-timeline__step-label--active': active || expanded,
        'denhaag-timeline__step-label--disabled': disabled,
        'denhaag-timeline__step-label--completed': completed,
    }, className);
    return (React__default__default.createElement("div", { id: id, className: classes },
        UpdatedStepIconComponent,
        React__default__default.createElement("p", { className: "denhaag-timeline__step-label-text" }, children)));
};function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$1 = ".utrecht-heading-1{--utrecht-heading-1-color:var(--denhaag-heading-color);--utrecht-heading-1-line-height:var(--denhaag-heading-line-height);font-family:var(--utrecht-heading-1-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-1-font-size);font-weight:var(--utrecht-heading-1-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-1-margin-block-end);margin-block-start:var(--utrecht-heading-1-margin-block-start)}.utrecht-heading-1--distanced{--utrecht-heading-1-margin-block-start:var(--utrecht-heading-1-distanced-margin-block-start);--utrecht-heading-1-margin-block-end:var(--utrecht-heading-1-distanced-margin-block-end)}.utrecht-heading-1+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-1-font-size)/4)}[class^=denhaag-]+.utrecht-heading-1{--utrecht-heading-1-margin-block-start:calc(var(--utrecht-heading-1-font-size)*1.125)}.utrecht-heading-2{--utrecht-heading-2-line-height:var(--denhaag-heading-line-height);--utrecht-heading-2-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-2-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-2-font-size);font-weight:var(--utrecht-heading-2-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-2-margin-block-end);margin-block-start:var(--utrecht-heading-2-margin-block-start)}.utrecht-heading-2--distanced{--utrecht-heading-2-margin-block-start:var(--utrecht-heading-2-distanced-margin-block-start);--utrecht-heading-2-margin-block-end:var(--utrecht-heading-2-distanced-margin-block-end)}.utrecht-heading-2+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-2-font-size)/4)}[class^=denhaag-]+.utrecht-heading-2{--utrecht-heading-2-margin-block-start:calc(var(--utrecht-heading-2-font-size)*1.125)}.utrecht-heading-3{--utrecht-heading-3-line-height:var(--denhaag-heading-line-height);--utrecht-heading-3-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-3-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-3-font-size);font-weight:var(--utrecht-heading-3-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-3-margin-block-end);margin-block-start:var(--utrecht-heading-3-margin-block-start)}.utrecht-heading-3--distanced{--utrecht-heading-3-margin-block-start:var(--utrecht-heading-3-distanced-margin-block-start);--utrecht-heading-3-margin-block-end:var(--utrecht-heading-3-distanced-margin-block-end)}.utrecht-heading-3+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-3-font-size)/4)}[class^=denhaag-]+.utrecht-heading-3{--utrecht-heading-3-margin-block-start:calc(var(--utrecht-heading-3-font-size)*1.125)}.utrecht-heading-4{--utrecht-heading-4-line-height:var(--denhaag-heading-line-height);--utrecht-heading-4-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-4-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-4-font-size);font-weight:var(--utrecht-heading-4-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-4-margin-block-end);margin-block-start:var(--utrecht-heading-4-margin-block-start)}.utrecht-heading-4--distanced{--utrecht-heading-4-margin-block-start:var(--utrecht-heading-4-distanced-margin-block-start);--utrecht-heading-4-margin-block-end:var(--utrecht-heading-4-distanced-margin-block-end)}.utrecht-heading-4+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-4-font-size)/4)}[class^=denhaag-]+.utrecht-heading-4{--utrecht-heading-4-margin-block-start:calc(var(--utrecht-heading-4-font-size)*1.125)}.utrecht-heading-5{--utrecht-heading-5-line-height:var(--denhaag-heading-line-height);--utrecht-heading-5-color:var(--denhaag-heading-color);font-family:var(--utrecht-heading-5-font-family,var(--utrecht-heading-font-family,var(--utrecht-document-font-family)));font-size:var(--utrecht-heading-5-font-size);font-weight:var(--utrecht-heading-5-font-weight,var(--utrecht-heading-font-weight,bold));margin-block-end:var(--utrecht-heading-5-margin-block-end);margin-block-start:var(--utrecht-heading-5-margin-block-start)}.utrecht-heading-5--distanced{--utrecht-heading-5-margin-block-start:var(--utrecht-heading-5-distanced-margin-block-start);--utrecht-heading-5-margin-block-end:var(--utrecht-heading-5-distanced-margin-block-end)}.utrecht-heading-5+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:calc(var(--utrecht-heading-5-font-size)/4)}[class^=denhaag-]+.utrecht-heading-5{--utrecht-heading-5-margin-block-start:calc(var(--utrecht-heading-5-font-size)*1.125)}";
styleInject(css_248z$1);function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var Heading1 = function (props) {
    var rootClassNames = clsx('utrecht-heading-1', 'utrecht-heading-1--distanced', props.className);
    return React__default__default.createElement("h1", { className: rootClassNames }, props.children);
};var Heading2 = function (props) {
    var rootClassNames = clsx('utrecht-heading-2', 'utrecht-heading-2--distanced', props.className);
    return React__default__default.createElement("h2", { className: rootClassNames }, props.children);
};var Heading3 = function (props) {
    var rootClassNames = clsx('utrecht-heading-3', 'utrecht-heading-3--distanced', props.className);
    return React__default__default.createElement("h3", { className: rootClassNames }, props.children);
};var Heading4 = function (props) {
    var rootClassNames = clsx('utrecht-heading-4', 'utrecht-heading-4--distanced', props.className);
    return React__default__default.createElement("h4", { className: rootClassNames }, props.children);
};var Heading5 = function (props) {
    var rootClassNames = clsx('utrecht-heading-5', 'utrecht-heading-5--distanced', props.className);
    return React__default__default.createElement("h5", { className: rootClassNames }, props.children);
};var css_248z = ".utrecht-paragraph{color:var(--utrecht-paragraph-color,var(--utrecht-document-color,inherit));font-family:var(--utrecht-paragraph-font-family,var(--utrecht-document-font-family,inherit));font-size:var(--utrecht-paragraph-font-size,var(--utrecht-document-font-size,inherit));font-weight:var(--utrecht-paragraph-font-weight,inherit);line-height:var(--utrecht-paragraph-line-height,var(--utrecht-document-line-height,normal));margin-block-end:var(--utrecht-paragraph-margin-block-end);margin-block-start:var(--utrecht-paragraph-margin-block-start)}.utrecht-paragraph--lead{font-size:var(--utrecht-paragraph-lead-font-size,inherit);font-weight:var(--utrecht-paragraph-lead-font-weight,inherit);line-height:var(--utrecht-paragraph-lead-line-height,inherit)}.utrecht-paragraph--distanced{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-distanced-margin-block-start);--utrecht-paragraph-margin-block-end:var(--utrecht-paragraph-distanced-margin-block-end)}.denhaag-paragraph--detail{font-family:var(--denhaag-posttypelabel-font-family,inherit);font-size:var(--denhaag-posttypelabel-font-size,.75rem);letter-spacing:var(--denhaag-posttypelabel-letter-spacing,1px);line-height:var(--denhaag-posttypelabel-line-height,1.5);text-transform:var(--denhaag-posttypelabel-text-transform,uppercase)}.utrecht-paragraph+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-paragraph-margin-block-start,inherit)}.utrecht-paragraph--lead+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-lead-paragraph-margin-block-start,inherit)}.denhaag-list+.utrecht-paragraph,.denhaag-list__wrapper+.utrecht-paragraph,.denhaag-ordered-list+.utrecht-paragraph,.denhaag-unordered-list+.utrecht-paragraph{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-list-margin-block-start,inherit)}.denhaag-list+.utrecht-paragraph--lead,.denhaag-list__wrapper+.utrecht-paragraph--lead,.denhaag-ordered-list+.utrecht-paragraph--lead,.denhaag-unordered-list+.utrecht-paragraph--lead{--utrecht-paragraph-margin-block-start:var(--utrecht-paragraph-lead-list-margin-block-start,inherit)}";
styleInject(css_248z);var Paragraph = function (props) {
    var rootClassNames = clsx('utrecht-paragraph', 'utrecht-paragraph--distanced', props.className);
    return React__default__default.createElement("p", { className: rootClassNames },
        " ",
        props.children);
};var LeadParagraph = function (props) {
    var rootClassNames = clsx('utrecht-paragraph', 'utrecht-paragraph--lead', 'utrecht-paragraph--distanced', props.className);
    return React__default__default.createElement("p", { className: rootClassNames }, props.children);
};export{Alert,Avatar,BadgeCounter,Button,Card,Checkbox,Datepicker,Divider,FormControl,FormControlLabel,FormField,FormFieldDescription,FormFieldGroup,FormFieldGroupLabel,FormFieldInput,FormFieldLabel,FormGroup,FormProgress,Heading1,Heading2,Heading3,Heading4,Heading5,IconButton$1 as IconButton,InputLabel,LeadParagraph,Link,List,ListItem,ListSubheader,Menu,MenuButton,MenuButtonExpandable,Paragraph,PostTypeLabel,ProcessSteps,Radio,Select,Sidenav,SidenavItem,SidenavLink,SidenavList,StepContent,StepContext,StepExpandedIcon,StepHeader,StepHeading,StepHeadingLabel,StepIcon,StepLabel,StepList,StepMarker,StepSection,StylesProvider,SubStep,SubStepHeading,SubStepList,SubStepMarker,Switch,Tab,TabContext,TabList,TabPanel,TabScrollButton,Tabs,TextField,Timeline};